import {
  Unit_instanceat14thlj150z as Unit_instance,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  EmptyCoroutineContext_getInstance7yleecrz3jzr as EmptyCoroutineContext_getInstance,
  Key_instance3trehy4y6zgij as Key_instance,
  equals2au1ep9vhcato as equals,
  createCoroutineUninterceptedGeneratorVersion2gduom218i9ay as createCoroutineUninterceptedGeneratorVersion,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  intercepted2ogpsikxxj4u0 as intercepted,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  isInterface3d6p8outrmvmk as isInterface,
  toString30pk9tzaqopn as toString_0,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  hashCodeq5arwsb9dgti as hashCode,
  Result__exceptionOrNull_impl_p6xea93g9kuxe56cw2k as Result__exceptionOrNull_impl_p6xea9,
  _Result___get_value__impl__bjfvqgbxrwpgk5sesh as _Result___get_value__impl__bjfvqg,
  CancellationException3b36o9qz53rgr as CancellationException,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  AbstractCoroutineContextKey9xr9r6wlj5bm as AbstractCoroutineContextKey,
  AbstractCoroutineContextElement2rpehg0hv5szw as AbstractCoroutineContextElement,
  getxe4seun860fg as get,
  protoOf180f3jzyo7rfj as protoOf,
  minusKey2uxs00uz5ceqp as minusKey,
  ContinuationInterceptor2624y0vaqwxwf as ContinuationInterceptor,
  RuntimeException1r3t0zl97011n as RuntimeException,
  addSuppressedu5jwjfvsc039 as addSuppressed,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  Enum3alwj03lh1n41 as Enum,
  startCoroutine327fwvtqvedik as startCoroutine,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  Long2qws0ah9gnpki as Long,
  Duration__isPositive_impl_tvkkt23mvdjuzm9oa9z as Duration__isPositive_impl_tvkkt2,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  DurationUnit_NANOSECONDS_getInstance2sujg77gnqrxb as DurationUnit_NANOSECONDS_getInstance,
  toDurationba1nlt78o6vu as toDuration,
  Duration__plus_impl_yu9v8f24i74j9g7b01u as Duration__plus_impl_yu9v8f,
  _Duration___get_inWholeMilliseconds__impl__msfiryngn8rf3n78he as _Duration___get_inWholeMilliseconds__impl__msfiry,
  ArrayDeque2dzc9uld4xi7n as ArrayDeque,
  captureStack1fzi4aczwc4hg as captureStack,
  Error3ofk6owajcepa as Error_0,
  Element2gr7ezmxqaln7 as Element,
  StringBuildermazzzhj6kkai as StringBuilder,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  ArrayList3it5z8td81qkl as ArrayList,
  SequenceScope1coiso86pqzq2 as SequenceScope,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  sequence2vgswtrxvqoa7 as sequence,
  plusolev77jfy5r9 as plus,
  get6d5x931vk0s as get_0,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey_0,
  anyToString3ho3k49fc56mj as anyToString,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  toLongw1zpgk99d84b as toLong,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  listOf1jh22dvmctj1r as listOf,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  compareTo3ankvs086tmwq as compareTo,
  last2n4gf5az1lkn4 as last,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  getKClass1s3j9wy1cofik as getKClass,
  Exceptiondt2hlxn7j7vw as Exception,
  toLongOrNullutqivezb0wx1 as toLongOrNull,
  startCoroutineUninterceptedOrReturnGeneratorVersion1cv0wx9z0l0zn as startCoroutineUninterceptedOrReturnGeneratorVersion,
  plus20p0vtfmu0596 as plus_0,
  KtList3hktaavzmj137 as KtList,
  listOfvhqybd2zx248 as listOf_0,
  Unitkvevlwgzwiuc as Unit,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  removeFirstOrNull15yg2tczrh8a7 as removeFirstOrNull,
  KtMutableList1beimitadwkna as KtMutableList,
  coerceIn302bduskdb54x as coerceIn,
  boxApply1qmzdb3dh90hg as boxApply,
  HashSet2dzve9y63nf0v as HashSet,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
} from './kotlin-kotlin-stdlib.mjs';
import {
  atomic$int$11d5swdyn6j0pu as atomic$int$1,
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
  atomic$boolean$1iggki4z65a2h as atomic$boolean$1,
  atomicfu$AtomicRefArray$ofNulls2kz3j9ehigwa3 as atomicfu$AtomicRefArray$ofNulls,
  atomic$long$129k9zwo6n9ogd as atomic$long$1,
} from './kotlinx-atomicfu.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Job {}
function cancel$default(cause, $super) {
  cause = cause === VOID ? null : cause;
  var tmp;
  if ($super === VOID) {
    this.i18(cause);
    tmp = Unit_instance;
  } else {
    tmp = $super.i18.call(this, cause);
  }
  return tmp;
}
class ParentJob {}
class JobSupport {
  constructor(active) {
    this.v16_1 = atomic$ref$1(active ? get_EMPTY_ACTIVE() : get_EMPTY_NEW());
    this.w16_1 = atomic$ref$1(null);
  }
  r1() {
    return Key_instance_3;
  }
  t17(value) {
    this.w16_1.kotlinx$atomicfu$value = value;
  }
  u17() {
    return this.w16_1.kotlinx$atomicfu$value;
  }
  x16(parent) {
    // Inline function 'kotlinx.coroutines.assert' call
    if (parent == null) {
      this.t17(NonDisposableHandle_instance);
      return Unit_instance;
    }
    parent.x17();
    var handle = parent.r18(this);
    this.t17(handle);
    if (this.w17()) {
      handle.m1a();
      this.t17(NonDisposableHandle_instance);
    }
  }
  v17() {
    return this.v16_1.kotlinx$atomicfu$value;
  }
  c17() {
    var state = this.v17();
    var tmp;
    if (!(state == null) ? isInterface(state, Incomplete) : false) {
      tmp = state.c17();
    } else {
      tmp = false;
    }
    return tmp;
  }
  w17() {
    var tmp = this.v17();
    return !(!(tmp == null) ? isInterface(tmp, Incomplete) : false);
  }
  x17() {
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      // Inline function 'kotlinx.coroutines.JobSupport.start.<anonymous>' call
      var state = this.v17();
      var tmp52_subject = startInternal(this, state);
      if (tmp52_subject === 0)
        return false;
      else if (tmp52_subject === 1)
        return true;
    }
  }
  y17() {
  }
  z17() {
    var state = this.v17();
    var tmp;
    if (state instanceof Finishing) {
      var tmp54_safe_receiver = state.i1g();
      var tmp0_elvis_lhs = tmp54_safe_receiver == null ? null : this.a18(tmp54_safe_receiver, get_classSimpleName(this) + ' is cancelling');
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        var message = 'Job is still new or active: ' + this.toString();
        throw IllegalStateException.h5(toString(message));
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      if (!(state == null) ? isInterface(state, Incomplete) : false) {
        var message_0 = 'Job is still new or active: ' + this.toString();
        throw IllegalStateException.h5(toString(message_0));
      } else {
        if (state instanceof CompletedExceptionally) {
          tmp = this.b18(state.h17_1);
        } else {
          tmp = JobCancellationException.d1g(get_classSimpleName(this) + ' has completed normally', null, this);
        }
      }
    }
    return tmp;
  }
  a18(_this__u8e3s4, message) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof CancellationException ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      tmp = JobCancellationException.d1g(message == null ? this.f17() : message, _this__u8e3s4, this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  b18(_this__u8e3s4, message, $super) {
    message = message === VOID ? null : message;
    return $super === VOID ? this.a18(_this__u8e3s4, message) : $super.a18.call(this, _this__u8e3s4, message);
  }
  c18(handler) {
    return this.e18(true, new InvokeOnCompletion(handler));
  }
  d18(onCancelling, invokeImmediately, handler) {
    var tmp;
    if (onCancelling) {
      tmp = new InvokeOnCancelling(handler);
    } else {
      tmp = new InvokeOnCompletion(handler);
    }
    return this.e18(invokeImmediately, tmp);
  }
  e18(invokeImmediately, node) {
    node.a1d_1 = this;
    var tmp$ret$0;
    $l$block_1: {
      // Inline function 'kotlinx.coroutines.JobSupport.tryPutNodeIntoList' call
      // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
      while (true) {
        // Inline function 'kotlinx.coroutines.JobSupport.tryPutNodeIntoList.<anonymous>' call
        var state = this.v17();
        if (state instanceof Empty) {
          if (state.f1f_1) {
            if (this.v16_1.atomicfu$compareAndSet(state, node)) {
              tmp$ret$0 = true;
              break $l$block_1;
            }
          } else {
            promoteEmptyToNodeList(this, state);
          }
        } else {
          if (!(state == null) ? isInterface(state, Incomplete) : false) {
            var list = state.c1d();
            if (list == null) {
              promoteSingleToNodeList(this, state instanceof JobNode ? state : THROW_CCE());
            } else {
              // Inline function 'kotlinx.coroutines.JobSupport.invokeOnCompletionInternal.<anonymous>' call
              var tmp;
              if (node.w1c()) {
                var tmp55_safe_receiver = state instanceof Finishing ? state : null;
                var rootCause = tmp55_safe_receiver == null ? null : tmp55_safe_receiver.i1g();
                var tmp_0;
                if (rootCause == null) {
                  tmp_0 = list.g1d(node, 5);
                } else {
                  if (invokeImmediately) {
                    node.l1a(rootCause);
                  }
                  return NonDisposableHandle_instance;
                }
                tmp = tmp_0;
              } else {
                tmp = list.g1d(node, 1);
              }
              if (tmp) {
                tmp$ret$0 = true;
                break $l$block_1;
              }
            }
          } else {
            tmp$ret$0 = false;
            break $l$block_1;
          }
        }
      }
    }
    var added = tmp$ret$0;
    if (added)
      return node;
    else if (invokeImmediately) {
      var tmp_1 = this.v17();
      var tmp56_safe_receiver = tmp_1 instanceof CompletedExceptionally ? tmp_1 : null;
      node.l1a(tmp56_safe_receiver == null ? null : tmp56_safe_receiver.h17_1);
    }
    return NonDisposableHandle_instance;
  }
  f18($completion) {
    if (!joinInternal(this)) {
      // Inline function 'kotlin.js.getCoroutineContext' call
      var tmp$ret$0 = $completion.zc();
      ensureActive(tmp$ret$0);
      return Unit_instance;
    }
    return joinSuspend(this, $completion);
  }
  g18(node) {
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      // Inline function 'kotlinx.coroutines.JobSupport.removeNode.<anonymous>' call
      var state = this.v17();
      if (state instanceof JobNode) {
        if (!(state === node))
          return Unit_instance;
        if (this.v16_1.atomicfu$compareAndSet(state, get_EMPTY_ACTIVE()))
          return Unit_instance;
      } else {
        if (!(state == null) ? isInterface(state, Incomplete) : false) {
          if (!(state.c1d() == null)) {
            node.h1d();
          }
          return Unit_instance;
        } else {
          return Unit_instance;
        }
      }
    }
  }
  h18() {
    return false;
  }
  i18(cause) {
    var tmp;
    if (cause == null) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      tmp = JobCancellationException.d1g(null == null ? this.f17() : null, null, this);
    } else {
      tmp = cause;
    }
    this.k18(tmp);
  }
  f17() {
    return 'Job was cancelled';
  }
  k18(cause) {
    this.o18(cause);
  }
  l18(parentJob) {
    this.o18(parentJob);
  }
  m18(cause) {
    if (cause instanceof CancellationException)
      return true;
    return this.o18(cause) && this.u18();
  }
  n18(cause) {
    return this.o18(cause);
  }
  o18(cause) {
    var finalState = get_COMPLETING_ALREADY();
    if (this.h18()) {
      finalState = cancelMakeCompleting(this, cause);
      if (finalState === get_COMPLETING_WAITING_CHILDREN())
        return true;
    }
    if (finalState === get_COMPLETING_ALREADY()) {
      finalState = makeCancelling(this, cause);
    }
    var tmp;
    if (finalState === get_COMPLETING_ALREADY()) {
      tmp = true;
    } else if (finalState === get_COMPLETING_WAITING_CHILDREN()) {
      tmp = true;
    } else if (finalState === get_TOO_LATE_TO_CANCEL()) {
      tmp = false;
    } else {
      this.m17(finalState);
      tmp = true;
    }
    return tmp;
  }
  p18() {
    var state = this.v17();
    var tmp;
    if (state instanceof Finishing) {
      tmp = state.i1g();
    } else {
      if (state instanceof CompletedExceptionally) {
        tmp = state.h17_1;
      } else {
        if (!(state == null) ? isInterface(state, Incomplete) : false) {
          var message = 'Cannot be cancelling child in this state: ' + toString(state);
          throw IllegalStateException.h5(toString(message));
        } else {
          tmp = null;
        }
      }
    }
    var rootCause = tmp;
    var tmp0_elvis_lhs = rootCause instanceof CancellationException ? rootCause : null;
    return tmp0_elvis_lhs == null ? JobCancellationException.d1g('Parent job is ' + stateString(this, state), rootCause, this) : tmp0_elvis_lhs;
  }
  n1d(proposedUpdate) {
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      $l$block: {
        // Inline function 'kotlinx.coroutines.JobSupport.makeCompleting.<anonymous>' call
        var state = this.v17();
        var finalState = tryMakeCompleting(this, state, proposedUpdate);
        if (finalState === get_COMPLETING_ALREADY())
          return false;
        else if (finalState === get_COMPLETING_WAITING_CHILDREN())
          return true;
        else if (finalState === get_COMPLETING_RETRY()) {
          break $l$block;
        } else {
          this.m17(finalState);
          return true;
        }
      }
    }
  }
  k17(proposedUpdate) {
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      $l$block: {
        // Inline function 'kotlinx.coroutines.JobSupport.makeCompletingOnce.<anonymous>' call
        var state = this.v17();
        var finalState = tryMakeCompleting(this, state, proposedUpdate);
        if (finalState === get_COMPLETING_ALREADY())
          throw IllegalStateException.wd('Job ' + this.toString() + ' is already complete or completing, ' + ('but is being completed with ' + toString_0(proposedUpdate)), _get_exceptionOrNull__b3j7js(proposedUpdate, this));
        else if (finalState === get_COMPLETING_RETRY()) {
          break $l$block;
        } else
          return finalState;
      }
    }
  }
  q18() {
    return sequence(JobSupport$_get_children_$slambda_k839f8_0(this));
  }
  r18(child) {
    // Inline function 'kotlin.also' call
    var this_0 = new ChildHandleNode(child);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.JobSupport.attachChild.<anonymous>' call
    this_0.a1d_1 = this;
    var node = this_0;
    var tmp$ret$1;
    $l$block_1: {
      // Inline function 'kotlinx.coroutines.JobSupport.tryPutNodeIntoList' call
      // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
      while (true) {
        // Inline function 'kotlinx.coroutines.JobSupport.tryPutNodeIntoList.<anonymous>' call
        var state = this.v17();
        if (state instanceof Empty) {
          if (state.f1f_1) {
            if (this.v16_1.atomicfu$compareAndSet(state, node)) {
              tmp$ret$1 = true;
              break $l$block_1;
            }
          } else {
            promoteEmptyToNodeList(this, state);
          }
        } else {
          if (!(state == null) ? isInterface(state, Incomplete) : false) {
            var list = state.c1d();
            if (list == null) {
              promoteSingleToNodeList(this, state instanceof JobNode ? state : THROW_CCE());
            } else {
              // Inline function 'kotlinx.coroutines.JobSupport.attachChild.<anonymous>' call
              var addedBeforeCancellation = list.g1d(node, 7);
              var tmp;
              if (addedBeforeCancellation) {
                tmp = true;
              } else {
                var addedBeforeCompletion = list.g1d(node, 3);
                var latestState = this.v17();
                var tmp_0;
                if (latestState instanceof Finishing) {
                  tmp_0 = latestState.i1g();
                } else {
                  // Inline function 'kotlinx.coroutines.assert' call
                  var tmp69_safe_receiver = latestState instanceof CompletedExceptionally ? latestState : null;
                  tmp_0 = tmp69_safe_receiver == null ? null : tmp69_safe_receiver.h17_1;
                }
                var rootCause = tmp_0;
                node.l1a(rootCause);
                var tmp_1;
                if (addedBeforeCompletion) {
                  // Inline function 'kotlinx.coroutines.assert' call
                  tmp_1 = true;
                } else {
                  return NonDisposableHandle_instance;
                }
                tmp = tmp_1;
              }
              if (tmp) {
                tmp$ret$1 = true;
                break $l$block_1;
              }
            }
          } else {
            tmp$ret$1 = false;
            break $l$block_1;
          }
        }
      }
    }
    var added = tmp$ret$1;
    if (added)
      return node;
    var tmp_2 = this.v17();
    var tmp70_safe_receiver = tmp_2 instanceof CompletedExceptionally ? tmp_2 : null;
    node.l1a(tmp70_safe_receiver == null ? null : tmp70_safe_receiver.h17_1);
    return NonDisposableHandle_instance;
  }
  n17(exception) {
    throw exception;
  }
  s18(cause) {
  }
  t18() {
    return false;
  }
  u18() {
    return true;
  }
  v18(exception) {
    return false;
  }
  g17(state) {
  }
  m17(state) {
  }
  toString() {
    return this.w18() + '@' + get_hexAddress(this);
  }
  w18() {
    return this.o17() + '{' + stateString(this, this.v17()) + '}';
  }
  o17() {
    return get_classSimpleName(this);
  }
  x18($completion) {
    $l$loop: while (true) {
      var state = this.v17();
      if (!(!(state == null) ? isInterface(state, Incomplete) : false)) {
        if (state instanceof CompletedExceptionally) {
          // Inline function 'kotlinx.coroutines.internal.recoverAndThrow' call
          throw state.h17_1;
        }
        return unboxState(state);
      }
      if (startInternal(this, state) >= 0)
        break $l$loop;
    }
    return awaitSuspend(this, $completion);
  }
}
class CoroutineScope {}
class AbstractCoroutine extends JobSupport {
  constructor(parentContext, initParentJob, active) {
    super(active);
    if (initParentJob) {
      this.x16(parentContext.md(Key_instance_3));
    }
    this.a17_1 = parentContext.cn(this);
  }
  zc() {
    return this.a17_1;
  }
  b17() {
    return this.a17_1;
  }
  c17() {
    return super.c17();
  }
  d17(value) {
  }
  e17(cause, handled) {
  }
  f17() {
    return get_classSimpleName(this) + ' was cancelled';
  }
  g17(state) {
    if (state instanceof CompletedExceptionally) {
      this.e17(state.h17_1, state.j17());
    } else {
      this.d17((state == null ? true : !(state == null)) ? state : THROW_CCE());
    }
  }
  bd(result) {
    var state = this.k17(toState_0(result));
    if (state === get_COMPLETING_WAITING_CHILDREN())
      return Unit_instance;
    this.l17(state);
  }
  l17(state) {
    return this.m17(state);
  }
  n17(exception) {
    handleCoroutineException(this.a17_1, exception);
  }
  o17() {
    var tmp0_elvis_lhs = get_coroutineName(this.a17_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return super.o17();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var coroutineName = tmp;
    return '"' + coroutineName + '":' + super.o17();
  }
  p17(start, receiver, block) {
    start.s17(block, receiver, this);
  }
}
class StandaloneCoroutine extends AbstractCoroutine {
  constructor(parentContext, active) {
    super(parentContext, true, active);
  }
  v18(exception) {
    handleCoroutineException(this.a17_1, exception);
    return true;
  }
}
class LazyStandaloneCoroutine extends StandaloneCoroutine {
  constructor(parentContext, block) {
    super(parentContext, false);
    this.l19_1 = createCoroutineUninterceptedGeneratorVersion(block, this, this);
  }
  y17() {
    startCoroutineCancellable_0(this.l19_1, this);
  }
}
class ScopeCoroutine extends AbstractCoroutine {
  constructor(context, uCont) {
    super(context, true, true);
    this.p19_1 = uCont;
  }
  t18() {
    return true;
  }
  m17(state) {
    resumeCancellableWith(intercepted(this.p19_1), recoverResult(state, this.p19_1));
  }
  l17(state) {
    this.p19_1.bd(recoverResult(state, this.p19_1));
  }
}
class DispatchedCoroutine extends ScopeCoroutine {
  constructor(context, uCont) {
    super(context, uCont);
    this.d19_1 = atomic$int$1(0);
  }
  m17(state) {
    this.l17(state);
  }
  l17(state) {
    if (tryResume(this))
      return Unit_instance;
    resumeCancellableWith(intercepted(this.p19_1), recoverResult(state, this.p19_1));
  }
  e19() {
    if (trySuspend(this))
      return get_COROUTINE_SUSPENDED();
    var state = unboxState(this.v17());
    if (state instanceof CompletedExceptionally)
      throw state.h17_1;
    return (state == null ? true : !(state == null)) ? state : THROW_CCE();
  }
}
class Deferred {}
class DeferredCoroutine extends AbstractCoroutine {
  constructor(parentContext, active) {
    super(parentContext, true, active);
  }
  t19($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_await__mos7q6.bind(VOID, this), $completion);
  }
}
class LazyDeferredCoroutine extends DeferredCoroutine {
  constructor(parentContext, block) {
    super(parentContext, false);
    this.x19_1 = createCoroutineUninterceptedGeneratorVersion(block, this, this);
  }
  y17() {
    startCoroutineCancellable_0(this.x19_1, this);
  }
}
class CancellableContinuation {}
class NotCompleted {}
class CancelHandler {}
class DisposeOnCancel {
  constructor(handle) {
    this.k1a_1 = handle;
  }
  l1a(cause) {
    return this.k1a_1.m1a();
  }
  toString() {
    return 'DisposeOnCancel[' + toString(this.k1a_1) + ']';
  }
}
class Runnable {}
class SchedulerTask {}
class DispatchedTask extends SchedulerTask {
  constructor(resumeMode) {
    super();
    this.w1a_1 = resumeMode;
  }
  u1b(takenState, cause) {
  }
  b1c(state) {
    return (state == null ? true : !(state == null)) ? state : THROW_CCE();
  }
  l1c(state) {
    var tmp151_safe_receiver = state instanceof CompletedExceptionally ? state : null;
    return tmp151_safe_receiver == null ? null : tmp151_safe_receiver.h17_1;
  }
  n1c() {
    // Inline function 'kotlinx.coroutines.assert' call
    var fatalException = null;
    try {
      var tmp = this.r1b();
      var delegate = tmp instanceof DispatchedContinuation ? tmp : THROW_CCE();
      var continuation = delegate.p1a_1;
      // Inline function 'kotlinx.coroutines.withContinuationContext' call
      delegate.r1a_1;
      var context = continuation.zc();
      var state = this.t1b();
      var exception = this.l1c(state);
      var job = exception == null && get_isCancellableMode(this.w1a_1) ? context.md(Key_instance_3) : null;
      if (!(job == null) && !job.c17()) {
        var cause = job.z17();
        this.u1b(state, cause);
        // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
        // Inline function 'kotlin.Companion.failure' call
        var exception_0 = recoverStackTrace(cause, continuation);
        var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception_0));
        continuation.bd(tmp$ret$0);
      } else {
        if (!(exception == null)) {
          // Inline function 'kotlin.coroutines.resumeWithException' call
          // Inline function 'kotlin.Companion.failure' call
          var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception));
          continuation.bd(tmp$ret$1);
        } else {
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var value = this.b1c(state);
          var tmp$ret$3 = _Result___init__impl__xyqfz8(value);
          continuation.bd(tmp$ret$3);
        }
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        fatalException = e;
      } else {
        throw $p;
      }
    }
    finally {
      var tmp152_safe_receiver = fatalException;
      if (tmp152_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        this.o1c(tmp152_safe_receiver);
      }
    }
  }
  o1c(exception) {
    var reason = CoroutinesInternalError.z1e('Fatal exception in coroutines machinery for ' + toString(this) + '. ' + "Please read KDoc to 'handleFatalException' method and report this incident to maintainers", exception);
    handleCoroutineException(this.r1b().zc(), reason);
  }
}
class Waiter {}
class CancellableContinuationImpl extends DispatchedTask {
  constructor(delegate, resumeMode) {
    super(resumeMode);
    this.e1a_1 = delegate;
    // Inline function 'kotlinx.coroutines.assert' call
    this.f1a_1 = this.e1a_1.zc();
    var tmp = this;
    // Inline function 'kotlinx.coroutines.decisionAndIndex' call
    var tmp$ret$0 = (0 << 29) + 536870911 | 0;
    tmp.g1a_1 = atomic$int$1(tmp$ret$0);
    this.h1a_1 = atomic$ref$1(Active_instance);
    this.i1a_1 = atomic$ref$1(null);
  }
  r1b() {
    return this.e1a_1;
  }
  zc() {
    return this.f1a_1;
  }
  v17() {
    return this.h1a_1.kotlinx$atomicfu$value;
  }
  w17() {
    var tmp = this.v17();
    return !(!(tmp == null) ? isInterface(tmp, NotCompleted) : false);
  }
  s1b() {
    var tmp0_elvis_lhs = installParentHandle(this);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var handle = tmp;
    if (this.w17()) {
      handle.m1a();
      this.i1a_1.kotlinx$atomicfu$value = NonDisposableHandle_instance;
    }
  }
  u1a() {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    var state = this.h1a_1.kotlinx$atomicfu$value;
    // Inline function 'kotlinx.coroutines.assert' call
    var tmp;
    if (state instanceof CompletedContinuation) {
      tmp = !(state.k1b_1 == null);
    } else {
      tmp = false;
    }
    if (tmp) {
      this.q1b();
      return false;
    }
    var tmp_0 = this.g1a_1;
    // Inline function 'kotlinx.coroutines.decisionAndIndex' call
    tmp_0.kotlinx$atomicfu$value = (0 << 29) + 536870911 | 0;
    this.h1a_1.kotlinx$atomicfu$value = Active_instance;
    return true;
  }
  t1b() {
    return this.v17();
  }
  u1b(takenState, cause) {
    var this_0 = this.h1a_1;
    while (true) {
      // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.cancelCompletedResult.<anonymous>' call
      var state = this_0.kotlinx$atomicfu$value;
      if (!(state == null) ? isInterface(state, NotCompleted) : false) {
        // Inline function 'kotlin.error' call
        var message = 'Not completed';
        throw IllegalStateException.h5(toString(message));
      } else {
        if (state instanceof CompletedExceptionally)
          return Unit_instance;
        else {
          if (state instanceof CompletedContinuation) {
            // Inline function 'kotlin.check' call
            // Inline function 'kotlin.contracts.contract' call
            if (!!state.n1b()) {
              // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.cancelCompletedResult.<anonymous>.<anonymous>' call
              var message_0 = 'Must be called at most once';
              throw IllegalStateException.h5(toString(message_0));
            }
            var update = state.o1b(VOID, VOID, VOID, VOID, cause);
            if (this.h1a_1.atomicfu$compareAndSet(state, update)) {
              state.v1b(this, cause);
              return Unit_instance;
            }
          } else {
            if (this.h1a_1.atomicfu$compareAndSet(state, new CompletedContinuation(state, VOID, VOID, VOID, cause))) {
              return Unit_instance;
            }
          }
        }
      }
    }
    return Unit_instance;
  }
  w1b(cause) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.h1a_1;
    while (true) {
      $l$block: {
        // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.cancel.<anonymous>' call
        var state = this_0.kotlinx$atomicfu$value;
        if (!(!(state == null) ? isInterface(state, NotCompleted) : false))
          return false;
        var tmp;
        if (isInterface(state, CancelHandler)) {
          tmp = true;
        } else {
          tmp = state instanceof Segment;
        }
        var update = new CancelledContinuation(this, cause, tmp);
        if (!this.h1a_1.atomicfu$compareAndSet(state, update)) {
          break $l$block;
        }
        if (isInterface(state, CancelHandler)) {
          this.m1b(state, cause);
        } else {
          if (state instanceof Segment) {
            callSegmentOnCancellation(this, state, cause);
          }
        }
        detachChildIfNonResuable(this);
        dispatchResume(this, this.w1a_1);
        return true;
      }
    }
  }
  x1b(cause) {
    if (cancelLater(this, cause))
      return Unit_instance;
    this.w1b(cause);
    detachChildIfNonResuable(this);
  }
  m1b(handler, cause) {
    var tmp;
    try {
      handler.l1a(cause);
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var ex = $p;
        handleCoroutineException(this.zc(), CompletionHandlerException.g1b('Exception in invokeOnCancellation handler for ' + this.toString(), ex));
        tmp_0 = Unit_instance;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  y1b(onCancellation, cause, value) {
    try {
      onCancellation(cause, value, this.zc());
    } catch ($p) {
      if ($p instanceof Error) {
        var ex = $p;
        handleCoroutineException(this.zc(), CompletionHandlerException.g1b('Exception in resume onCancellation handler for ' + this.toString(), ex));
      } else {
        throw $p;
      }
    }
  }
  z1b(parent) {
    return parent.z17();
  }
  e19() {
    var isReusable_0 = isReusable(this);
    if (trySuspend_0(this)) {
      if (_get_parentHandle__f8dcex(this) == null) {
        installParentHandle(this);
      }
      if (isReusable_0) {
        this.a1c();
      }
      return get_COROUTINE_SUSPENDED();
    }
    if (isReusable_0) {
      this.a1c();
    }
    var state = this.v17();
    if (state instanceof CompletedExceptionally)
      throw recoverStackTrace(state.h17_1, this);
    if (get_isCancellableMode(this.w1a_1)) {
      var job = this.zc().md(Key_instance_3);
      if (!(job == null) && !job.c17()) {
        var cause = job.z17();
        this.u1b(state, cause);
        throw recoverStackTrace(cause, this);
      }
    }
    return this.b1c(state);
  }
  a1c() {
    var tmp = this.e1a_1;
    var tmp10_safe_receiver = tmp instanceof DispatchedContinuation ? tmp : null;
    var tmp0_elvis_lhs = tmp10_safe_receiver == null ? null : tmp10_safe_receiver.c1c(this);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var cancellationCause = tmp_0;
    this.q1b();
    this.w1b(cancellationCause);
  }
  bd(result) {
    return this.d1c(toState(result, this), this.w1a_1);
  }
  e1c(value, onCancellation) {
    var tmp = this.w1a_1;
    var tmp_0;
    if (onCancellation == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.resume.<anonymous>' call
      tmp_0 = CancellableContinuationImpl$resume$lambda(onCancellation);
    }
    return this.f1c(value, tmp, tmp_0);
  }
  c1a(value, onCancellation) {
    return this.f1c(value, this.w1a_1, onCancellation);
  }
  g1c(segment, index) {
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      var this_0 = this.g1a_1;
      while (true) {
        var cur = this_0.kotlinx$atomicfu$value;
        // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.invokeOnCancellation.<anonymous>' call
        // Inline function 'kotlin.check' call
        // Inline function 'kotlinx.coroutines.index' call
        // Inline function 'kotlin.contracts.contract' call
        if (!((cur & 536870911) === 536870911)) {
          // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.invokeOnCancellation.<anonymous>.<anonymous>' call
          var message = 'invokeOnCancellation should be called at most once';
          throw IllegalStateException.h5(toString(message));
        }
        // Inline function 'kotlinx.coroutines.decisionAndIndex' call
        // Inline function 'kotlinx.coroutines.decision' call
        var upd = (cur >> 29 << 29) + index | 0;
        if (this_0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    invokeOnCancellationImpl(this, segment);
  }
  a1a(handler) {
    return invokeOnCancellation(this, new UserSupplied(handler));
  }
  j1a(handler) {
    return invokeOnCancellationImpl(this, handler);
  }
  f1c(proposedUpdate, resumeMode, onCancellation) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.h1a_1;
    while (true) {
      $l$block: {
        // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.resumeImpl.<anonymous>' call
        var state = this_0.kotlinx$atomicfu$value;
        if (!(state == null) ? isInterface(state, NotCompleted) : false) {
          var update = resumedState(this, state, proposedUpdate, resumeMode, onCancellation, null);
          if (!this.h1a_1.atomicfu$compareAndSet(state, update)) {
            break $l$block;
          }
          detachChildIfNonResuable(this);
          dispatchResume(this, resumeMode);
          return Unit_instance;
        } else {
          if (state instanceof CancelledContinuation) {
            if (state.k1c()) {
              if (onCancellation == null)
                null;
              else {
                // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                this.y1b(onCancellation, state.h17_1, proposedUpdate);
              }
              return Unit_instance;
            }
          }
        }
        alreadyResumedError(this, proposedUpdate);
      }
    }
  }
  d1c(proposedUpdate, resumeMode, onCancellation, $super) {
    onCancellation = onCancellation === VOID ? null : onCancellation;
    var tmp;
    if ($super === VOID) {
      this.f1c(proposedUpdate, resumeMode, onCancellation);
      tmp = Unit_instance;
    } else {
      tmp = $super.f1c.call(this, proposedUpdate, resumeMode, onCancellation);
    }
    return tmp;
  }
  q1b() {
    var tmp0_elvis_lhs = _get_parentHandle__f8dcex(this);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var handle = tmp;
    handle.m1a();
    this.i1a_1.kotlinx$atomicfu$value = NonDisposableHandle_instance;
  }
  y19(value, idempotent, onCancellation) {
    return tryResumeImpl(this, value, idempotent, onCancellation);
  }
  z19(token) {
    // Inline function 'kotlinx.coroutines.assert' call
    dispatchResume(this, this.w1a_1);
  }
  b1a(_this__u8e3s4, value) {
    var tmp = this.e1a_1;
    var dc = tmp instanceof DispatchedContinuation ? tmp : null;
    var tmp_0;
    if ((dc == null ? null : dc.o1a_1) === _this__u8e3s4) {
      tmp_0 = 4;
    } else {
      tmp_0 = this.w1a_1;
    }
    this.d1c(value, tmp_0);
  }
  b1c(state) {
    var tmp;
    if (state instanceof CompletedContinuation) {
      var tmp_0 = state.h1b_1;
      tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    } else {
      tmp = (state == null ? true : !(state == null)) ? state : THROW_CCE();
    }
    return tmp;
  }
  l1c(state) {
    var tmp20_safe_receiver = super.l1c(state);
    var tmp;
    if (tmp20_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.getExceptionalResult.<anonymous>' call
      tmp = recoverStackTrace(tmp20_safe_receiver, this.e1a_1);
    }
    return tmp;
  }
  toString() {
    return this.m1c() + '(' + toDebugString(this.e1a_1) + '){' + _get_stateDebugRepresentation__bf18u4(this) + '}@' + get_hexAddress(this);
  }
  m1c() {
    return 'CancellableContinuation';
  }
}
class UserSupplied {
  constructor(handler) {
    this.p1c_1 = handler;
  }
  l1a(cause) {
    this.p1c_1(cause);
  }
  toString() {
    return 'CancelHandler.UserSupplied[' + get_classSimpleName(this.p1c_1) + '@' + get_hexAddress(this) + ']';
  }
}
class Active {
  toString() {
    return 'Active';
  }
}
class CompletedContinuation {
  constructor(result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
    cancelHandler = cancelHandler === VOID ? null : cancelHandler;
    onCancellation = onCancellation === VOID ? null : onCancellation;
    idempotentResume = idempotentResume === VOID ? null : idempotentResume;
    cancelCause = cancelCause === VOID ? null : cancelCause;
    this.h1b_1 = result;
    this.i1b_1 = cancelHandler;
    this.j1b_1 = onCancellation;
    this.k1b_1 = idempotentResume;
    this.l1b_1 = cancelCause;
  }
  n1b() {
    return !(this.l1b_1 == null);
  }
  v1b(cont, cause) {
    var tmp21_safe_receiver = this.i1b_1;
    if (tmp21_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      cont.m1b(tmp21_safe_receiver, cause);
    }
    var tmp22_safe_receiver = this.j1b_1;
    if (tmp22_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      cont.y1b(tmp22_safe_receiver, cause, this.h1b_1);
    }
  }
  q1c(result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
    return new CompletedContinuation(result, cancelHandler, onCancellation, idempotentResume, cancelCause);
  }
  o1b(result, cancelHandler, onCancellation, idempotentResume, cancelCause, $super) {
    result = result === VOID ? this.h1b_1 : result;
    cancelHandler = cancelHandler === VOID ? this.i1b_1 : cancelHandler;
    onCancellation = onCancellation === VOID ? this.j1b_1 : onCancellation;
    idempotentResume = idempotentResume === VOID ? this.k1b_1 : idempotentResume;
    cancelCause = cancelCause === VOID ? this.l1b_1 : cancelCause;
    return $super === VOID ? this.q1c(result, cancelHandler, onCancellation, idempotentResume, cancelCause) : $super.q1c.call(this, result, cancelHandler, onCancellation, idempotentResume, cancelCause);
  }
  toString() {
    return 'CompletedContinuation(result=' + toString_0(this.h1b_1) + ', cancelHandler=' + toString_0(this.i1b_1) + ', onCancellation=' + toString_0(this.j1b_1) + ', idempotentResume=' + toString_0(this.k1b_1) + ', cancelCause=' + toString_0(this.l1b_1) + ')';
  }
  hashCode() {
    var result = this.h1b_1 == null ? 0 : hashCode(this.h1b_1);
    result = imul(result, 31) + (this.i1b_1 == null ? 0 : hashCode(this.i1b_1)) | 0;
    result = imul(result, 31) + (this.j1b_1 == null ? 0 : hashCode(this.j1b_1)) | 0;
    result = imul(result, 31) + (this.k1b_1 == null ? 0 : hashCode(this.k1b_1)) | 0;
    result = imul(result, 31) + (this.l1b_1 == null ? 0 : hashCode(this.l1b_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletedContinuation))
      return false;
    var tmp0_other_with_cast = other instanceof CompletedContinuation ? other : THROW_CCE();
    if (!equals(this.h1b_1, tmp0_other_with_cast.h1b_1))
      return false;
    if (!equals(this.i1b_1, tmp0_other_with_cast.i1b_1))
      return false;
    if (!equals(this.j1b_1, tmp0_other_with_cast.j1b_1))
      return false;
    if (!equals(this.k1b_1, tmp0_other_with_cast.k1b_1))
      return false;
    if (!equals(this.l1b_1, tmp0_other_with_cast.l1b_1))
      return false;
    return true;
  }
}
class LockFreeLinkedListNode {
  constructor() {
    this.d1d_1 = this;
    this.e1d_1 = this;
    this.f1d_1 = false;
  }
  g1d(node, permissionsBitmask) {
    var prev = this.e1d_1;
    var tmp;
    if (prev instanceof ListClosed) {
      tmp = ((prev.m1r_1 & permissionsBitmask) === 0 && prev.g1d(node, permissionsBitmask));
    } else {
      node.d1d_1 = this;
      node.e1d_1 = prev;
      prev.d1d_1 = node;
      this.e1d_1 = node;
      tmp = true;
    }
    return tmp;
  }
  k1f(forbiddenElementsBit) {
    this.g1d(new ListClosed(forbiddenElementsBit), forbiddenElementsBit);
  }
  h1d() {
    if (this.f1d_1)
      return false;
    var prev = this.e1d_1;
    var next = this.d1d_1;
    prev.d1d_1 = next;
    next.e1d_1 = prev;
    this.f1d_1 = true;
    return true;
  }
  i1d(node) {
    if (!(this.d1d_1 === this))
      return false;
    this.g1d(node, -2147483648);
    return true;
  }
}
class DisposableHandle {}
class Incomplete {}
class JobNode extends LockFreeLinkedListNode {
  b1d() {
    var tmp = this.a1d_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('job');
    }
  }
  c17() {
    return true;
  }
  c1d() {
    return null;
  }
  m1a() {
    return this.b1d().g18(this);
  }
  toString() {
    return get_classSimpleName(this) + '@' + get_hexAddress(this) + '[job@' + get_hexAddress(this.b1d()) + ']';
  }
}
class ChildContinuation extends JobNode {
  constructor(child) {
    super();
    this.v1c_1 = child;
  }
  w1c() {
    return true;
  }
  l1a(cause) {
    this.v1c_1.x1b(this.v1c_1.z1b(this.b1d()));
  }
}
class CompletableDeferredImpl extends JobSupport {
  constructor(parent) {
    super(true);
    this.x16(parent);
  }
  h18() {
    return true;
  }
  t19($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_await__mos7q6_0.bind(VOID, this), $completion);
  }
  k1d(value) {
    return this.n1d(value);
  }
  j1d(exception) {
    return this.n1d(new CompletedExceptionally(exception));
  }
}
class CompletedExceptionally {
  constructor(cause, handled) {
    handled = handled === VOID ? false : handled;
    this.h17_1 = cause;
    this.i17_1 = atomic$boolean$1(handled);
  }
  j17() {
    return this.i17_1.kotlinx$atomicfu$value;
  }
  p1b() {
    return this.i17_1.atomicfu$compareAndSet(false, true);
  }
  toString() {
    return get_classSimpleName(this) + '[' + this.h17_1.toString() + ']';
  }
}
class CancelledContinuation extends CompletedExceptionally {
  constructor(continuation, cause, handled) {
    super(cause == null ? CancellationException.ud('Continuation ' + toString(continuation) + ' was cancelled normally') : cause, handled);
    this.j1c_1 = atomic$boolean$1(false);
  }
  k1c() {
    return this.j1c_1.atomicfu$compareAndSet(false, true);
  }
}
class Key extends AbstractCoroutineContextKey {
  constructor() {
    Key_instance_0 = null;
    var tmp = Key_instance;
    super(tmp, CoroutineDispatcher$Key$_init_$lambda_akl8b5);
    Key_instance_0 = this;
  }
}
class CoroutineDispatcher extends AbstractCoroutineContextElement {
  static p1d() {
    Key_getInstance();
    return this.hn(Key_instance);
  }
  q1d(context) {
    return true;
  }
  s1d(context, block) {
    return this.r1d(context, block);
  }
  nd(continuation) {
    return new DispatchedContinuation(this, continuation);
  }
  od(continuation) {
    var dispatched = continuation instanceof DispatchedContinuation ? continuation : THROW_CCE();
    dispatched.t1d();
  }
  toString() {
    return get_classSimpleName(this) + '@' + get_hexAddress(this);
  }
}
class Key_0 {}
class Key_1 {}
class CoroutineName extends AbstractCoroutineContextElement {
  static x1d(name) {
    var $this = this.hn(Key_instance_2);
    $this.w1d_1 = name;
    return $this;
  }
  toString() {
    return 'CoroutineName(' + this.w1d_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.w1d_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CoroutineName))
      return false;
    var tmp0_other_with_cast = other instanceof CoroutineName ? other : THROW_CCE();
    if (!(this.w1d_1 === tmp0_other_with_cast.w1d_1))
      return false;
    return true;
  }
}
class GlobalScope {
  b17() {
    return EmptyCoroutineContext_getInstance();
  }
}
class CoroutineStart extends Enum {
  s17(block, receiver, completion) {
    var tmp;
    switch (this.r3_1) {
      case 0:
        startCoroutineCancellable(block, receiver, completion);
        tmp = Unit_instance;
        break;
      case 2:
        startCoroutine(block, receiver, completion);
        tmp = Unit_instance;
        break;
      case 3:
        startCoroutineUndispatched(block, receiver, completion);
        tmp = Unit_instance;
        break;
      case 1:
        tmp = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  y18() {
    return this === CoroutineStart_LAZY_getInstance();
  }
}
class Delay {}
function invokeOnTimeout(timeMillis, block, context) {
  return get_DefaultDelay().e1e(timeMillis, block, context);
}
class DelayWithTimeoutDiagnostics {}
class EventLoop extends CoroutineDispatcher {
  static k1e() {
    var $this = this.p1d();
    $this.h1e_1 = new Long(0, 0);
    $this.i1e_1 = false;
    $this.j1e_1 = null;
    return $this;
  }
  l1e() {
    var tmp0_elvis_lhs = this.j1e_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var queue = tmp;
    var tmp1_elvis_lhs = queue.vk();
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var task = tmp_0;
    task.n1c();
    return true;
  }
  m1e(task) {
    var tmp0_elvis_lhs = this.j1e_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = ArrayDeque.pk();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.coroutines.EventLoop.dispatchUnconfined.<anonymous>' call
      this.j1e_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var queue = tmp;
    queue.tk(task);
  }
  n1e() {
    return this.h1e_1.x1(delta(this, true)) >= 0;
  }
  o1e() {
    var tmp27_safe_receiver = this.j1e_1;
    var tmp0_elvis_lhs = tmp27_safe_receiver == null ? null : tmp27_safe_receiver.h1();
    return tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs;
  }
  p1e(unconfined) {
    this.h1e_1 = this.h1e_1.y3(delta(this, unconfined));
    if (!unconfined)
      this.i1e_1 = true;
  }
  q1e(unconfined) {
    this.h1e_1 = this.h1e_1.y1(delta(this, unconfined));
    if (this.h1e_1.x1(new Long(0, 0)) > 0)
      return Unit_instance;
    // Inline function 'kotlinx.coroutines.assert' call
    if (this.i1e_1) {
      this.r1e();
    }
  }
  r1e() {
  }
}
class ThreadLocalEventLoop {
  constructor() {
    ThreadLocalEventLoop_instance = this;
    this.s1e_1 = commonThreadLocal(new Symbol('ThreadLocalEventLoop'));
  }
  t1e() {
    var tmp0_elvis_lhs = this.s1e_1.v1e();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = createEventLoop();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.coroutines.ThreadLocalEventLoop.<get-eventLoop>.<anonymous>' call
      ThreadLocalEventLoop_getInstance().s1e_1.w1e(this_0);
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
}
class CompletionHandlerException extends RuntimeException {
  static g1b(message, cause) {
    var $this = this.ke(message, cause);
    captureStack($this, $this.f1b_1);
    return $this;
  }
}
class CoroutinesInternalError extends Error_0 {
  static z1e(message, cause) {
    var $this = this.oe(message, cause);
    captureStack($this, $this.y1e_1);
    return $this;
  }
}
class Key_2 {}
class NonDisposableHandle {
  m1a() {
  }
  m18(cause) {
    return false;
  }
  toString() {
    return 'NonDisposableHandle';
  }
}
class DisposeOnCompletion extends JobNode {
  constructor(handle) {
    super();
    this.e1f_1 = handle;
  }
  w1c() {
    return false;
  }
  l1a(cause) {
    return this.e1f_1.m1a();
  }
}
class Empty {
  constructor(isActive) {
    this.f1f_1 = isActive;
  }
  c17() {
    return this.f1f_1;
  }
  c1d() {
    return null;
  }
  toString() {
    return 'Empty{' + (this.f1f_1 ? 'Active' : 'New') + '}';
  }
}
class LockFreeLinkedListHead extends LockFreeLinkedListNode {}
class NodeList extends LockFreeLinkedListHead {
  c17() {
    return true;
  }
  c1d() {
    return this;
  }
  j1f(state) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.NodeList.getString.<anonymous>' call
    this_0.bc('List{');
    this_0.bc(state);
    this_0.bc('}[');
    var first = true;
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListHead.forEach' call
    var cur = this.d1d_1;
    while (!equals(cur, this)) {
      // Inline function 'kotlinx.coroutines.NodeList.getString.<anonymous>.<anonymous>' call
      var node = cur;
      if (node instanceof JobNode) {
        if (first) {
          first = false;
        } else
          this_0.bc(', ');
        this_0.ac(node);
      }
      cur = cur.d1d_1;
    }
    this_0.bc(']');
    return this_0.toString();
  }
  toString() {
    return get_DEBUG() ? this.j1f('Active') : super.toString();
  }
}
class SynchronizedObject {}
class Finishing extends SynchronizedObject {
  constructor(list, isCompleting, rootCause) {
    super();
    this.l1f_1 = list;
    this.m1f_1 = atomic$boolean$1(isCompleting);
    this.n1f_1 = atomic$ref$1(rootCause);
    this.o1f_1 = atomic$ref$1(null);
  }
  c1d() {
    return this.l1f_1;
  }
  j1g(value) {
    this.m1f_1.kotlinx$atomicfu$value = value;
  }
  f1g() {
    return this.m1f_1.kotlinx$atomicfu$value;
  }
  k1g(value) {
    this.n1f_1.kotlinx$atomicfu$value = value;
  }
  i1g() {
    return this.n1f_1.kotlinx$atomicfu$value;
  }
  g1g() {
    return _get_exceptionsHolder__nhszp(this) === get_SEALED();
  }
  v1f() {
    return !(this.i1g() == null);
  }
  c17() {
    return this.i1g() == null;
  }
  w1f(proposedException) {
    var eh = _get_exceptionsHolder__nhszp(this);
    var tmp;
    if (eh == null) {
      tmp = allocateList(this);
    } else {
      if (eh instanceof Error) {
        // Inline function 'kotlin.also' call
        var this_0 = allocateList(this);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.coroutines.Finishing.sealLocked.<anonymous>' call
        this_0.h(eh);
        tmp = this_0;
      } else {
        if (eh instanceof ArrayList) {
          tmp = eh instanceof ArrayList ? eh : THROW_CCE();
        } else {
          var message = 'State is ' + toString_0(eh);
          throw IllegalStateException.h5(toString(message));
        }
      }
    }
    var list = tmp;
    var rootCause = this.i1g();
    if (rootCause == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      list.i7(0, rootCause);
    }
    if (!(proposedException == null) && !equals(proposedException, rootCause)) {
      list.h(proposedException);
    }
    _set_exceptionsHolder__tqm22h(this, get_SEALED());
    return list;
  }
  h1g(exception) {
    var rootCause = this.i1g();
    if (rootCause == null) {
      this.k1g(exception);
      return Unit_instance;
    }
    if (exception === rootCause)
      return Unit_instance;
    var eh = _get_exceptionsHolder__nhszp(this);
    if (eh == null) {
      _set_exceptionsHolder__tqm22h(this, exception);
    } else {
      if (eh instanceof Error) {
        if (exception === eh)
          return Unit_instance;
        // Inline function 'kotlin.apply' call
        var this_0 = allocateList(this);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.coroutines.Finishing.addExceptionLocked.<anonymous>' call
        this_0.h(eh);
        this_0.h(exception);
        _set_exceptionsHolder__tqm22h(this, this_0);
      } else {
        if (eh instanceof ArrayList) {
          (eh instanceof ArrayList ? eh : THROW_CCE()).h(exception);
        } else {
          var message = 'State is ' + toString_0(eh);
          throw IllegalStateException.h5(toString(message));
        }
      }
    }
  }
  toString() {
    return 'Finishing[cancelling=' + this.v1f() + ', completing=' + this.f1g() + ', rootCause=' + toString_0(this.i1g()) + ', exceptions=' + toString_0(_get_exceptionsHolder__nhszp(this)) + ', list=' + this.l1f_1.toString() + ']';
  }
}
class ChildCompletion extends JobNode {
  constructor(parent, state, child, proposedUpdate) {
    super();
    this.p1g_1 = parent;
    this.q1g_1 = state;
    this.r1g_1 = child;
    this.s1g_1 = proposedUpdate;
  }
  w1c() {
    return false;
  }
  l1a(cause) {
    continueCompleting(this.p1g_1, this.q1g_1, this.r1g_1, this.s1g_1);
  }
}
class AwaitContinuation extends CancellableContinuationImpl {
  constructor(delegate, job) {
    super(delegate, 1);
    this.z1g_1 = job;
  }
  z1b(parent) {
    var state = this.z1g_1.v17();
    if (state instanceof Finishing) {
      var tmp73_safe_receiver = state.i1g();
      if (tmp73_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        return tmp73_safe_receiver;
      }
    }
    if (state instanceof CompletedExceptionally)
      return state.h17_1;
    return parent.z17();
  }
  m1c() {
    return 'AwaitContinuation';
  }
}
class JobSupport$_get_children_$slambda_k839f8 {
  constructor(this$0) {
    this.p1f_1 = this$0;
  }
  a1h($this$sequence, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$sequence), $completion);
  }
  de(p1, $completion) {
    return this.a1h(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  }
}
class InactiveNodeList {
  constructor(list) {
    this.e1g_1 = list;
  }
  c1d() {
    return this.e1g_1;
  }
  c17() {
    return false;
  }
  toString() {
    return get_DEBUG() ? this.e1g_1.j1f('New') : anyToString(this);
  }
}
class InvokeOnCompletion extends JobNode {
  constructor(handler) {
    super();
    this.f1h_1 = handler;
  }
  w1c() {
    return false;
  }
  l1a(cause) {
    return this.f1h_1(cause);
  }
}
class InvokeOnCancelling extends JobNode {
  constructor(handler) {
    super();
    this.k1h_1 = handler;
    this.l1h_1 = atomic$boolean$1(false);
  }
  w1c() {
    return true;
  }
  l1a(cause) {
    if (this.l1h_1.atomicfu$compareAndSet(false, true))
      this.k1h_1(cause);
  }
}
class ResumeOnCompletion extends JobNode {
  constructor(continuation) {
    super();
    this.q1h_1 = continuation;
  }
  w1c() {
    return false;
  }
  l1a(cause) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = this.q1h_1;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
    this_0.bd(tmp$ret$0);
    return Unit_instance;
  }
}
class ChildHandleNode extends JobNode {
  constructor(childJob) {
    super();
    this.u1f_1 = childJob;
  }
  w1c() {
    return true;
  }
  l1a(cause) {
    return this.u1f_1.l18(this.b1d());
  }
  m18(cause) {
    return this.b1d().m18(cause);
  }
}
class ResumeAwaitOnCompletion extends JobNode {
  constructor(continuation) {
    super();
    this.w1h_1 = continuation;
  }
  w1c() {
    return false;
  }
  l1a(cause) {
    var state = this.b1d().v17();
    // Inline function 'kotlinx.coroutines.assert' call
    if (state instanceof CompletedExceptionally) {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var this_0 = this.w1h_1;
      // Inline function 'kotlin.Companion.failure' call
      var exception = state.h17_1;
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
      this_0.bd(tmp$ret$0);
    } else {
      // Inline function 'kotlin.coroutines.resume' call
      var this_1 = this.w1h_1;
      var tmp = unboxState(state);
      // Inline function 'kotlin.Companion.success' call
      var value = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
      var tmp$ret$2 = _Result___init__impl__xyqfz8(value);
      this_1.bd(tmp$ret$2);
    }
  }
}
class IncompleteStateBox {
  constructor(state) {
    this.r1h_1 = state;
  }
}
class JobImpl extends JobSupport {
  constructor(parent) {
    super(true);
    this.x16(parent);
    this.z1h_1 = handlesExceptionF(this);
  }
  h18() {
    return true;
  }
  u18() {
    return this.z1h_1;
  }
}
class MainCoroutineDispatcher extends CoroutineDispatcher {
  static b1i() {
    return this.p1d();
  }
  toString() {
    var tmp0_elvis_lhs = this.d1i();
    return tmp0_elvis_lhs == null ? get_classSimpleName(this) + '@' + get_hexAddress(this) : tmp0_elvis_lhs;
  }
  d1i() {
    var main = Dispatchers_getInstance().c1e();
    if (this === main)
      return 'Dispatchers.Main';
    var tmp;
    try {
      tmp = main.c1i();
    } catch ($p) {
      var tmp_0;
      if ($p instanceof UnsupportedOperationException) {
        var e = $p;
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var immediate = tmp;
    if (this === immediate)
      return 'Dispatchers.Main.immediate';
    return null;
  }
}
class SupervisorJobImpl extends JobImpl {
  m18(cause) {
    return false;
  }
}
class TimeoutCancellationException extends CancellationException {
  static n1i(message, coroutine) {
    var $this = this.ud(message);
    captureStack($this, $this.m1i_1);
    $this.l1i_1 = coroutine;
    return $this;
  }
  static o1i(message) {
    return this.n1i(message, null);
  }
}
class TimeoutCoroutine extends ScopeCoroutine {
  constructor(time, uCont) {
    super(uCont.zc(), uCont);
    this.t1i_1 = time;
  }
  n1c() {
    this.n18(TimeoutCancellationException_0(this.t1i_1, get_delay(this.a17_1), this));
  }
  o17() {
    return super.o17() + '(timeMillis=' + this.t1i_1.toString() + ')';
  }
}
class Unconfined extends CoroutineDispatcher {
  static v1i() {
    Unconfined_instance = null;
    var $this = this.p1d();
    Unconfined_instance = $this;
    return $this;
  }
  q1d(context) {
    return false;
  }
  r1d(context, block) {
    var yieldContext = context.md(Key_instance_4);
    if (!(yieldContext == null)) {
      yieldContext.x1i_1 = true;
      return Unit_instance;
    }
    throw UnsupportedOperationException.la('Dispatchers.Unconfined.dispatch function can only be used by the yield function. If you wrap Unconfined dispatcher in your code, make sure you properly delegate isDispatchNeeded and dispatch calls.');
  }
  toString() {
    return 'Dispatchers.Unconfined';
  }
}
class Key_3 {}
class YieldContext extends AbstractCoroutineContextElement {
  static y1i() {
    var $this = this.hn(Key_instance_4);
    $this.x1i_1 = false;
    return $this;
  }
}
class BufferOverflow extends Enum {}
class ConcurrentLinkedListNode {
  constructor(prev) {
    this.i1k_1 = atomic$ref$1(null);
    this.j1k_1 = atomic$ref$1(prev);
  }
  k1k() {
    // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed.<anonymous>' call
    var it = _get_nextOrClosed__w0gmuv(this);
    var tmp;
    if (it === get_CLOSED()) {
      // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.<get-next>.<anonymous>' call
      return null;
    } else {
      tmp = (it == null ? true : it instanceof ConcurrentLinkedListNode) ? it : THROW_CCE();
    }
    return tmp;
  }
  l1k(value) {
    return this.i1k_1.atomicfu$compareAndSet(null, value);
  }
  m1k() {
    return this.k1k() == null;
  }
  n1k() {
    return this.j1k_1.kotlinx$atomicfu$value;
  }
  o1k() {
    // Inline function 'kotlinx.atomicfu.AtomicRef.lazySet' call
    this.j1k_1.kotlinx$atomicfu$value = null;
  }
  p1k() {
    return this.i1k_1.atomicfu$compareAndSet(null, get_CLOSED());
  }
  r6() {
    // Inline function 'kotlinx.coroutines.assert' call
    if (this.m1k())
      return Unit_instance;
    $l$loop_0: while (true) {
      var prev = _get_aliveSegmentLeft__mr4ndu(this);
      var next = _get_aliveSegmentRight__7ulr0b(this);
      $l$block: {
        // Inline function 'kotlinx.atomicfu.update' call
        var this_0 = next.j1k_1;
        while (true) {
          var cur = this_0.kotlinx$atomicfu$value;
          // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.remove.<anonymous>' call
          var upd = cur === null ? null : prev;
          if (this_0.atomicfu$compareAndSet(cur, upd)) {
            break $l$block;
          }
        }
      }
      if (!(prev === null))
        prev.i1k_1.kotlinx$atomicfu$value = next;
      if (next.f1k() && !next.m1k())
        continue $l$loop_0;
      if (!(prev === null) && prev.f1k())
        continue $l$loop_0;
      return Unit_instance;
    }
  }
}
class Segment extends ConcurrentLinkedListNode {
  constructor(id, prev, pointers) {
    super(prev);
    this.a1b_1 = id;
    this.b1b_1 = atomic$int$1(pointers << 16);
  }
  f1k() {
    return this.b1b_1.kotlinx$atomicfu$value === this.h1j() && !this.m1k();
  }
  g1k() {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlinx.coroutines.internal.addConditionally' call
      var this_0 = this.b1b_1;
      while (true) {
        var cur = this_0.kotlinx$atomicfu$value;
        // Inline function 'kotlinx.coroutines.internal.Segment.tryIncPointers.<anonymous>' call
        if (!(!(cur === this.h1j()) || this.m1k())) {
          tmp$ret$1 = false;
          break $l$block_0;
        }
        if (this_0.atomicfu$compareAndSet(cur, cur + 65536 | 0)) {
          tmp$ret$1 = true;
          break $l$block_0;
        }
      }
    }
    return tmp$ret$1;
  }
  h1k() {
    return this.b1b_1.atomicfu$addAndGet(-65536) === this.h1j() && !this.m1k();
  }
  e1k() {
    if (this.b1b_1.atomicfu$incrementAndGet() === this.h1j()) {
      this.r6();
    }
  }
}
class ChannelSegment extends Segment {
  constructor(id, prev, channel, pointers) {
    super(id, prev, pointers);
    this.e1j_1 = channel;
    this.f1j_1 = atomicfu$AtomicRefArray$ofNulls(imul(get_SEGMENT_SIZE(), 2));
  }
  g1j() {
    return ensureNotNull(this.e1j_1);
  }
  h1j() {
    return get_SEGMENT_SIZE();
  }
  i1j(index, element) {
    setElementLazy(this, index, element);
  }
  j1j(index) {
    var tmp = this.f1j_1.atomicfu$get(imul(index, 2)).kotlinx$atomicfu$value;
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  }
  k1j(index) {
    // Inline function 'kotlin.also' call
    var this_0 = this.j1j(index);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.channels.ChannelSegment.retrieveElement.<anonymous>' call
    this.l1j(index);
    return this_0;
  }
  l1j(index) {
    setElementLazy(this, index, null);
  }
  m1j(index) {
    return this.f1j_1.atomicfu$get(imul(index, 2) + 1 | 0).kotlinx$atomicfu$value;
  }
  n1j(index, value) {
    this.f1j_1.atomicfu$get(imul(index, 2) + 1 | 0).kotlinx$atomicfu$value = value;
  }
  o1j(index, from, to) {
    return this.f1j_1.atomicfu$get(imul(index, 2) + 1 | 0).atomicfu$compareAndSet(from, to);
  }
  p1j(index, update) {
    return this.f1j_1.atomicfu$get(imul(index, 2) + 1 | 0).atomicfu$getAndSet(update);
  }
  c1b(index, cause, context) {
    var isSender = index >= get_SEGMENT_SIZE();
    var index_0 = isSender ? index - get_SEGMENT_SIZE() | 0 : index;
    var element = this.j1j(index_0);
    $l$loop: while (true) {
      var cur = this.m1j(index_0);
      var tmp;
      if (!(cur == null) ? isInterface(cur, Waiter) : false) {
        tmp = true;
      } else {
        tmp = cur instanceof WaiterEB;
      }
      if (tmp) {
        var update = isSender ? get_INTERRUPTED_SEND() : get_INTERRUPTED_RCV();
        if (this.o1j(index_0, cur, update)) {
          this.l1j(index_0);
          this.c1k(index_0, !isSender);
          if (isSender) {
            var tmp109_safe_receiver = this.g1j().r1j_1;
            if (tmp109_safe_receiver == null)
              null;
            else {
              callUndeliveredElement(tmp109_safe_receiver, element, context);
            }
          }
          return Unit_instance;
        }
      } else {
        if (cur === get_INTERRUPTED_SEND() || cur === get_INTERRUPTED_RCV()) {
          this.l1j(index_0);
          if (isSender) {
            var tmp110_safe_receiver = this.g1j().r1j_1;
            if (tmp110_safe_receiver == null)
              null;
            else {
              callUndeliveredElement(tmp110_safe_receiver, element, context);
            }
          }
          return Unit_instance;
        } else {
          if (cur === get_RESUMING_BY_EB() || cur === get_RESUMING_BY_RCV())
            continue $l$loop;
          else {
            if (cur === get_DONE_RCV() || cur === get_BUFFERED())
              return Unit_instance;
            else {
              if (cur === get_CHANNEL_CLOSED())
                return Unit_instance;
              else {
                var message = 'unexpected state: ' + toString_0(cur);
                throw IllegalStateException.h5(toString(message));
              }
            }
          }
        }
      }
    }
  }
  c1k(index, receiver) {
    if (receiver) {
      var tmp = this.g1j();
      // Inline function 'kotlin.Long.plus' call
      // Inline function 'kotlin.Long.times' call
      var this_0 = this.a1b_1;
      var other = get_SEGMENT_SIZE();
      var tmp$ret$1 = this_0.z3(toLong(other)).y3(toLong(index));
      tmp.d1k(tmp$ret$1);
    }
    this.e1k();
  }
}
class SendBroadcast {}
class BufferedChannelIterator {
  x1k(element) {
    var cont = ensureNotNull(this.v1k_1);
    this.v1k_1 = null;
    this.u1k_1 = element;
    var tmp98_safe_receiver = this.w1k_1.r1j_1;
    return tryResume0(cont, true, tmp98_safe_receiver == null ? null : bindCancellationFun(tmp98_safe_receiver, this.w1k_1, element));
  }
  k1l() {
    var cont = ensureNotNull(this.v1k_1);
    this.v1k_1 = null;
    this.u1k_1 = get_CHANNEL_CLOSED();
    var cause = this.w1k_1.l1l();
    if (cause == null) {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(false);
      cont.bd(tmp$ret$0);
    } else {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = recoverStackTrace(cause, cont);
      var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
      cont.bd(tmp$ret$2);
    }
  }
}
class BufferedChannel {
  constructor(capacity, onUndeliveredElement) {
    onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
    this.q1j_1 = capacity;
    this.r1j_1 = onUndeliveredElement;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.q1j_1 >= 0)) {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.<anonymous>' call
      var message = 'Invalid channel capacity: ' + this.q1j_1 + ', should be >=0';
      throw IllegalArgumentException.l(toString(message));
    }
    this.s1j_1 = atomic$long$1(new Long(0, 0));
    this.t1j_1 = atomic$long$1(new Long(0, 0));
    this.u1j_1 = atomic$long$1(initialBufferEnd(this.q1j_1));
    this.v1j_1 = atomic$long$1(_get_bufferEndCounter__2d4hee(this));
    var firstSegment = new ChannelSegment(new Long(0, 0), null, this, 3);
    this.w1j_1 = atomic$ref$1(firstSegment);
    this.x1j_1 = atomic$ref$1(firstSegment);
    var tmp = this;
    var tmp_0;
    if (_get_isRendezvousOrUnlimited__3mdufi(this)) {
      var tmp_1 = get_NULL_SEGMENT();
      tmp_0 = tmp_1 instanceof ChannelSegment ? tmp_1 : THROW_CCE();
    } else {
      tmp_0 = firstSegment;
    }
    tmp.y1j_1 = atomic$ref$1(tmp_0);
    var tmp_2 = this;
    var tmp_3;
    if (this.r1j_1 == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.onUndeliveredElementReceiveCancellationConstructor.<anonymous>' call
      tmp_3 = BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda(this);
    }
    tmp_2.z1j_1 = tmp_3;
    this.a1k_1 = atomic$ref$1(get_NO_CLOSE_CAUSE());
    this.b1k_1 = atomic$ref$1(null);
  }
  d1l() {
    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
    return this.s1j_1.kotlinx$atomicfu$value.j4(new Long(-1, 268435455));
  }
  q1k() {
    return this.t1j_1.kotlinx$atomicfu$value;
  }
  y1l(element, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_send__qhx0g0.bind(VOID, this, element), $completion);
  }
  z1l(element) {
    if (shouldSendSuspend0(this, this.s1j_1.kotlinx$atomicfu$value))
      return Companion_getInstance_0().a1m();
    var tmp$ret$4;
    $l$block_4: {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
      var waiter = get_INTERRUPTED_SEND();
      var segment = this.w1j_1.kotlinx$atomicfu$value;
      $l$loop_0: while (true) {
        var sendersAndCloseStatusCur = this.s1j_1.atomicfu$getAndIncrement$long();
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
        var s = sendersAndCloseStatusCur.j4(new Long(-1, 268435455));
        var closed = _get_isClosedForSend0__kxgf9m(sendersAndCloseStatusCur, this);
        // Inline function 'kotlin.Long.div' call
        var other = get_SEGMENT_SIZE();
        var id = s.a4(toLong(other));
        // Inline function 'kotlin.Long.rem' call
        var other_0 = get_SEGMENT_SIZE();
        var i = s.b4(toLong(other_0)).j2();
        if (!segment.a1b_1.equals(id)) {
          var tmp0_elvis_lhs = findSegmentSend(this, id, segment);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            var tmp_0;
            if (closed) {
              // Inline function 'kotlinx.coroutines.channels.BufferedChannel.trySend.<anonymous>' call
              tmp$ret$4 = Companion_getInstance_0().u1l(this.r1k());
              break $l$block_4;
            } else {
              continue $l$loop_0;
            }
          } else {
            tmp = tmp0_elvis_lhs;
          }
          segment = tmp;
        }
        switch (updateCellSend(this, segment, i, element, s, waiter, closed)) {
          case 0:
            segment.o1k();
            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.trySend.<anonymous>' call

            tmp$ret$4 = Companion_getInstance_0().z1k(Unit_instance);
            break $l$block_4;
          case 1:
            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.trySend.<anonymous>' call

            tmp$ret$4 = Companion_getInstance_0().z1k(Unit_instance);
            break $l$block_4;
          case 2:
            if (closed) {
              segment.e1k();
              // Inline function 'kotlinx.coroutines.channels.BufferedChannel.trySend.<anonymous>' call
              tmp$ret$4 = Companion_getInstance_0().u1l(this.r1k());
              break $l$block_4;
            }

            var tmp83_safe_receiver = (!(waiter == null) ? isInterface(waiter, Waiter) : false) ? waiter : null;
            if (tmp83_safe_receiver == null)
              null;
            else {
              prepareSenderForSuspension(tmp83_safe_receiver, this, segment, i);
            }

            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.trySend.<anonymous>' call

            segment.e1k();
            tmp$ret$4 = Companion_getInstance_0().a1m();
            break $l$block_4;
          case 4:
            if (s.x1(this.q1k()) < 0) {
              segment.o1k();
            }

            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.trySend.<anonymous>' call

            tmp$ret$4 = Companion_getInstance_0().u1l(this.r1k());
            break $l$block_4;
          case 5:
            segment.o1k();
            continue $l$loop_0;
          case 3:
            var message = 'unexpected';
            throw IllegalStateException.h5(toString(message));
        }
      }
    }
    return tmp$ret$4;
  }
  b1m(element) {
    var tmp$ret$3;
    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
    var waiter = get_BUFFERED();
    var segment = this.w1j_1.kotlinx$atomicfu$value;
    $l$loop_0: while (true) {
      var sendersAndCloseStatusCur = this.s1j_1.atomicfu$getAndIncrement$long();
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
      var s = sendersAndCloseStatusCur.j4(new Long(-1, 268435455));
      var closed = _get_isClosedForSend0__kxgf9m(sendersAndCloseStatusCur, this);
      // Inline function 'kotlin.Long.div' call
      var other = get_SEGMENT_SIZE();
      var id = s.a4(toLong(other));
      // Inline function 'kotlin.Long.rem' call
      var other_0 = get_SEGMENT_SIZE();
      var i = s.b4(toLong(other_0)).j2();
      if (!segment.a1b_1.equals(id)) {
        var tmp0_elvis_lhs = findSegmentSend(this, id, segment);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var tmp_0;
          if (closed) {
            return Companion_getInstance_0().u1l(this.r1k());
          } else {
            continue $l$loop_0;
          }
        } else {
          tmp = tmp0_elvis_lhs;
        }
        segment = tmp;
      }
      switch (updateCellSend(this, segment, i, element, s, waiter, closed)) {
        case 0:
          segment.o1k();
          return Companion_getInstance_0().z1k(Unit_instance);
        case 1:
          return Companion_getInstance_0().z1k(Unit_instance);
        case 2:
          if (closed) {
            segment.e1k();
            return Companion_getInstance_0().u1l(this.r1k());
          }

          var tmp83_safe_receiver = (!(waiter == null) ? isInterface(waiter, Waiter) : false) ? waiter : null;
          if (tmp83_safe_receiver == null)
            null;
          else {
            prepareSenderForSuspension(tmp83_safe_receiver, this, segment, i);
          }

          // Inline function 'kotlin.Long.plus' call

          // Inline function 'kotlin.Long.times' call

          var this_0 = segment.a1b_1;
          var other_1 = get_SEGMENT_SIZE();
          var tmp$ret$5 = this_0.z3(toLong(other_1)).y3(toLong(i));
          this.s1l(tmp$ret$5);
          return Companion_getInstance_0().z1k(Unit_instance);
        case 4:
          if (s.x1(this.q1k()) < 0) {
            segment.o1k();
          }

          return Companion_getInstance_0().u1l(this.r1k());
        case 5:
          segment.o1k();
          continue $l$loop_0;
        case 3:
          var message = 'unexpected';
          throw IllegalStateException.h5(toString(message));
      }
    }
    return tmp$ret$3;
  }
  e1l() {
  }
  s1k() {
  }
  c1m($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_receive__aoggq9.bind(VOID, this), $completion);
  }
  s1l(globalCellIndex) {
    // Inline function 'kotlinx.coroutines.assert' call
    var segment = this.x1j_1.kotlinx$atomicfu$value;
    $l$loop_0: while (true) {
      var r = this.t1j_1.kotlinx$atomicfu$value;
      // Inline function 'kotlin.math.max' call
      // Inline function 'kotlin.Long.plus' call
      var other = this.q1j_1;
      var a = r.y3(toLong(other));
      var b = _get_bufferEndCounter__2d4hee(this);
      var tmp$ret$1 = a.x1(b) >= 0 ? a : b;
      if (globalCellIndex.x1(tmp$ret$1) < 0)
        return Unit_instance;
      // Inline function 'kotlin.Long.plus' call
      var tmp$ret$2 = r.y3(toLong(1));
      if (!this.t1j_1.atomicfu$compareAndSet(r, tmp$ret$2))
        continue $l$loop_0;
      // Inline function 'kotlin.Long.div' call
      var other_0 = get_SEGMENT_SIZE();
      var id = r.a4(toLong(other_0));
      // Inline function 'kotlin.Long.rem' call
      var other_1 = get_SEGMENT_SIZE();
      var i = r.b4(toLong(other_1)).j2();
      if (!segment.a1b_1.equals(id)) {
        var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        segment = tmp;
      }
      var updCellResult = updateCellReceive(this, segment, i, r, null);
      if (updCellResult === _get_FAILED_$accessor$yt74tm_h47uk8()) {
        if (r.x1(this.d1l()) < 0) {
          segment.o1k();
        }
      } else {
        segment.o1k();
        var tmp90_safe_receiver = this.r1j_1;
        var tmp_0;
        if (tmp90_safe_receiver == null) {
          tmp_0 = null;
        } else {
          tmp_0 = callUndeliveredElementCatchingException(tmp90_safe_receiver, (updCellResult == null ? true : !(updCellResult == null)) ? updCellResult : THROW_CCE());
        }
        var tmp91_safe_receiver = tmp_0;
        if (tmp91_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          throw tmp91_safe_receiver;
        }
      }
    }
  }
  d1k(globalIndex) {
    if (_get_isRendezvousOrUnlimited__3mdufi(this))
      return Unit_instance;
    while (_get_bufferEndCounter__2d4hee(this).x1(globalIndex) <= 0) {
    }
    // Inline function 'kotlin.repeat' call
    var times = get_EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS();
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.waitExpandBufferCompletion.<anonymous>' call
        var b = _get_bufferEndCounter__2d4hee(this);
        // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
        var ebCompleted = this.v1j_1.kotlinx$atomicfu$value.j4(new Long(-1, 1073741823));
        if (b.equals(ebCompleted) && b.equals(_get_bufferEndCounter__2d4hee(this)))
          return Unit_instance;
      }
       while (inductionVariable < times);
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      var this_0 = this.v1j_1;
      while (true) {
        var cur = this_0.kotlinx$atomicfu$value;
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.waitExpandBufferCompletion.<anonymous>' call
        // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
        var tmp$ret$1 = cur.j4(new Long(-1, 1073741823));
        var upd = constructEBCompletedAndPauseFlag(tmp$ret$1, true);
        if (this_0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    while (true) {
      var b_0 = _get_bufferEndCounter__2d4hee(this);
      var ebCompletedAndBit = this.v1j_1.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
      var ebCompleted_0 = ebCompletedAndBit.j4(new Long(-1, 1073741823));
      // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
      var pauseExpandBuffers = !ebCompletedAndBit.j4(new Long(0, 1073741824)).equals(new Long(0, 0));
      if (b_0.equals(ebCompleted_0) && b_0.equals(_get_bufferEndCounter__2d4hee(this))) {
        $l$block_0: {
          // Inline function 'kotlinx.atomicfu.update' call
          var this_1 = this.v1j_1;
          while (true) {
            var cur_0 = this_1.kotlinx$atomicfu$value;
            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.waitExpandBufferCompletion.<anonymous>' call
            // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
            var tmp$ret$6 = cur_0.j4(new Long(-1, 1073741823));
            var upd_0 = constructEBCompletedAndPauseFlag(tmp$ret$6, false);
            if (this_1.atomicfu$compareAndSet(cur_0, upd_0)) {
              break $l$block_0;
            }
          }
        }
        return Unit_instance;
      }
      if (!pauseExpandBuffers) {
        this.v1j_1.atomicfu$compareAndSet(ebCompletedAndBit, constructEBCompletedAndPauseFlag(ebCompleted_0, true));
      }
    }
  }
  l1l() {
    var tmp = this.a1k_1.kotlinx$atomicfu$value;
    return (tmp == null ? true : tmp instanceof Error) ? tmp : THROW_CCE();
  }
  r1k() {
    var tmp0_elvis_lhs = this.l1l();
    return tmp0_elvis_lhs == null ? ClosedSendChannelException.h1m('Channel was closed') : tmp0_elvis_lhs;
  }
  t1l() {
    return false;
  }
  r1l() {
    return _get_isClosedForSend0__kxgf9m(this.s1j_1.kotlinx$atomicfu$value, this);
  }
  c1l() {
    return _get_isClosedForReceive0__f7qknl(this.s1j_1.kotlinx$atomicfu$value, this);
  }
  v1l() {
    $l$loop: while (true) {
      var segment = this.x1j_1.kotlinx$atomicfu$value;
      var r = this.q1k();
      var s = this.d1l();
      if (s.x1(r) <= 0)
        return false;
      // Inline function 'kotlin.Long.div' call
      var other = get_SEGMENT_SIZE();
      var id = r.a4(toLong(other));
      if (!segment.a1b_1.equals(id)) {
        var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var tmp_0;
          if (this.x1j_1.kotlinx$atomicfu$value.a1b_1.x1(id) < 0) {
            return false;
          } else {
            continue $l$loop;
          }
        } else {
          tmp = tmp0_elvis_lhs;
        }
        segment = tmp;
      }
      segment.o1k();
      // Inline function 'kotlin.Long.rem' call
      var other_0 = get_SEGMENT_SIZE();
      var i = r.b4(toLong(other_0)).j2();
      if (isCellNonEmpty(this, segment, i, r))
        return true;
      // Inline function 'kotlin.Long.plus' call
      var tmp$ret$2 = r.y3(toLong(1));
      this.t1j_1.atomicfu$compareAndSet(r, tmp$ret$2);
    }
  }
  toString() {
    var sb = StringBuilder.f();
    // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
    var tmp103_subject = this.s1j_1.kotlinx$atomicfu$value.h4(60).j2();
    if (tmp103_subject === 2) {
      sb.bc('closed,');
    } else if (tmp103_subject === 3) {
      sb.bc('cancelled,');
    }
    sb.bc('capacity=' + this.q1j_1 + ',');
    sb.bc('data=[');
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlin.collections.minBy' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = listOf([this.x1j_1.kotlinx$atomicfu$value, this.w1j_1.kotlinx$atomicfu$value, this.y1j_1.kotlinx$atomicfu$value]);
      var destination = ArrayList.j1();
      var tmp0_iterator = this_0.b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.toString.<anonymous>' call
        if (!(element === get_NULL_SEGMENT())) {
          destination.h(element);
        }
      }
      var iterator = destination.b1();
      if (!iterator.c1())
        throw NoSuchElementException.v6();
      var minElem = iterator.d1();
      if (!iterator.c1()) {
        tmp$ret$4 = minElem;
        break $l$block;
      }
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.toString.<anonymous>' call
      var minValue = minElem.a1b_1;
      do {
        var e = iterator.d1();
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.toString.<anonymous>' call
        var v = e.a1b_1;
        if (compareTo(minValue, v) > 0) {
          minElem = e;
          minValue = v;
        }
      }
       while (iterator.c1());
      tmp$ret$4 = minElem;
    }
    var firstSegment = tmp$ret$4;
    var r = this.q1k();
    var s = this.d1l();
    var segment = firstSegment;
    append_elements: while (true) {
      var inductionVariable = 0;
      var last_0 = get_SEGMENT_SIZE();
      if (inductionVariable < last_0)
        process_cell: do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.Long.plus' call
          // Inline function 'kotlin.Long.times' call
          var this_1 = segment.a1b_1;
          var other = get_SEGMENT_SIZE();
          var globalCellIndex = this_1.z3(toLong(other)).y3(toLong(i));
          if (globalCellIndex.x1(s) >= 0 && globalCellIndex.x1(r) >= 0)
            break append_elements;
          var cellState = segment.m1j(i);
          var element_0 = segment.j1j(i);
          var tmp;
          if (!(cellState == null) ? isInterface(cellState, CancellableContinuation) : false) {
            tmp = globalCellIndex.x1(r) < 0 && globalCellIndex.x1(s) >= 0 ? 'receive' : globalCellIndex.x1(s) < 0 && globalCellIndex.x1(r) >= 0 ? 'send' : 'cont';
          } else {
            if (!(cellState == null) ? isInterface(cellState, SelectInstance) : false) {
              tmp = globalCellIndex.x1(r) < 0 && globalCellIndex.x1(s) >= 0 ? 'onReceive' : globalCellIndex.x1(s) < 0 && globalCellIndex.x1(r) >= 0 ? 'onSend' : 'select';
            } else {
              if (cellState instanceof ReceiveCatching) {
                tmp = 'receiveCatching';
              } else {
                if (cellState instanceof SendBroadcast) {
                  tmp = 'sendBroadcast';
                } else {
                  if (cellState instanceof WaiterEB) {
                    tmp = 'EB(' + cellState.toString() + ')';
                  } else {
                    if (equals(cellState, get_RESUMING_BY_RCV()) || equals(cellState, get_RESUMING_BY_EB())) {
                      tmp = 'resuming_sender';
                    } else {
                      if (cellState == null || (equals(cellState, get_IN_BUFFER()) || equals(cellState, get_DONE_RCV())) || (equals(cellState, get_POISONED()) || equals(cellState, get_INTERRUPTED_RCV()) || (equals(cellState, get_INTERRUPTED_SEND()) || equals(cellState, get_CHANNEL_CLOSED())))) {
                        continue process_cell;
                      } else {
                        tmp = toString(cellState);
                      }
                    }
                  }
                }
              }
            }
          }
          var cellStateString = tmp;
          if (!(element_0 == null)) {
            sb.bc('(' + cellStateString + ',' + toString_0(element_0) + '),');
          } else {
            sb.bc(cellStateString + ',');
          }
        }
         while (inductionVariable < last_0);
      var tmp0_elvis_lhs = segment.k1k();
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        break append_elements;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      segment = tmp_0;
    }
    if (last(sb) === _Char___init__impl__6a9atx(44)) {
      sb.ih(sb.a() - 1 | 0);
    }
    sb.bc(']');
    return sb.toString();
  }
}
class WaiterEB {
  constructor(waiter) {
    this.t1k_1 = waiter;
  }
  toString() {
    return 'WaiterEB(' + toString(this.t1k_1) + ')';
  }
}
class ReceiveCatching {}
class Factory {
  constructor() {
    Factory_instance = this;
    this.i1m_1 = 2147483647;
    this.j1m_1 = 0;
    this.k1m_1 = -1;
    this.l1m_1 = -2;
    this.m1m_1 = -3;
    this.n1m_1 = 'kotlinx.coroutines.channels.defaultBuffer';
    this.o1m_1 = systemProp('kotlinx.coroutines.channels.defaultBuffer', 64, 1, 2147483646);
  }
}
class Failed {
  toString() {
    return 'Failed';
  }
}
class Closed extends Failed {
  constructor(cause) {
    super();
    this.p1m_1 = cause;
  }
  equals(other) {
    var tmp;
    if (other instanceof Closed) {
      tmp = equals(this.p1m_1, other.p1m_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.p1m_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
  toString() {
    return 'Closed(' + toString_0(this.p1m_1) + ')';
  }
}
class Companion {
  constructor() {
    Companion_instance_0 = this;
    this.y1k_1 = new Failed();
  }
  z1k(value) {
    return _ChannelResult___init__impl__siwsuf(value);
  }
  a1m() {
    return _ChannelResult___init__impl__siwsuf(this.y1k_1);
  }
  u1l(cause) {
    return _ChannelResult___init__impl__siwsuf(new Closed(cause));
  }
}
class ChannelResult {
  constructor(holder) {
    Companion_getInstance_0();
    this.x1l_1 = holder;
  }
  toString() {
    return ChannelResult__toString_impl_rrcqu7(this.x1l_1);
  }
  hashCode() {
    return ChannelResult__hashCode_impl_lilec2(this.x1l_1);
  }
  equals(other) {
    return ChannelResult__equals_impl_f471ri(this.x1l_1, other);
  }
}
class ClosedSendChannelException extends IllegalStateException {
  static h1m(message) {
    var $this = this.h5(message);
    captureStack($this, $this.g1m_1);
    return $this;
  }
}
class ClosedReceiveChannelException extends NoSuchElementException {
  static q1l(message) {
    var $this = this.p(message);
    captureStack($this, $this.p1l_1);
    return $this;
  }
}
class ConflatedBufferedChannel extends BufferedChannel {
  constructor(capacity, onBufferOverflow, onUndeliveredElement) {
    onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
    super(capacity, onUndeliveredElement);
    this.c1n_1 = capacity;
    this.d1n_1 = onBufferOverflow;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!(this.d1n_1 === BufferOverflow_SUSPEND_getInstance())) {
      // Inline function 'kotlinx.coroutines.channels.ConflatedBufferedChannel.<anonymous>' call
      var message = 'This implementation does not support suspension for senders, use ' + getKClass(BufferedChannel).gf() + ' instead';
      throw IllegalArgumentException.l(toString(message));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.c1n_1 >= 1)) {
      // Inline function 'kotlinx.coroutines.channels.ConflatedBufferedChannel.<anonymous>' call
      var message_0 = 'Buffered channel capacity must be at least 1, but ' + this.c1n_1 + ' was specified';
      throw IllegalArgumentException.l(toString(message_0));
    }
  }
  t1l() {
    return this.d1n_1.equals(BufferOverflow_DROP_OLDEST_getInstance());
  }
  y1l(element, $completion) {
    // Inline function 'kotlinx.coroutines.channels.onClosed' call
    var this_0 = trySendImpl(this, element, true);
    var tmp = _ChannelResult___get_holder__impl__pm9gzw(this_0);
    if (tmp instanceof Closed) {
      // Inline function 'kotlinx.coroutines.channels.ConflatedBufferedChannel.send.<anonymous>' call
      ChannelResult__exceptionOrNull_impl_16ei30(this_0);
      var tmp116_safe_receiver = this.r1j_1;
      var tmp117_safe_receiver = tmp116_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp116_safe_receiver, element);
      if (tmp117_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        addSuppressed(tmp117_safe_receiver, this.r1k());
        throw tmp117_safe_receiver;
      }
      throw this.r1k();
    }
  }
  z1l(element) {
    return trySendImpl(this, element, false);
  }
}
class SegmentOrClosed {
  constructor(value) {
    this.w1l_1 = value;
  }
  toString() {
    return SegmentOrClosed__toString_impl_pzb2an(this.w1l_1);
  }
  hashCode() {
    return SegmentOrClosed__hashCode_impl_4855hs(this.w1l_1);
  }
  equals(other) {
    return SegmentOrClosed__equals_impl_6erq1g(this.w1l_1, other);
  }
}
class ExceptionSuccessfullyProcessed extends Exception {}
class DispatchedContinuation extends DispatchedTask {
  constructor(dispatcher, continuation) {
    super(-1);
    this.o1a_1 = dispatcher;
    this.p1a_1 = continuation;
    this.q1a_1 = get_UNDEFINED();
    this.r1a_1 = threadContextElements(this.zc());
    this.s1a_1 = atomic$ref$1(null);
  }
  zc() {
    return this.p1a_1.zc();
  }
  v1a() {
    return !(this.s1a_1.kotlinx$atomicfu$value == null);
  }
  i1n() {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.s1a_1;
    while (true) {
      // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.awaitReusability.<anonymous>' call
      if (!(this_0.kotlinx$atomicfu$value === get_REUSABLE_CLAIMED()))
        return Unit_instance;
    }
  }
  t1d() {
    this.i1n();
    var tmp148_safe_receiver = _get_reusableCancellableContinuation__9qex09(this);
    if (tmp148_safe_receiver == null)
      null;
    else {
      tmp148_safe_receiver.q1b();
    }
  }
  t1a() {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.s1a_1;
    while (true) {
      // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.claimReusableCancellableContinuation.<anonymous>' call
      var state = this_0.kotlinx$atomicfu$value;
      if (state === null) {
        this.s1a_1.kotlinx$atomicfu$value = get_REUSABLE_CLAIMED();
        return null;
      } else {
        if (state instanceof CancellableContinuationImpl) {
          if (this.s1a_1.atomicfu$compareAndSet(state, get_REUSABLE_CLAIMED())) {
            return state instanceof CancellableContinuationImpl ? state : THROW_CCE();
          }
        } else {
          if (state !== get_REUSABLE_CLAIMED()) {
            if (!(state instanceof Error)) {
              var message = 'Inconsistent state ' + toString_0(state);
              throw IllegalStateException.h5(toString(message));
            }
          }
        }
      }
    }
  }
  c1c(continuation) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.s1a_1;
    while (true) {
      // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.tryReleaseClaimedContinuation.<anonymous>' call
      var state = this_0.kotlinx$atomicfu$value;
      if (state === get_REUSABLE_CLAIMED()) {
        if (this.s1a_1.atomicfu$compareAndSet(get_REUSABLE_CLAIMED(), continuation))
          return null;
      } else {
        if (state instanceof Error) {
          // Inline function 'kotlin.require' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'kotlin.require' call
          // Inline function 'kotlin.contracts.contract' call
          if (!this.s1a_1.atomicfu$compareAndSet(state, null)) {
            // Inline function 'kotlin.require.<anonymous>' call
            var message = 'Failed requirement.';
            throw IllegalArgumentException.l(toString(message));
          }
          return state;
        } else {
          var message_0 = 'Inconsistent state ' + toString_0(state);
          throw IllegalStateException.h5(toString(message_0));
        }
      }
    }
  }
  x1a(cause) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.s1a_1;
    while (true) {
      // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.postponeCancellation.<anonymous>' call
      var state = this_0.kotlinx$atomicfu$value;
      if (equals(state, get_REUSABLE_CLAIMED())) {
        if (this.s1a_1.atomicfu$compareAndSet(get_REUSABLE_CLAIMED(), cause))
          return true;
      } else {
        if (state instanceof Error)
          return true;
        else {
          if (this.s1a_1.atomicfu$compareAndSet(state, null))
            return false;
        }
      }
    }
  }
  t1b() {
    var state = this.q1a_1;
    // Inline function 'kotlinx.coroutines.assert' call
    this.q1a_1 = get_UNDEFINED();
    return state;
  }
  r1b() {
    return this;
  }
  bd(result) {
    var state = toState_0(result);
    if (this.o1a_1.q1d(this.zc())) {
      this.q1a_1 = state;
      this.w1a_1 = 0;
      this.o1a_1.r1d(this.zc(), this);
    } else {
      $l$block: {
        // Inline function 'kotlinx.coroutines.internal.executeUnconfined' call
        // Inline function 'kotlinx.coroutines.assert' call
        var eventLoop = ThreadLocalEventLoop_getInstance().t1e();
        if (false && eventLoop.o1e()) {
          break $l$block;
        }
        var tmp;
        if (eventLoop.n1e()) {
          this.q1a_1 = state;
          this.w1a_1 = 0;
          eventLoop.m1e(this);
          tmp = true;
        } else {
          // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
          eventLoop.p1e(true);
          try {
            // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeWith.<anonymous>' call
            // Inline function 'kotlinx.coroutines.withCoroutineContext' call
            this.zc();
            this.r1a_1;
            this.p1a_1.bd(result);
            $l$loop: while (eventLoop.l1e()) {
            }
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              this.o1c(e);
            } else {
              throw $p;
            }
          }
          finally {
            eventLoop.q1e(true);
          }
          tmp = false;
        }
      }
    }
  }
  z1i(context, value) {
    this.q1a_1 = value;
    this.w1a_1 = 1;
    this.o1a_1.s1d(context, this);
  }
  toString() {
    return 'DispatchedContinuation[' + this.o1a_1.toString() + ', ' + toDebugString(this.p1a_1) + ']';
  }
}
class UndeliveredElementException extends RuntimeException {
  static m1n(message, cause) {
    var $this = this.ke(message, cause);
    captureStack($this, $this.l1n_1);
    return $this;
  }
}
class ContextScope {
  constructor(context) {
    this.n1n_1 = context;
  }
  b17() {
    return this.n1n_1;
  }
  toString() {
    return 'CoroutineScope(coroutineContext=' + toString(this.n1n_1) + ')';
  }
}
class Symbol {
  constructor(symbol) {
    this.o1n_1 = symbol;
  }
  toString() {
    return '<' + this.o1n_1 + '>';
  }
}
class SelectInstance {}
class ClauseData {
  t1n(select, internalResult) {
    var tmp161_safe_receiver = this.s1n_1;
    return tmp161_safe_receiver == null ? null : tmp161_safe_receiver(select, this.r1n_1, internalResult);
  }
}
class SelectImplementation {
  j1l(clauseObject, result) {
    return TrySelectDetailedResult_0(trySelectInternal(this, clauseObject, result));
  }
}
class TrySelectDetailedResult extends Enum {}
class CancellableContinuationWithOwner {
  constructor($outer, cont, owner) {
    this.f1o_1 = $outer;
    this.d1o_1 = cont;
    this.e1o_1 = owner;
  }
  z19(token) {
    this.d1o_1.z19(token);
  }
  a1a(handler) {
    this.d1o_1.a1a(handler);
  }
  r1o(_this__u8e3s4, value) {
    this.d1o_1.b1a(_this__u8e3s4, Unit_instance);
  }
  b1a(_this__u8e3s4, value) {
    return this.r1o(_this__u8e3s4, value instanceof Unit ? value : THROW_CCE());
  }
  yl(result) {
    this.d1o_1.bd(result);
  }
  bd(result) {
    return this.yl(result);
  }
  zc() {
    return this.d1o_1.zc();
  }
  g1c(segment, index) {
    this.d1o_1.g1c(segment, index);
  }
  s1o(value, idempotent, onCancellation) {
    // Inline function 'kotlinx.coroutines.assert' call
    var token = this.d1o_1.y19(value, idempotent, MutexImpl$CancellableContinuationWithOwner$tryResume$lambda(this.f1o_1, this));
    if (!(token == null)) {
      // Inline function 'kotlinx.coroutines.assert' call
      this.f1o_1.b1o_1.kotlinx$atomicfu$value = this.e1o_1;
    }
    return token;
  }
  y19(value, idempotent, onCancellation) {
    return this.s1o(value instanceof Unit ? value : THROW_CCE(), idempotent, onCancellation);
  }
  t1o(value, onCancellation) {
    // Inline function 'kotlinx.coroutines.assert' call
    this.f1o_1.b1o_1.kotlinx$atomicfu$value = this.e1o_1;
    this.d1o_1.e1c(Unit_instance, MutexImpl$CancellableContinuationWithOwner$resume$lambda(this.f1o_1, this));
  }
  c1a(value, onCancellation) {
    return this.t1o(value instanceof Unit ? value : THROW_CCE(), onCancellation);
  }
}
class SemaphoreAndMutexImpl {
  constructor(permits, acquiredPermits) {
    this.j1o_1 = permits;
    this.l1o_1 = atomic$long$1(new Long(0, 0));
    this.n1o_1 = atomic$long$1(new Long(0, 0));
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.j1o_1 > 0)) {
      // Inline function 'kotlinx.coroutines.sync.SemaphoreAndMutexImpl.<anonymous>' call
      var message = 'Semaphore should have at least 1 permit, but had ' + this.j1o_1;
      throw IllegalArgumentException.l(toString(message));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(0 <= acquiredPermits ? acquiredPermits <= this.j1o_1 : false)) {
      // Inline function 'kotlinx.coroutines.sync.SemaphoreAndMutexImpl.<anonymous>' call
      var message_0 = 'The number of acquired permits should be in 0..' + this.j1o_1;
      throw IllegalArgumentException.l(toString(message_0));
    }
    var s = new SemaphoreSegment(new Long(0, 0), null, 2);
    this.k1o_1 = atomic$ref$1(s);
    this.m1o_1 = atomic$ref$1(s);
    this.o1o_1 = atomic$int$1(this.j1o_1 - acquiredPermits | 0);
    var tmp = this;
    tmp.p1o_1 = SemaphoreAndMutexImpl$onCancellationRelease$lambda(this);
  }
  u1o() {
    // Inline function 'kotlin.math.max' call
    var a = this.o1o_1.kotlinx$atomicfu$value;
    return Math.max(a, 0);
  }
  q1o() {
    $l$loop: while (true) {
      var p = this.o1o_1.kotlinx$atomicfu$value;
      if (p > this.j1o_1) {
        coerceAvailablePermitsAtMaximum(this);
        continue $l$loop;
      }
      if (p <= 0)
        return false;
      if (this.o1o_1.atomicfu$compareAndSet(p, p - 1 | 0))
        return true;
    }
  }
  acquireCont(waiter) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlinx.coroutines.sync.SemaphoreAndMutexImpl.acquire' call
      while (true) {
        var p = decPermits(this);
        if (p > 0) {
          // Inline function 'kotlinx.coroutines.sync.SemaphoreAndMutexImpl.acquire.<anonymous>' call
          waiter.c1a(Unit_instance, this.p1o_1);
          tmp$ret$0 = Unit_instance;
          break $l$block_0;
        }
        // Inline function 'kotlinx.coroutines.sync.SemaphoreAndMutexImpl.acquire.<anonymous>' call
        if (addAcquireToQueue(this, isInterface(waiter, Waiter) ? waiter : THROW_CCE())) {
          tmp$ret$0 = Unit_instance;
          break $l$block_0;
        }
      }
    }
    return tmp$ret$0;
  }
  w1o() {
    while (true) {
      var p = this.o1o_1.atomicfu$getAndIncrement();
      if (p >= this.j1o_1) {
        coerceAvailablePermitsAtMaximum(this);
        // Inline function 'kotlin.error' call
        var message = 'The number of released permits cannot be greater than ' + this.j1o_1;
        throw IllegalStateException.h5(toString(message));
      }
      if (p >= 0)
        return Unit_instance;
      if (tryResumeNextFromQueue(this))
        return Unit_instance;
    }
  }
}
class MutexImpl extends SemaphoreAndMutexImpl {
  constructor(locked) {
    super(1, locked ? 1 : 0);
    this.b1o_1 = atomic$ref$1(locked ? null : get_NO_OWNER());
    var tmp = this;
    tmp.c1o_1 = MutexImpl$onSelectCancellationUnlockConstructor$lambda(this);
  }
  h1o() {
    return this.u1o() === 0;
  }
  v1o(owner, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_lock__qllepv.bind(VOID, this, owner), $completion);
  }
  i1o(owner) {
    var tmp;
    switch (tryLockImpl(this, owner)) {
      case 0:
        tmp = true;
        break;
      case 1:
        tmp = false;
        break;
      case 2:
        var message = 'This mutex is already locked by the specified owner: ' + toString_0(owner);
        throw IllegalStateException.h5(toString(message));
      default:
        var message_0 = 'unexpected';
        throw IllegalStateException.h5(toString(message_0));
    }
    return tmp;
  }
  g1o(owner) {
    $l$loop_0: while (true) {
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!this.h1o()) {
        // Inline function 'kotlinx.coroutines.sync.MutexImpl.unlock.<anonymous>' call
        var message = 'This mutex is not locked';
        throw IllegalStateException.h5(toString(message));
      }
      var curOwner = this.b1o_1.kotlinx$atomicfu$value;
      if (curOwner === get_NO_OWNER())
        continue $l$loop_0;
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(curOwner === owner || owner == null)) {
        // Inline function 'kotlinx.coroutines.sync.MutexImpl.unlock.<anonymous>' call
        var message_0 = 'This mutex is locked by ' + toString_0(curOwner) + ', but ' + toString_0(owner) + ' is expected';
        throw IllegalStateException.h5(toString(message_0));
      }
      if (!this.b1o_1.atomicfu$compareAndSet(curOwner, get_NO_OWNER()))
        continue $l$loop_0;
      this.w1o();
      return Unit_instance;
    }
  }
  toString() {
    return 'Mutex@' + get_hexAddress(this) + '[isLocked=' + this.h1o() + ',owner=' + toString_0(this.b1o_1.kotlinx$atomicfu$value) + ']';
  }
}
class SemaphoreSegment extends Segment {
  constructor(id, prev, pointers) {
    super(id, prev, pointers);
    this.b1p_1 = atomicfu$AtomicRefArray$ofNulls(get_SEGMENT_SIZE_0());
  }
  h1j() {
    return get_SEGMENT_SIZE_0();
  }
  c1b(index, cause, context) {
    // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.set' call
    var value = get_CANCELLED();
    this.b1p_1.atomicfu$get(index).kotlinx$atomicfu$value = value;
    this.e1k();
  }
  toString() {
    return 'SemaphoreSegment[id=' + this.a1b_1.toString() + ', hashCode=' + hashCode(this) + ']';
  }
}
class SetTimeoutBasedDispatcher extends CoroutineDispatcher {
  static h1p() {
    var $this = this.p1d();
    $this.g1p_1 = new ScheduledMessageQueue($this);
    return $this;
  }
  r1d(context, block) {
    this.g1p_1.d1q(block);
  }
  e1e(timeMillis, block, context) {
    var handle = w3cSetTimeout(SetTimeoutBasedDispatcher$invokeOnTimeout$lambda(block), delayToInt(timeMillis));
    return new ClearTimeout(handle);
  }
  d1e(timeMillis, continuation) {
    var handle = w3cSetTimeout(SetTimeoutBasedDispatcher$scheduleResumeAfterDelay$lambda(continuation, this), delayToInt(timeMillis));
    invokeOnCancellation(continuation, new ClearTimeout(handle));
  }
}
class NodeDispatcher extends SetTimeoutBasedDispatcher {
  static e1p() {
    NodeDispatcher_instance = null;
    var $this = this.h1p();
    NodeDispatcher_instance = $this;
    return $this;
  }
  i1p() {
    process.nextTick(this.g1p_1.n1p_1);
  }
}
class MessageQueue {
  constructor() {
    this.o1p_1 = ArrayDeque.pk();
    this.p1p_1 = 16;
    this.q1p_1 = false;
  }
  v1p(element) {
    return this.o1p_1.h(element);
  }
  h(element) {
    return this.v1p((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  }
  w1p(elements) {
    return this.o1p_1.g1(elements);
  }
  g1(elements) {
    return this.w1p(elements);
  }
  k3() {
    this.o1p_1.k3();
  }
  a3() {
    return this.o1p_1.a3();
  }
  b3(index) {
    return this.o1p_1.b3(index);
  }
  x1p(element) {
    return this.o1p_1.m3(element);
  }
  m3(element) {
    if (!(!(element == null) ? isInterface(element, Runnable) : false))
      return false;
    return this.x1p((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  }
  y1p(elements) {
    return this.o1p_1.n3(elements);
  }
  n3(elements) {
    return this.y1p(elements);
  }
  p3(index) {
    return this.o1p_1.p3(index);
  }
  z1p(index, element) {
    return this.o1p_1.o3(index, element);
  }
  o3(index, element) {
    return this.z1p(index, (!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  }
  c3(fromIndex, toIndex) {
    return this.o1p_1.c3(fromIndex, toIndex);
  }
  a1q(element) {
    return this.o1p_1.x2(element);
  }
  x2(element) {
    if (!(!(element == null) ? isInterface(element, Runnable) : false))
      return false;
    return this.a1q((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  }
  b1q(elements) {
    return this.o1p_1.y2(elements);
  }
  y2(elements) {
    return this.b1q(elements);
  }
  e1(index) {
    return this.o1p_1.e1(index);
  }
  c1q(element) {
    return this.o1p_1.z2(element);
  }
  z2(element) {
    if (!(!(element == null) ? isInterface(element, Runnable) : false))
      return -1;
    return this.c1q((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  }
  h1() {
    return this.o1p_1.h1();
  }
  b1() {
    return this.o1p_1.b1();
  }
  f1() {
    return this.o1p_1.mk_1;
  }
  d1q(element) {
    this.v1p(element);
    if (!this.q1p_1) {
      this.q1p_1 = true;
      this.s1p();
    }
  }
  r1p() {
    try {
      // Inline function 'kotlin.repeat' call
      var times = this.p1p_1;
      // Inline function 'kotlin.contracts.contract' call
      var inductionVariable = 0;
      if (inductionVariable < times)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlinx.coroutines.MessageQueue.process.<anonymous>' call
          var tmp0_elvis_lhs = removeFirstOrNull(this);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            return Unit_instance;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var element = tmp;
          element.n1c();
        }
         while (inductionVariable < times);
    }finally {
      if (this.h1()) {
        this.q1p_1 = false;
      } else {
        this.t1p();
      }
    }
  }
}
class ScheduledMessageQueue extends MessageQueue {
  constructor(dispatcher) {
    super();
    this.m1p_1 = dispatcher;
    var tmp = this;
    tmp.n1p_1 = ScheduledMessageQueue$processQueue$lambda(this);
  }
  s1p() {
    this.m1p_1.i1p();
  }
  t1p() {
    setTimeout(this.n1p_1, 0);
  }
  u1p(timeout) {
    setTimeout(this.n1p_1, timeout);
  }
}
class WindowMessageQueue extends MessageQueue {
  constructor(window_0) {
    super();
    this.h1q_1 = window_0;
    this.i1q_1 = 'dispatchCoroutine';
    this.h1q_1.addEventListener('message', WindowMessageQueue$lambda(this), true);
  }
  s1p() {
    var tmp = Promise.resolve(Unit_instance);
    tmp.then(WindowMessageQueue$schedule$lambda(this));
  }
  t1p() {
    this.h1q_1.postMessage(this.i1q_1, '*');
  }
}
class asDeferred$slambda {
  constructor($this_asDeferred) {
    this.j1q_1 = $this_asDeferred;
  }
  k1q($this$async, $completion) {
    return await_0(this.j1q_1, $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class UnconfinedEventLoop extends EventLoop {
  static t1q() {
    return this.k1e();
  }
  r1d(context, block) {
    unsupported();
  }
}
class SetTimeoutDispatcher extends SetTimeoutBasedDispatcher {
  static w1q() {
    SetTimeoutDispatcher_instance = null;
    var $this = this.h1p();
    SetTimeoutDispatcher_instance = $this;
    return $this;
  }
  i1p() {
    this.g1p_1.u1p(0);
  }
}
class ClearTimeout {
  constructor(handle, $box) {
    boxApply(this, $box);
    this.z1q_1 = handle;
  }
  m1a() {
    w3cClearTimeout_0(this.z1q_1);
  }
  l1a(cause) {
    this.m1a();
  }
  toString() {
    return 'ClearTimeout[' + this.z1q_1 + ']';
  }
}
class WindowClearTimeout extends ClearTimeout {
  constructor($outer, handle, $box) {
    if ($box === VOID)
      $box = {};
    $box.y1q_1 = $outer;
    super(handle, $box);
  }
  m1a() {
    w3cClearTimeout(this.y1q_1.m1q_1, this.z1q_1);
  }
}
class WindowDispatcher extends CoroutineDispatcher {
  static o1q(window_0) {
    var $this = this.p1d();
    $this.m1q_1 = window_0;
    $this.n1q_1 = new WindowMessageQueue($this.m1q_1);
    return $this;
  }
  r1d(context, block) {
    return this.n1q_1.d1q(block);
  }
  d1e(timeMillis, continuation) {
    var handle = w3cSetTimeout_0(this.m1q_1, WindowDispatcher$scheduleResumeAfterDelay$lambda(continuation, this), delayToInt(timeMillis));
    invokeOnCancellation(continuation, new WindowClearTimeout(this, handle));
  }
  e1e(timeMillis, block, context) {
    var handle = w3cSetTimeout_0(this.m1q_1, Runnable$run$ref(block), delayToInt(timeMillis));
    return new WindowClearTimeout(this, handle);
  }
}
class UndispatchedCoroutine extends ScopeCoroutine {
  l17(state) {
    return this.p19_1.bd(recoverResult(state, this.p19_1));
  }
}
class Dispatchers {
  constructor() {
    Dispatchers_instance = this;
    this.y1d_1 = createDefaultDispatcher();
    this.z1d_1 = Unconfined_getInstance();
    this.a1e_1 = JsMainDispatcher.i1r(this.y1d_1, false);
    this.b1e_1 = null;
  }
  c1e() {
    var tmp0_elvis_lhs = this.b1e_1;
    return tmp0_elvis_lhs == null ? this.a1e_1 : tmp0_elvis_lhs;
  }
}
class JsMainDispatcher extends MainCoroutineDispatcher {
  static i1r(delegate, invokeImmediately) {
    var $this = this.b1i();
    $this.f1r_1 = delegate;
    $this.g1r_1 = invokeImmediately;
    $this.h1r_1 = $this.g1r_1 ? $this : JsMainDispatcher.i1r($this.f1r_1, true);
    return $this;
  }
  c1i() {
    return this.h1r_1;
  }
  q1d(context) {
    return !this.g1r_1;
  }
  r1d(context, block) {
    return this.f1r_1.r1d(context, block);
  }
  s1d(context, block) {
    return this.f1r_1.s1d(context, block);
  }
  toString() {
    var tmp0_elvis_lhs = this.d1i();
    return tmp0_elvis_lhs == null ? this.f1r_1.toString() : tmp0_elvis_lhs;
  }
}
class JobCancellationException extends CancellationException {
  static d1g(message, cause, job) {
    var $this = this.vd(message, cause);
    captureStack($this, $this.c1g_1);
    $this.b1g_1 = job;
    return $this;
  }
  toString() {
    return super.toString() + '; job=' + toString(this.b1g_1);
  }
  equals(other) {
    var tmp;
    if (other === this) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      if (other instanceof JobCancellationException) {
        tmp_2 = other.message == this.message;
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = equals(other.b1g_1, this.b1g_1);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = equals(other.cause, this.cause);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  hashCode() {
    var tmp = imul(imul(getStringHashCode(ensureNotNull(this.message)), 31) + hashCode(this.b1g_1) | 0, 31);
    var tmp0_safe_receiver = this.cause;
    var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp + (tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs) | 0;
  }
}
class DiagnosticCoroutineContextException extends RuntimeException {
  static h1n(context) {
    var $this = this.wa(toString(context));
    captureStack($this, $this.g1n_1);
    return $this;
  }
}
class ListClosed extends LockFreeLinkedListNode {
  constructor(forbiddenElementsBitmask) {
    super();
    this.m1r_1 = forbiddenElementsBitmask;
  }
}
class CommonThreadLocal {
  constructor() {
    this.u1e_1 = null;
  }
  v1e() {
    var tmp = this.u1e_1;
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  }
  w1e(value) {
    this.u1e_1 = value;
  }
}
//endregion
function launch(_this__u8e3s4, context, start, block) {
  context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
  start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
  var newContext = newCoroutineContext(_this__u8e3s4, context);
  var coroutine = start.y18() ? new LazyStandaloneCoroutine(newContext, block) : new StandaloneCoroutine(newContext, true);
  coroutine.p17(start, coroutine, block);
  return coroutine;
}
function withContext(context, block, $completion) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlinx.coroutines.withContext.<anonymous>' call
    var oldContext = $completion.zc();
    var newContext = newCoroutineContext_0(oldContext, context);
    ensureActive(newContext);
    if (newContext === oldContext) {
      var coroutine = new ScopeCoroutine(newContext, $completion);
      tmp$ret$0 = startUndispatchedOrReturn(coroutine, coroutine, block);
      break $l$block_0;
    }
    if (equals(newContext.md(Key_instance), oldContext.md(Key_instance))) {
      var coroutine_0 = new UndispatchedCoroutine(newContext, $completion);
      // Inline function 'kotlinx.coroutines.withCoroutineContext' call
      coroutine_0.a17_1;
      tmp$ret$0 = startUndispatchedOrReturn(coroutine_0, coroutine_0, block);
      break $l$block_0;
    }
    var coroutine_1 = new DispatchedCoroutine(newContext, $completion);
    startCoroutineCancellable(block, coroutine_1, coroutine_1);
    tmp$ret$0 = coroutine_1.e19();
  }
  return tmp$ret$0;
}
function trySuspend($this) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.d19_1;
  while (true) {
    // Inline function 'kotlinx.coroutines.DispatchedCoroutine.trySuspend.<anonymous>' call
    switch (this_0.kotlinx$atomicfu$value) {
      case 0:
        if ($this.d19_1.atomicfu$compareAndSet(0, 1))
          return true;
        break;
      case 2:
        return false;
      default:
        // Inline function 'kotlin.error' call

        var message = 'Already suspended';
        throw IllegalStateException.h5(toString(message));
    }
  }
}
function tryResume($this) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.d19_1;
  while (true) {
    // Inline function 'kotlinx.coroutines.DispatchedCoroutine.tryResume.<anonymous>' call
    switch (this_0.kotlinx$atomicfu$value) {
      case 0:
        if ($this.d19_1.atomicfu$compareAndSet(0, 2))
          return true;
        break;
      case 1:
        return false;
      default:
        // Inline function 'kotlin.error' call

        var message = 'Already resumed';
        throw IllegalStateException.h5(toString(message));
    }
  }
}
function async(_this__u8e3s4, context, start, block) {
  context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
  start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
  var newContext = newCoroutineContext(_this__u8e3s4, context);
  var coroutine = start.y18() ? new LazyDeferredCoroutine(newContext, block) : new DeferredCoroutine(newContext, true);
  coroutine.p17(start, coroutine, block);
  return coroutine;
}
function *_generator_await__mos7q6($this, $completion) {
  var tmp = $this.x18($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp;
  return (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
}
function disposeOnCancellation(_this__u8e3s4, handle) {
  return invokeOnCancellation(_this__u8e3s4, new DisposeOnCancel(handle));
}
function invokeOnCancellation(_this__u8e3s4, handler) {
  var tmp;
  if (_this__u8e3s4 instanceof CancellableContinuationImpl) {
    _this__u8e3s4.j1a(handler);
    tmp = Unit_instance;
  } else {
    throw UnsupportedOperationException.la('third-party implementation of CancellableContinuation is not supported');
  }
  return tmp;
}
function getOrCreateCancellableContinuation(delegate) {
  if (!(delegate instanceof DispatchedContinuation)) {
    return new CancellableContinuationImpl(delegate, 1);
  }
  var tmp4_safe_receiver = delegate.t1a();
  var tmp;
  if (tmp4_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp_0;
    // Inline function 'kotlinx.coroutines.getOrCreateCancellableContinuation.<anonymous>' call
    if (tmp4_safe_receiver.u1a()) {
      tmp_0 = tmp4_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var tmp0_elvis_lhs = tmp;
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    return new CancellableContinuationImpl(delegate, 2);
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  return tmp_1;
}
function get_RESUME_TOKEN() {
  _init_properties_CancellableContinuationImpl_kt__6rrtdd();
  return RESUME_TOKEN;
}
var RESUME_TOKEN;
function _get_parentHandle__f8dcex($this) {
  return $this.i1a_1.kotlinx$atomicfu$value;
}
function _get_stateDebugRepresentation__bf18u4($this) {
  var tmp5_subject = $this.v17();
  var tmp;
  if (!(tmp5_subject == null) ? isInterface(tmp5_subject, NotCompleted) : false) {
    tmp = 'Active';
  } else {
    if (tmp5_subject instanceof CancelledContinuation) {
      tmp = 'Cancelled';
    } else {
      tmp = 'Completed';
    }
  }
  return tmp;
}
function isReusable($this) {
  var tmp;
  if (get_isReusableMode($this.w1a_1)) {
    var tmp_0 = $this.e1a_1;
    tmp = (tmp_0 instanceof DispatchedContinuation ? tmp_0 : THROW_CCE()).v1a();
  } else {
    tmp = false;
  }
  return tmp;
}
function cancelLater($this, cause) {
  if (!isReusable($this))
    return false;
  var tmp = $this.e1a_1;
  var dispatched = tmp instanceof DispatchedContinuation ? tmp : THROW_CCE();
  return dispatched.x1a(cause);
}
function callSegmentOnCancellation($this, segment, cause) {
  // Inline function 'kotlinx.coroutines.index' call
  var index = $this.g1a_1.kotlinx$atomicfu$value & 536870911;
  // Inline function 'kotlin.check' call
  // Inline function 'kotlin.contracts.contract' call
  if (!!(index === 536870911)) {
    // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.callSegmentOnCancellation.<anonymous>' call
    var message = 'The index for Segment.onCancellation(..) is broken';
    throw IllegalStateException.h5(toString(message));
  }
  // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.callCancelHandlerSafely' call
  try {
    // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.callSegmentOnCancellation.<anonymous>' call
    segment.c1b(index, cause, $this.zc());
  } catch ($p) {
    if ($p instanceof Error) {
      var ex = $p;
      handleCoroutineException($this.zc(), CompletionHandlerException.g1b('Exception in invokeOnCancellation handler for ' + $this.toString(), ex));
    } else {
      throw $p;
    }
  }
}
function trySuspend_0($this) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.g1a_1;
  while (true) {
    // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.trySuspend.<anonymous>' call
    var cur = this_0.kotlinx$atomicfu$value;
    // Inline function 'kotlinx.coroutines.decision' call
    switch (cur >> 29) {
      case 0:
        // Inline function 'kotlinx.coroutines.decisionAndIndex' call

        // Inline function 'kotlinx.coroutines.index' call

        var tmp$ret$2 = (1 << 29) + (cur & 536870911) | 0;
        if ($this.g1a_1.atomicfu$compareAndSet(cur, tmp$ret$2))
          return true;
        break;
      case 2:
        return false;
      default:
        // Inline function 'kotlin.error' call

        var message = 'Already suspended';
        throw IllegalStateException.h5(toString(message));
    }
  }
}
function tryResume_0($this) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.g1a_1;
  while (true) {
    // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.tryResume.<anonymous>' call
    var cur = this_0.kotlinx$atomicfu$value;
    // Inline function 'kotlinx.coroutines.decision' call
    switch (cur >> 29) {
      case 0:
        // Inline function 'kotlinx.coroutines.decisionAndIndex' call

        // Inline function 'kotlinx.coroutines.index' call

        var tmp$ret$2 = (2 << 29) + (cur & 536870911) | 0;
        if ($this.g1a_1.atomicfu$compareAndSet(cur, tmp$ret$2))
          return true;
        break;
      case 1:
        return false;
      default:
        // Inline function 'kotlin.error' call

        var message = 'Already resumed';
        throw IllegalStateException.h5(toString(message));
    }
  }
}
function installParentHandle($this) {
  var tmp0_elvis_lhs = $this.zc().md(Key_instance_3);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var parent = tmp;
  var handle = invokeOnCompletion(parent, VOID, new ChildContinuation($this));
  $this.i1a_1.atomicfu$compareAndSet(null, handle);
  return handle;
}
function invokeOnCancellationImpl($this, handler) {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.h1a_1;
  while (true) {
    // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.invokeOnCancellationImpl.<anonymous>' call
    var state = this_0.kotlinx$atomicfu$value;
    if (state instanceof Active) {
      if ($this.h1a_1.atomicfu$compareAndSet(state, handler))
        return Unit_instance;
    } else {
      var tmp;
      if (!(state == null) ? isInterface(state, CancelHandler) : false) {
        tmp = true;
      } else {
        tmp = state instanceof Segment;
      }
      if (tmp) {
        multipleHandlersError($this, handler, state);
      } else {
        if (state instanceof CompletedExceptionally) {
          if (!state.p1b()) {
            multipleHandlersError($this, handler, state);
          }
          if (state instanceof CancelledContinuation) {
            var tmp13_safe_receiver = state instanceof CompletedExceptionally ? state : null;
            var cause = tmp13_safe_receiver == null ? null : tmp13_safe_receiver.h17_1;
            if (isInterface(handler, CancelHandler)) {
              $this.m1b(handler, cause);
            } else {
              var segment = handler instanceof Segment ? handler : THROW_CCE();
              callSegmentOnCancellation($this, segment, cause);
            }
          }
          return Unit_instance;
        } else {
          if (state instanceof CompletedContinuation) {
            if (!(state.i1b_1 == null)) {
              multipleHandlersError($this, handler, state);
            }
            if (handler instanceof Segment)
              return Unit_instance;
            if (!isInterface(handler, CancelHandler))
              THROW_CCE();
            if (state.n1b()) {
              $this.m1b(handler, state.l1b_1);
              return Unit_instance;
            }
            var update = state.o1b(VOID, handler);
            if ($this.h1a_1.atomicfu$compareAndSet(state, update))
              return Unit_instance;
          } else {
            if (handler instanceof Segment)
              return Unit_instance;
            if (!isInterface(handler, CancelHandler))
              THROW_CCE();
            var update_0 = new CompletedContinuation(state, handler);
            if ($this.h1a_1.atomicfu$compareAndSet(state, update_0))
              return Unit_instance;
          }
        }
      }
    }
  }
}
function multipleHandlersError($this, handler, state) {
  // Inline function 'kotlin.error' call
  var message = "It's prohibited to register multiple handlers, tried to register " + toString(handler) + ', already has ' + toString_0(state);
  throw IllegalStateException.h5(toString(message));
}
function dispatchResume($this, mode) {
  if (tryResume_0($this))
    return Unit_instance;
  dispatch($this, mode);
}
function resumedState($this, state, proposedUpdate, resumeMode, onCancellation, idempotent) {
  var tmp;
  if (proposedUpdate instanceof CompletedExceptionally) {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    tmp = proposedUpdate;
  } else {
    if (!get_isCancellableMode(resumeMode) && idempotent == null) {
      tmp = proposedUpdate;
    } else {
      var tmp_0;
      var tmp_1;
      if (!(onCancellation == null)) {
        tmp_1 = true;
      } else {
        tmp_1 = isInterface(state, CancelHandler);
      }
      if (tmp_1) {
        tmp_0 = true;
      } else {
        tmp_0 = !(idempotent == null);
      }
      if (tmp_0) {
        tmp = new CompletedContinuation(proposedUpdate, isInterface(state, CancelHandler) ? state : null, onCancellation, idempotent);
      } else {
        tmp = proposedUpdate;
      }
    }
  }
  return tmp;
}
function tryResumeImpl($this, proposedUpdate, idempotent, onCancellation) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.h1a_1;
  while (true) {
    $l$block: {
      // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.tryResumeImpl.<anonymous>' call
      var state = this_0.kotlinx$atomicfu$value;
      if (!(state == null) ? isInterface(state, NotCompleted) : false) {
        var update = resumedState($this, state, proposedUpdate, $this.w1a_1, onCancellation, idempotent);
        if (!$this.h1a_1.atomicfu$compareAndSet(state, update)) {
          break $l$block;
        }
        detachChildIfNonResuable($this);
        return get_RESUME_TOKEN();
      } else {
        if (state instanceof CompletedContinuation) {
          var tmp;
          if (!(idempotent == null) && state.k1b_1 === idempotent) {
            // Inline function 'kotlinx.coroutines.assert' call
            tmp = get_RESUME_TOKEN();
          } else {
            tmp = null;
          }
          return tmp;
        } else {
          return null;
        }
      }
    }
  }
}
function alreadyResumedError($this, proposedUpdate) {
  // Inline function 'kotlin.error' call
  var message = 'Already resumed, but proposed with update ' + toString_0(proposedUpdate);
  throw IllegalStateException.h5(toString(message));
}
function detachChildIfNonResuable($this) {
  if (!isReusable($this)) {
    $this.q1b();
  }
}
function CancellableContinuationImpl$resume$lambda($onCancellation) {
  return function (cause, _unused_var__etf5q3, _unused_var__etf5q3_0) {
    $onCancellation(cause);
    return Unit_instance;
  };
}
var Active_instance;
function Active_getInstance() {
  return Active_instance;
}
var properties_initialized_CancellableContinuationImpl_kt_xtzb03;
function _init_properties_CancellableContinuationImpl_kt__6rrtdd() {
  if (!properties_initialized_CancellableContinuationImpl_kt_xtzb03) {
    properties_initialized_CancellableContinuationImpl_kt_xtzb03 = true;
    RESUME_TOKEN = new Symbol('RESUME_TOKEN');
  }
}
function CompletableDeferred(parent) {
  parent = parent === VOID ? null : parent;
  return new CompletableDeferredImpl(parent);
}
function completeWith(_this__u8e3s4, result) {
  // Inline function 'kotlin.fold' call
  // Inline function 'kotlin.contracts.contract' call
  var exception = Result__exceptionOrNull_impl_p6xea9(result);
  var tmp;
  if (exception == null) {
    // Inline function 'kotlinx.coroutines.completeWith.<anonymous>' call
    var tmp_0 = _Result___get_value__impl__bjfvqg(result);
    var it = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    tmp = _this__u8e3s4.k1d(it);
  } else {
    // Inline function 'kotlinx.coroutines.completeWith.<anonymous>' call
    tmp = _this__u8e3s4.j1d(exception);
  }
  return tmp;
}
function *_generator_await__mos7q6_0($this, $completion) {
  var tmp = $this.x18($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp;
  return (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
}
function toState(_this__u8e3s4, caller) {
  // Inline function 'kotlin.getOrElse' call
  // Inline function 'kotlin.contracts.contract' call
  var exception = Result__exceptionOrNull_impl_p6xea9(_this__u8e3s4);
  var tmp;
  if (exception == null) {
    var tmp_0 = _Result___get_value__impl__bjfvqg(_this__u8e3s4);
    tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
  } else {
    // Inline function 'kotlinx.coroutines.toState.<anonymous>' call
    tmp = new CompletedExceptionally(recoverStackTrace(exception, caller));
  }
  return tmp;
}
function toState_0(_this__u8e3s4) {
  // Inline function 'kotlin.getOrElse' call
  // Inline function 'kotlin.contracts.contract' call
  var exception = Result__exceptionOrNull_impl_p6xea9(_this__u8e3s4);
  var tmp;
  if (exception == null) {
    var tmp_0 = _Result___get_value__impl__bjfvqg(_this__u8e3s4);
    tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
  } else {
    // Inline function 'kotlinx.coroutines.toState.<anonymous>' call
    tmp = new CompletedExceptionally(exception);
  }
  return tmp;
}
function recoverResult(state, uCont) {
  var tmp;
  if (state instanceof CompletedExceptionally) {
    // Inline function 'kotlin.Companion.failure' call
    var exception = recoverStackTrace(state.h17_1, uCont);
    tmp = _Result___init__impl__xyqfz8(createFailure(exception));
  } else {
    // Inline function 'kotlin.Companion.success' call
    var value = (state == null ? true : !(state == null)) ? state : THROW_CCE();
    tmp = _Result___init__impl__xyqfz8(value);
  }
  return tmp;
}
function CoroutineDispatcher$Key$_init_$lambda_akl8b5(it) {
  return it instanceof CoroutineDispatcher ? it : null;
}
var Key_instance_0;
function Key_getInstance() {
  if (Key_instance_0 === VOID)
    new Key();
  return Key_instance_0;
}
function handleCoroutineException(context, exception) {
  try {
    var tmp23_safe_receiver = context.md(Key_instance_1);
    if (tmp23_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      tmp23_safe_receiver.u1d(context, exception);
      return Unit_instance;
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var t = $p;
      handleUncaughtCoroutineException(context, handlerException(exception, t));
      return Unit_instance;
    } else {
      throw $p;
    }
  }
  handleUncaughtCoroutineException(context, exception);
}
var Key_instance_1;
function Key_getInstance_0() {
  return Key_instance_1;
}
function handlerException(originalException, thrownException) {
  if (originalException === thrownException)
    return originalException;
  // Inline function 'kotlin.apply' call
  var this_0 = RuntimeException.ke('Exception while trying to handle coroutine exception', thrownException);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlinx.coroutines.handlerException.<anonymous>' call
  addSuppressed(this_0, originalException);
  return this_0;
}
var Key_instance_2;
function Key_getInstance_1() {
  return Key_instance_2;
}
function CoroutineScope_0(context) {
  return new ContextScope(!(context.md(Key_instance_3) == null) ? context : context.cn(Job_0()));
}
function coroutineScope(block, $completion) {
  // Inline function 'kotlinx.coroutines.coroutineScope.<anonymous>' call
  var coroutine = new ScopeCoroutine($completion.zc(), $completion);
  return startUndispatchedOrReturn(coroutine, coroutine, block);
}
function MainScope() {
  return new ContextScope(SupervisorJob().cn(Dispatchers_getInstance().c1e()));
}
var GlobalScope_instance;
function GlobalScope_getInstance() {
  return GlobalScope_instance;
}
var CoroutineStart_DEFAULT_instance;
var CoroutineStart_LAZY_instance;
var CoroutineStart_ATOMIC_instance;
var CoroutineStart_UNDISPATCHED_instance;
var CoroutineStart_entriesInitialized;
function CoroutineStart_initEntries() {
  if (CoroutineStart_entriesInitialized)
    return Unit_instance;
  CoroutineStart_entriesInitialized = true;
  CoroutineStart_DEFAULT_instance = new CoroutineStart('DEFAULT', 0);
  CoroutineStart_LAZY_instance = new CoroutineStart('LAZY', 1);
  CoroutineStart_ATOMIC_instance = new CoroutineStart('ATOMIC', 2);
  CoroutineStart_UNDISPATCHED_instance = new CoroutineStart('UNDISPATCHED', 3);
}
function CoroutineStart_DEFAULT_getInstance() {
  CoroutineStart_initEntries();
  return CoroutineStart_DEFAULT_instance;
}
function CoroutineStart_LAZY_getInstance() {
  CoroutineStart_initEntries();
  return CoroutineStart_LAZY_instance;
}
function CoroutineStart_UNDISPATCHED_getInstance() {
  CoroutineStart_initEntries();
  return CoroutineStart_UNDISPATCHED_instance;
}
function get_delay(_this__u8e3s4) {
  var tmp = _this__u8e3s4.md(Key_instance);
  var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, Delay) : false) ? tmp : null;
  return tmp0_elvis_lhs == null ? get_DefaultDelay() : tmp0_elvis_lhs;
}
function delay(timeMillis, $completion) {
  if (timeMillis.x1(new Long(0, 0)) <= 0)
    return Unit_instance;
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.s1b();
  // Inline function 'kotlinx.coroutines.delay.<anonymous>' call
  if (timeMillis.x1(new Long(-1, 2147483647)) < 0) {
    get_delay(cancellable.zc()).d1e(timeMillis, cancellable);
  }
  return cancellable.e19();
}
function delay_0(duration, $completion) {
  return delay(toDelayMillis(duration), $completion);
}
function toDelayMillis(_this__u8e3s4) {
  var tmp;
  switch (Duration__isPositive_impl_tvkkt2(_this__u8e3s4)) {
    case true:
      // Inline function 'kotlin.time.Companion.nanoseconds' call

      Companion_getInstance();
      var this_0 = new Long(999999, 0);
      var tmp$ret$0 = toDuration(this_0, DurationUnit_NANOSECONDS_getInstance());
      tmp = _Duration___get_inWholeMilliseconds__impl__msfiry(Duration__plus_impl_yu9v8f(_this__u8e3s4, tmp$ret$0));
      break;
    case false:
      tmp = new Long(0, 0);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function delta($this, unconfined) {
  return unconfined ? new Long(0, 1) : new Long(1, 0);
}
var ThreadLocalEventLoop_instance;
function ThreadLocalEventLoop_getInstance() {
  if (ThreadLocalEventLoop_instance === VOID)
    new ThreadLocalEventLoop();
  return ThreadLocalEventLoop_instance;
}
var Key_instance_3;
function Key_getInstance_2() {
  return Key_instance_3;
}
var NonDisposableHandle_instance;
function NonDisposableHandle_getInstance() {
  return NonDisposableHandle_instance;
}
function ensureActive(_this__u8e3s4) {
  var tmp41_safe_receiver = _this__u8e3s4.md(Key_instance_3);
  if (tmp41_safe_receiver == null)
    null;
  else {
    ensureActive_0(tmp41_safe_receiver);
  }
}
function invokeOnCompletion(_this__u8e3s4, invokeImmediately, handler) {
  invokeImmediately = invokeImmediately === VOID ? true : invokeImmediately;
  var tmp;
  if (_this__u8e3s4 instanceof JobSupport) {
    tmp = _this__u8e3s4.e18(invokeImmediately, handler);
  } else {
    var tmp_0 = handler.w1c();
    tmp = _this__u8e3s4.d18(tmp_0, invokeImmediately, JobNode$invoke$ref(handler));
  }
  return tmp;
}
function ensureActive_0(_this__u8e3s4) {
  if (!_this__u8e3s4.c17())
    throw _this__u8e3s4.z17();
}
function Job_0(parent) {
  parent = parent === VOID ? null : parent;
  return new JobImpl(parent);
}
function cancelChildren(_this__u8e3s4, cause) {
  cause = cause === VOID ? null : cause;
  var tmp42_safe_receiver = _this__u8e3s4.md(Key_instance_3);
  var tmp43_safe_receiver = tmp42_safe_receiver == null ? null : tmp42_safe_receiver.q18();
  if (tmp43_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.sequences.forEach' call
    var tmp0_iterator = tmp43_safe_receiver.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'kotlinx.coroutines.cancelChildren.<anonymous>' call
      element.i18(cause);
    }
  }
}
function cancel(_this__u8e3s4, cause) {
  cause = cause === VOID ? null : cause;
  var tmp40_safe_receiver = _this__u8e3s4.md(Key_instance_3);
  if (tmp40_safe_receiver == null)
    null;
  else {
    tmp40_safe_receiver.i18(cause);
  }
}
function disposeOnCompletion(_this__u8e3s4, handle) {
  return invokeOnCompletion(_this__u8e3s4, VOID, new DisposeOnCompletion(handle));
}
function cancelAndJoin(_this__u8e3s4, $completion) {
  _this__u8e3s4.j18();
  return _this__u8e3s4.f18($completion);
}
function JobNode$invoke$ref($boundThis) {
  var l = function (p0) {
    $boundThis.l1a(p0);
    return Unit_instance;
  };
  l.callableName = 'invoke';
  return l;
}
function get_COMPLETING_ALREADY() {
  _init_properties_JobSupport_kt__68f172();
  return COMPLETING_ALREADY;
}
var COMPLETING_ALREADY;
function get_COMPLETING_WAITING_CHILDREN() {
  _init_properties_JobSupport_kt__68f172();
  return COMPLETING_WAITING_CHILDREN;
}
var COMPLETING_WAITING_CHILDREN;
function get_COMPLETING_RETRY() {
  _init_properties_JobSupport_kt__68f172();
  return COMPLETING_RETRY;
}
var COMPLETING_RETRY;
function get_TOO_LATE_TO_CANCEL() {
  _init_properties_JobSupport_kt__68f172();
  return TOO_LATE_TO_CANCEL;
}
var TOO_LATE_TO_CANCEL;
function get_SEALED() {
  _init_properties_JobSupport_kt__68f172();
  return SEALED;
}
var SEALED;
function get_EMPTY_NEW() {
  _init_properties_JobSupport_kt__68f172();
  return EMPTY_NEW;
}
var EMPTY_NEW;
function get_EMPTY_ACTIVE() {
  _init_properties_JobSupport_kt__68f172();
  return EMPTY_ACTIVE;
}
var EMPTY_ACTIVE;
function _set_exceptionsHolder__tqm22h($this, value) {
  $this.o1f_1.kotlinx$atomicfu$value = value;
}
function _get_exceptionsHolder__nhszp($this) {
  return $this.o1f_1.kotlinx$atomicfu$value;
}
function allocateList($this) {
  return ArrayList.w(4);
}
function *_generator_invoke__zhh2q8($this, $this$sequence, $completion) {
  var state = $this.p1f_1.v17();
  if (state instanceof ChildHandleNode) {
    var tmp = $this$sequence.tl(state.u1f_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } else {
    if (!(state == null) ? isInterface(state, Incomplete) : false) {
      var tmp68_safe_receiver = state.c1d();
      if (tmp68_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListHead.forEach' call
        var cur = tmp68_safe_receiver.d1d_1;
        while (!equals(cur, tmp68_safe_receiver)) {
          // Inline function 'kotlinx.coroutines.JobSupport.<get-children>.<anonymous>.<anonymous>.<anonymous>' call
          var it = cur;
          if (it instanceof ChildHandleNode) {
            var tmp_0 = $this$sequence.tl(it.u1f_1, $completion);
            if (tmp_0 === get_COROUTINE_SUSPENDED())
              tmp_0 = yield tmp_0;
          }
          cur = cur.d1d_1;
        }
      }
    }
  }
  return Unit_instance;
}
function finalizeFinishingState($this, state, proposedUpdate) {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  var tmp46_safe_receiver = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
  var proposedException = tmp46_safe_receiver == null ? null : tmp46_safe_receiver.h17_1;
  var wasCancelling;
  // Inline function 'kotlinx.coroutines.internal.synchronized' call
  // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
  // Inline function 'kotlinx.coroutines.JobSupport.finalizeFinishingState.<anonymous>' call
  wasCancelling = state.v1f();
  var exceptions = state.w1f(proposedException);
  var finalCause = getFinalRootCause($this, state, exceptions);
  if (!(finalCause == null)) {
    addSuppressedExceptions($this, finalCause, exceptions);
  }
  var finalException = finalCause;
  var finalState = finalException == null ? proposedUpdate : finalException === proposedException ? proposedUpdate : new CompletedExceptionally(finalException);
  if (!(finalException == null)) {
    var handled = cancelParent($this, finalException) || $this.v18(finalException);
    if (handled) {
      (finalState instanceof CompletedExceptionally ? finalState : THROW_CCE()).p1b();
    }
  }
  if (!wasCancelling) {
    $this.s18(finalException);
  }
  $this.g17(finalState);
  var casSuccess = $this.v16_1.atomicfu$compareAndSet(state, boxIncomplete(finalState));
  // Inline function 'kotlinx.coroutines.assert' call
  completeStateFinalization($this, state, finalState);
  return finalState;
}
function getFinalRootCause($this, state, exceptions) {
  if (exceptions.h1()) {
    if (state.v1f()) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      return JobCancellationException.d1g(null == null ? $this.f17() : null, null, $this);
    }
    return null;
  }
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var tmp0_iterator = exceptions.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'kotlinx.coroutines.JobSupport.getFinalRootCause.<anonymous>' call
      if (!(element instanceof CancellationException)) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var firstNonCancellation = tmp$ret$2;
  if (!(firstNonCancellation == null))
    return firstNonCancellation;
  var first = exceptions.e1(0);
  if (first instanceof TimeoutCancellationException) {
    var tmp$ret$4;
    $l$block_0: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator_0 = exceptions.b1();
      while (tmp0_iterator_0.c1()) {
        var element_0 = tmp0_iterator_0.d1();
        // Inline function 'kotlinx.coroutines.JobSupport.getFinalRootCause.<anonymous>' call
        var tmp;
        if (!(element_0 === first)) {
          tmp = element_0 instanceof TimeoutCancellationException;
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$4 = element_0;
          break $l$block_0;
        }
      }
      tmp$ret$4 = null;
    }
    var detailedTimeoutException = tmp$ret$4;
    if (!(detailedTimeoutException == null))
      return detailedTimeoutException;
  }
  return first;
}
function addSuppressedExceptions($this, rootCause, exceptions) {
  if (exceptions.f1() <= 1)
    return Unit_instance;
  var seenExceptions = identitySet(exceptions.f1());
  var unwrappedCause = unwrap(rootCause);
  var _iterator__ex2g4s = exceptions.b1();
  while (_iterator__ex2g4s.c1()) {
    var exception = _iterator__ex2g4s.d1();
    var unwrapped = unwrap(exception);
    var tmp;
    var tmp_0;
    if (!(unwrapped === rootCause) && !(unwrapped === unwrappedCause)) {
      tmp_0 = !(unwrapped instanceof CancellationException);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = seenExceptions.h(unwrapped);
    } else {
      tmp = false;
    }
    if (tmp) {
      addSuppressed(rootCause, unwrapped);
    }
  }
}
function tryFinalizeSimpleState($this, state, update) {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  if (!$this.v16_1.atomicfu$compareAndSet(state, boxIncomplete(update)))
    return false;
  $this.s18(null);
  $this.g17(update);
  completeStateFinalization($this, state, update);
  return true;
}
function completeStateFinalization($this, state, update) {
  var tmp47_safe_receiver = $this.u17();
  if (tmp47_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    tmp47_safe_receiver.m1a();
    $this.t17(NonDisposableHandle_instance);
  }
  var tmp48_safe_receiver = update instanceof CompletedExceptionally ? update : null;
  var cause = tmp48_safe_receiver == null ? null : tmp48_safe_receiver.h17_1;
  if (state instanceof JobNode) {
    try {
      state.l1a(cause);
    } catch ($p) {
      if ($p instanceof Error) {
        var ex = $p;
        $this.n17(CompletionHandlerException.g1b('Exception in completion handler ' + state.toString() + ' for ' + $this.toString(), ex));
      } else {
        throw $p;
      }
    }
  } else {
    var tmp49_safe_receiver = state.c1d();
    if (tmp49_safe_receiver == null)
      null;
    else {
      notifyCompletion(tmp49_safe_receiver, $this, cause);
    }
  }
}
function notifyCancelling($this, list, cause) {
  $this.s18(cause);
  list.k1f(4);
  // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers' call
  var exception = null;
  // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListHead.forEach' call
  var cur = list.d1d_1;
  while (!equals(cur, list)) {
    // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers.<anonymous>' call
    var node = cur;
    var tmp;
    if (node instanceof JobNode) {
      // Inline function 'kotlinx.coroutines.JobSupport.notifyCancelling.<anonymous>' call
      tmp = node.w1c();
    } else {
      tmp = false;
    }
    if (tmp) {
      try {
        node.l1a(cause);
      } catch ($p) {
        if ($p instanceof Error) {
          var ex = $p;
          var tmp50_safe_receiver = exception;
          var tmp_0;
          if (tmp50_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.apply' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers.<anonymous>.<anonymous>' call
            addSuppressed(tmp50_safe_receiver, ex);
            tmp_0 = tmp50_safe_receiver;
          }
          if (tmp_0 == null) {
            // Inline function 'kotlin.run' call
            // Inline function 'kotlin.contracts.contract' call
            exception = CompletionHandlerException.g1b('Exception in completion handler ' + node.toString() + ' for ' + $this.toString(), ex);
          }
        } else {
          throw $p;
        }
      }
    }
    cur = cur.d1d_1;
  }
  var tmp51_safe_receiver = exception;
  if (tmp51_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    $this.n17(tmp51_safe_receiver);
  }
  cancelParent($this, cause);
}
function cancelParent($this, cause) {
  if ($this.t18())
    return true;
  var isCancellation = cause instanceof CancellationException;
  var parent = $this.u17();
  if (parent === null || parent === NonDisposableHandle_instance) {
    return isCancellation;
  }
  return parent.m18(cause) || isCancellation;
}
function notifyCompletion(_this__u8e3s4, $this, cause) {
  _this__u8e3s4.k1f(1);
  // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers' call
  var exception = null;
  // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListHead.forEach' call
  var cur = _this__u8e3s4.d1d_1;
  while (!equals(cur, _this__u8e3s4)) {
    // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers.<anonymous>' call
    var node = cur;
    var tmp;
    if (node instanceof JobNode) {
      // Inline function 'kotlinx.coroutines.JobSupport.notifyCompletion.<anonymous>' call
      tmp = true;
    } else {
      tmp = false;
    }
    if (tmp) {
      try {
        node.l1a(cause);
      } catch ($p) {
        if ($p instanceof Error) {
          var ex = $p;
          var tmp50_safe_receiver = exception;
          var tmp_0;
          if (tmp50_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.apply' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers.<anonymous>.<anonymous>' call
            addSuppressed(tmp50_safe_receiver, ex);
            tmp_0 = tmp50_safe_receiver;
          }
          if (tmp_0 == null) {
            // Inline function 'kotlin.run' call
            // Inline function 'kotlin.contracts.contract' call
            exception = CompletionHandlerException.g1b('Exception in completion handler ' + node.toString() + ' for ' + $this.toString(), ex);
          }
        } else {
          throw $p;
        }
      }
    }
    cur = cur.d1d_1;
  }
  var tmp51_safe_receiver = exception;
  if (tmp51_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    $this.n17(tmp51_safe_receiver);
  }
}
function startInternal($this, state) {
  if (state instanceof Empty) {
    if (state.f1f_1)
      return 0;
    if (!$this.v16_1.atomicfu$compareAndSet(state, get_EMPTY_ACTIVE()))
      return -1;
    $this.y17();
    return 1;
  } else {
    if (state instanceof InactiveNodeList) {
      if (!$this.v16_1.atomicfu$compareAndSet(state, state.e1g_1))
        return -1;
      $this.y17();
      return 1;
    } else {
      return 0;
    }
  }
}
function promoteEmptyToNodeList($this, state) {
  var list = new NodeList();
  var update = state.f1f_1 ? list : new InactiveNodeList(list);
  $this.v16_1.atomicfu$compareAndSet(state, update);
}
function promoteSingleToNodeList($this, state) {
  state.i1d(new NodeList());
  // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.nextNode' call
  var list = state.d1d_1;
  $this.v16_1.atomicfu$compareAndSet(state, list);
}
function joinInternal($this) {
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    // Inline function 'kotlinx.coroutines.JobSupport.joinInternal.<anonymous>' call
    var state = $this.v17();
    if (!(!(state == null) ? isInterface(state, Incomplete) : false))
      return false;
    if (startInternal($this, state) >= 0)
      return true;
  }
}
function joinSuspend($this, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.s1b();
  // Inline function 'kotlinx.coroutines.JobSupport.joinSuspend.<anonymous>' call
  disposeOnCancellation(cancellable, invokeOnCompletion($this, VOID, new ResumeOnCompletion(cancellable)));
  return cancellable.e19();
}
function cancelMakeCompleting($this, cause) {
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    // Inline function 'kotlinx.coroutines.JobSupport.cancelMakeCompleting.<anonymous>' call
    var state = $this.v17();
    var tmp;
    if (!(!(state == null) ? isInterface(state, Incomplete) : false)) {
      tmp = true;
    } else {
      var tmp_0;
      if (state instanceof Finishing) {
        tmp_0 = state.f1g();
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    if (tmp) {
      return get_COMPLETING_ALREADY();
    }
    var proposedUpdate = new CompletedExceptionally(createCauseException($this, cause));
    var finalState = tryMakeCompleting($this, state, proposedUpdate);
    if (!(finalState === get_COMPLETING_RETRY()))
      return finalState;
  }
}
function createCauseException($this, cause) {
  var tmp;
  if (cause == null ? true : cause instanceof Error) {
    var tmp_0;
    if (cause == null) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      tmp_0 = JobCancellationException.d1g(null == null ? $this.f17() : null, null, $this);
    } else {
      tmp_0 = cause;
    }
    tmp = tmp_0;
  } else {
    tmp = ((!(cause == null) ? isInterface(cause, ParentJob) : false) ? cause : THROW_CCE()).p18();
  }
  return tmp;
}
function makeCancelling($this, cause) {
  var causeExceptionCache = null;
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    $l$block: {
      // Inline function 'kotlinx.coroutines.JobSupport.makeCancelling.<anonymous>' call
      var state = $this.v17();
      if (state instanceof Finishing) {
        // Inline function 'kotlinx.coroutines.internal.synchronized' call
        // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
        // Inline function 'kotlinx.coroutines.JobSupport.makeCancelling.<anonymous>.<anonymous>' call
        if (state.g1g())
          return get_TOO_LATE_TO_CANCEL();
        var wasCancelling = state.v1f();
        if (!(cause == null) || !wasCancelling) {
          var tmp0_elvis_lhs = causeExceptionCache;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            var this_0 = createCauseException($this, cause);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlinx.coroutines.JobSupport.makeCancelling.<anonymous>.<anonymous>.<anonymous>' call
            causeExceptionCache = this_0;
            tmp = this_0;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var causeException = tmp;
          state.h1g(causeException);
        }
        // Inline function 'kotlin.takeIf' call
        var this_1 = state.i1g();
        // Inline function 'kotlin.contracts.contract' call
        var tmp_0;
        // Inline function 'kotlinx.coroutines.JobSupport.makeCancelling.<anonymous>.<anonymous>.<anonymous>' call
        if (!wasCancelling) {
          tmp_0 = this_1;
        } else {
          tmp_0 = null;
        }
        var notifyRootCause = tmp_0;
        if (notifyRootCause == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          notifyCancelling($this, state.l1f_1, notifyRootCause);
        }
        return get_COMPLETING_ALREADY();
      } else {
        if (!(state == null) ? isInterface(state, Incomplete) : false) {
          var tmp0_elvis_lhs_0 = causeExceptionCache;
          var tmp_1;
          if (tmp0_elvis_lhs_0 == null) {
            // Inline function 'kotlin.also' call
            var this_2 = createCauseException($this, cause);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlinx.coroutines.JobSupport.makeCancelling.<anonymous>.<anonymous>' call
            causeExceptionCache = this_2;
            tmp_1 = this_2;
          } else {
            tmp_1 = tmp0_elvis_lhs_0;
          }
          var causeException_0 = tmp_1;
          if (state.c17()) {
            if (tryMakeCancelling($this, state, causeException_0))
              return get_COMPLETING_ALREADY();
          } else {
            var finalState = tryMakeCompleting($this, state, new CompletedExceptionally(causeException_0));
            if (finalState === get_COMPLETING_ALREADY()) {
              // Inline function 'kotlin.error' call
              var message = 'Cannot happen in ' + toString(state);
              throw IllegalStateException.h5(toString(message));
            } else if (finalState === get_COMPLETING_RETRY()) {
              break $l$block;
            } else
              return finalState;
          }
        } else {
          return get_TOO_LATE_TO_CANCEL();
        }
      }
    }
  }
}
function getOrPromoteCancellingList($this, state) {
  var tmp0_elvis_lhs = state.c1d();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp_0;
    if (state instanceof Empty) {
      tmp_0 = new NodeList();
    } else {
      if (state instanceof JobNode) {
        promoteSingleToNodeList($this, state);
        tmp_0 = null;
      } else {
        var message = 'State should have list: ' + toString(state);
        throw IllegalStateException.h5(toString(message));
      }
    }
    tmp = tmp_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function tryMakeCancelling($this, state, rootCause) {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var list = tmp;
  var cancelling = new Finishing(list, false, rootCause);
  if (!$this.v16_1.atomicfu$compareAndSet(state, cancelling))
    return false;
  notifyCancelling($this, list, rootCause);
  return true;
}
function tryMakeCompleting($this, state, proposedUpdate) {
  if (!(!(state == null) ? isInterface(state, Incomplete) : false))
    return get_COMPLETING_ALREADY();
  var tmp;
  var tmp_0;
  var tmp_1;
  if (state instanceof Empty) {
    tmp_1 = true;
  } else {
    tmp_1 = state instanceof JobNode;
  }
  if (tmp_1) {
    tmp_0 = !(state instanceof ChildHandleNode);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = !(proposedUpdate instanceof CompletedExceptionally);
  } else {
    tmp = false;
  }
  if (tmp) {
    if (tryFinalizeSimpleState($this, state, proposedUpdate)) {
      return proposedUpdate;
    }
    return get_COMPLETING_RETRY();
  }
  return tryMakeCompletingSlowPath($this, state, proposedUpdate);
}
function tryMakeCompletingSlowPath($this, state, proposedUpdate) {
  var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return get_COMPLETING_RETRY();
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var list = tmp;
  var tmp1_elvis_lhs = state instanceof Finishing ? state : null;
  var finishing = tmp1_elvis_lhs == null ? new Finishing(list, false, null) : tmp1_elvis_lhs;
  var notifyRootCause;
  // Inline function 'kotlinx.coroutines.internal.synchronized' call
  // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
  if (finishing.f1g())
    return get_COMPLETING_ALREADY();
  finishing.j1g(true);
  if (!(finishing === state)) {
    if (!$this.v16_1.atomicfu$compareAndSet(state, finishing))
      return get_COMPLETING_RETRY();
  }
  // Inline function 'kotlinx.coroutines.assert' call
  var wasCancelling = finishing.v1f();
  var tmp65_safe_receiver = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
  if (tmp65_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    finishing.h1g(tmp65_safe_receiver.h17_1);
  }
  // Inline function 'kotlin.takeIf' call
  var this_0 = finishing.i1g();
  // Inline function 'kotlin.contracts.contract' call
  var tmp_0;
  // Inline function 'kotlinx.coroutines.JobSupport.tryMakeCompletingSlowPath.<anonymous>.<anonymous>' call
  if (!wasCancelling) {
    tmp_0 = this_0;
  } else {
    tmp_0 = null;
  }
  notifyRootCause = tmp_0;
  if (notifyRootCause == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    notifyCancelling($this, list, notifyRootCause);
  }
  var child = nextChild(list, $this);
  if (!(child == null) && tryWaitForChild($this, finishing, child, proposedUpdate))
    return get_COMPLETING_WAITING_CHILDREN();
  list.k1f(2);
  var anotherChild = nextChild(list, $this);
  if (!(anotherChild == null) && tryWaitForChild($this, finishing, anotherChild, proposedUpdate))
    return get_COMPLETING_WAITING_CHILDREN();
  return finalizeFinishingState($this, finishing, proposedUpdate);
}
function _get_exceptionOrNull__b3j7js(_this__u8e3s4, $this) {
  var tmp67_safe_receiver = _this__u8e3s4 instanceof CompletedExceptionally ? _this__u8e3s4 : null;
  return tmp67_safe_receiver == null ? null : tmp67_safe_receiver.h17_1;
}
function tryWaitForChild($this, state, child, proposedUpdate) {
  var $this_0 = $this;
  var state_0 = state;
  var child_0 = child;
  var proposedUpdate_0 = proposedUpdate;
  $l$1: do {
    $l$0: do {
      var handle = invokeOnCompletion(child_0.u1f_1, false, new ChildCompletion($this_0, state_0, child_0, proposedUpdate_0));
      if (!(handle === NonDisposableHandle_instance))
        return true;
      var tmp0_elvis_lhs = nextChild(child_0, $this_0);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return false;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var nextChild_0 = tmp;
      $this_0 = $this_0;
      state_0 = state_0;
      child_0 = nextChild_0;
      proposedUpdate_0 = proposedUpdate_0;
      continue $l$0;
    }
     while (false);
  }
   while (true);
}
function continueCompleting($this, state, lastChild, proposedUpdate) {
  // Inline function 'kotlinx.coroutines.assert' call
  var waitChild = nextChild(lastChild, $this);
  if (!(waitChild == null) && tryWaitForChild($this, state, waitChild, proposedUpdate))
    return Unit_instance;
  state.l1f_1.k1f(2);
  var waitChildAgain = nextChild(lastChild, $this);
  if (!(waitChildAgain == null) && tryWaitForChild($this, state, waitChildAgain, proposedUpdate)) {
    return Unit_instance;
  }
  var finalState = finalizeFinishingState($this, state, proposedUpdate);
  $this.m17(finalState);
}
function nextChild(_this__u8e3s4, $this) {
  var cur = _this__u8e3s4;
  $l$loop: while (true) {
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.isRemoved' call
    if (!cur.f1d_1) {
      break $l$loop;
    }
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.prevNode' call
    cur = cur.e1d_1;
  }
  $l$loop_0: while (true) {
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.nextNode' call
    cur = cur.d1d_1;
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.isRemoved' call
    if (cur.f1d_1)
      continue $l$loop_0;
    if (cur instanceof ChildHandleNode)
      return cur;
    if (cur instanceof NodeList)
      return null;
  }
}
function stateString($this, state) {
  var tmp;
  if (state instanceof Finishing) {
    tmp = state.v1f() ? 'Cancelling' : state.f1g() ? 'Completing' : 'Active';
  } else {
    if (!(state == null) ? isInterface(state, Incomplete) : false) {
      tmp = state.c17() ? 'Active' : 'New';
    } else {
      if (state instanceof CompletedExceptionally) {
        tmp = 'Cancelled';
      } else {
        tmp = 'Completed';
      }
    }
  }
  return tmp;
}
function awaitSuspend($this, $completion) {
  // Inline function 'kotlinx.coroutines.JobSupport.awaitSuspend.<anonymous>' call
  var cont = new AwaitContinuation(intercepted($completion), $this);
  cont.s1b();
  disposeOnCancellation(cont, invokeOnCompletion($this, VOID, new ResumeAwaitOnCompletion(cont)));
  return cont.e19();
}
function JobSupport$_get_children_$slambda_k839f8_0(this$0) {
  var i = new JobSupport$_get_children_$slambda_k839f8(this$0);
  var l = function ($this$sequence, $completion) {
    return i.a1h($this$sequence, $completion);
  };
  l.$arity = 1;
  return l;
}
function boxIncomplete(_this__u8e3s4) {
  _init_properties_JobSupport_kt__68f172();
  var tmp;
  if (!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Incomplete) : false) {
    tmp = new IncompleteStateBox(_this__u8e3s4);
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
function unboxState(_this__u8e3s4) {
  _init_properties_JobSupport_kt__68f172();
  var tmp74_safe_receiver = _this__u8e3s4 instanceof IncompleteStateBox ? _this__u8e3s4 : null;
  var tmp0_elvis_lhs = tmp74_safe_receiver == null ? null : tmp74_safe_receiver.r1h_1;
  return tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
}
function handlesExceptionF($this) {
  var tmp = $this.u17();
  var tmp75_safe_receiver = tmp instanceof ChildHandleNode ? tmp : null;
  var tmp0_elvis_lhs = tmp75_safe_receiver == null ? null : tmp75_safe_receiver.b1d();
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var parentJob = tmp_0;
  while (true) {
    if (parentJob.u18())
      return true;
    var tmp_1 = parentJob.u17();
    var tmp76_safe_receiver = tmp_1 instanceof ChildHandleNode ? tmp_1 : null;
    var tmp1_elvis_lhs = tmp76_safe_receiver == null ? null : tmp76_safe_receiver.b1d();
    var tmp_2;
    if (tmp1_elvis_lhs == null) {
      return false;
    } else {
      tmp_2 = tmp1_elvis_lhs;
    }
    parentJob = tmp_2;
  }
}
var properties_initialized_JobSupport_kt_5iq8a4;
function _init_properties_JobSupport_kt__68f172() {
  if (!properties_initialized_JobSupport_kt_5iq8a4) {
    properties_initialized_JobSupport_kt_5iq8a4 = true;
    COMPLETING_ALREADY = new Symbol('COMPLETING_ALREADY');
    COMPLETING_WAITING_CHILDREN = new Symbol('COMPLETING_WAITING_CHILDREN');
    COMPLETING_RETRY = new Symbol('COMPLETING_RETRY');
    TOO_LATE_TO_CANCEL = new Symbol('TOO_LATE_TO_CANCEL');
    SEALED = new Symbol('SEALED');
    EMPTY_NEW = new Empty(false);
    EMPTY_ACTIVE = new Empty(true);
  }
}
function SupervisorJob(parent) {
  parent = parent === VOID ? null : parent;
  return new SupervisorJobImpl(parent);
}
function withTimeout(timeMillis, block, $completion) {
  if (timeMillis.x1(new Long(0, 0)) <= 0)
    throw TimeoutCancellationException.o1i('Timed out immediately');
  // Inline function 'kotlinx.coroutines.withTimeout.<anonymous>' call
  return setupTimeout(new TimeoutCoroutine(timeMillis, $completion), block);
}
function setupTimeout(coroutine, block) {
  var cont = coroutine.p19_1;
  var context = cont.zc();
  disposeOnCompletion(coroutine, get_delay(context).e1e(coroutine.t1i_1, coroutine, coroutine.a17_1));
  return startUndispatchedOrReturnIgnoreTimeout(coroutine, coroutine, block);
}
function TimeoutCancellationException_0(time, delay, coroutine) {
  var tmp77_safe_receiver = isInterface(delay, DelayWithTimeoutDiagnostics) ? delay : null;
  var tmp;
  if (tmp77_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$0 = toDuration(time, DurationUnit_MILLISECONDS_getInstance());
    tmp = tmp77_safe_receiver.f1e(tmp$ret$0);
  }
  var tmp0_elvis_lhs = tmp;
  var message = tmp0_elvis_lhs == null ? 'Timed out waiting for ' + time.toString() + ' ms' : tmp0_elvis_lhs;
  return TimeoutCancellationException.n1i(message, coroutine);
}
var Unconfined_instance;
function Unconfined_getInstance() {
  if (Unconfined_instance === VOID)
    Unconfined.v1i();
  return Unconfined_instance;
}
var Key_instance_4;
function Key_getInstance_3() {
  return Key_instance_4;
}
function yield_0($completion) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlinx.coroutines.yield.<anonymous>' call
    var context = $completion.zc();
    ensureActive(context);
    var tmp = intercepted($completion);
    var tmp0_elvis_lhs = tmp instanceof DispatchedContinuation ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      tmp$ret$0 = Unit_instance;
      break $l$block_0;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var cont = tmp_0;
    if (cont.o1a_1.q1d(context)) {
      cont.z1i(context, Unit_instance);
    } else {
      var yieldContext = YieldContext.y1i();
      cont.z1i(context.cn(yieldContext), Unit_instance);
      if (yieldContext.x1i_1) {
        tmp$ret$0 = yieldUndispatched(cont) ? get_COROUTINE_SUSPENDED() : Unit_instance;
        break $l$block_0;
      }
    }
    tmp$ret$0 = get_COROUTINE_SUSPENDED();
  }
  return tmp$ret$0;
}
var BufferOverflow_SUSPEND_instance;
var BufferOverflow_DROP_OLDEST_instance;
var BufferOverflow_DROP_LATEST_instance;
var BufferOverflow_entriesInitialized;
function BufferOverflow_initEntries() {
  if (BufferOverflow_entriesInitialized)
    return Unit_instance;
  BufferOverflow_entriesInitialized = true;
  BufferOverflow_SUSPEND_instance = new BufferOverflow('SUSPEND', 0);
  BufferOverflow_DROP_OLDEST_instance = new BufferOverflow('DROP_OLDEST', 1);
  BufferOverflow_DROP_LATEST_instance = new BufferOverflow('DROP_LATEST', 2);
}
function BufferOverflow_SUSPEND_getInstance() {
  BufferOverflow_initEntries();
  return BufferOverflow_SUSPEND_instance;
}
function BufferOverflow_DROP_OLDEST_getInstance() {
  BufferOverflow_initEntries();
  return BufferOverflow_DROP_OLDEST_instance;
}
function BufferOverflow_DROP_LATEST_getInstance() {
  BufferOverflow_initEntries();
  return BufferOverflow_DROP_LATEST_instance;
}
function get_NULL_SEGMENT() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return NULL_SEGMENT;
}
var NULL_SEGMENT;
function get_SEGMENT_SIZE() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return SEGMENT_SIZE;
}
var SEGMENT_SIZE;
function get_EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS;
}
var EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS;
function get_BUFFERED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return BUFFERED;
}
var BUFFERED;
function get_IN_BUFFER() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return IN_BUFFER;
}
var IN_BUFFER;
function get_RESUMING_BY_RCV() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return RESUMING_BY_RCV;
}
var RESUMING_BY_RCV;
function get_RESUMING_BY_EB() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return RESUMING_BY_EB;
}
var RESUMING_BY_EB;
function get_POISONED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return POISONED;
}
var POISONED;
function get_DONE_RCV() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return DONE_RCV;
}
var DONE_RCV;
function get_INTERRUPTED_SEND() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return INTERRUPTED_SEND;
}
var INTERRUPTED_SEND;
function get_INTERRUPTED_RCV() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return INTERRUPTED_RCV;
}
var INTERRUPTED_RCV;
function get_CHANNEL_CLOSED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return CHANNEL_CLOSED;
}
var CHANNEL_CLOSED;
function get_SUSPEND() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return SUSPEND;
}
var SUSPEND;
function get_SUSPEND_NO_WAITER() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return SUSPEND_NO_WAITER;
}
var SUSPEND_NO_WAITER;
function get_FAILED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return FAILED;
}
var FAILED;
var NO_RECEIVE_RESULT;
var CLOSE_HANDLER_CLOSED;
var CLOSE_HANDLER_INVOKED;
function get_NO_CLOSE_CAUSE() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return NO_CLOSE_CAUSE;
}
var NO_CLOSE_CAUSE;
function setElementLazy($this, index, value) {
  // Inline function 'kotlinx.atomicfu.AtomicRef.lazySet' call
  $this.f1j_1.atomicfu$get(imul(index, 2)).kotlinx$atomicfu$value = value;
}
function _get_bufferEndCounter__2d4hee($this) {
  return $this.u1j_1.kotlinx$atomicfu$value;
}
function _get_isRendezvousOrUnlimited__3mdufi($this) {
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlinx.coroutines.channels.BufferedChannel.<get-isRendezvousOrUnlimited>.<anonymous>' call
  var it = _get_bufferEndCounter__2d4hee($this);
  return it.equals(new Long(0, 0)) || it.equals(new Long(-1, 2147483647));
}
function *_generator_send__qhx0g0($this, element, $completion) {
  $l$block_5: {
    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
    var segment = $this.w1j_1.kotlinx$atomicfu$value;
    $l$loop_0: while (true) {
      var sendersAndCloseStatusCur = $this.s1j_1.atomicfu$getAndIncrement$long();
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
      var s = sendersAndCloseStatusCur.j4(new Long(-1, 268435455));
      var closed = _get_isClosedForSend0__kxgf9m(sendersAndCloseStatusCur, $this);
      // Inline function 'kotlin.Long.div' call
      var other = get_SEGMENT_SIZE();
      var id = s.a4(toLong(other));
      // Inline function 'kotlin.Long.rem' call
      var other_0 = get_SEGMENT_SIZE();
      var i = s.b4(toLong(other_0)).j2();
      if (!segment.a1b_1.equals(id)) {
        var tmp0_elvis_lhs = findSegmentSend($this, id, segment);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var tmp_0;
          if (closed) {
            var tmp_1 = onClosedSend($this, element, $completion);
            if (tmp_1 === get_COROUTINE_SUSPENDED())
              tmp_1 = yield tmp_1;
            break $l$block_5;
          } else {
            continue $l$loop_0;
          }
        } else {
          tmp = tmp0_elvis_lhs;
        }
        segment = tmp;
      }
      switch (updateCellSend($this, segment, i, element, s, null, closed)) {
        case 0:
          segment.o1k();
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.send.<anonymous>' call

          break $l$block_5;
        case 1:
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.send.<anonymous>' call

          break $l$block_5;
        case 2:
          if (closed) {
            segment.e1k();
            var tmp_2 = onClosedSend($this, element, $completion);
            if (tmp_2 === get_COROUTINE_SUSPENDED())
              tmp_2 = yield tmp_2;
            break $l$block_5;
          }

          var tmp83_safe_receiver = (!(null == null) ? isInterface(null, Waiter) : false) ? null : null;
          if (tmp83_safe_receiver == null)
            null;
          else {
            prepareSenderForSuspension(tmp83_safe_receiver, $this, segment, i);
          }

          // Inline function 'kotlinx.coroutines.assert' call

          break $l$block_5;
        case 4:
          if (s.x1($this.q1k()) < 0) {
            segment.o1k();
          }

          var tmp_3 = onClosedSend($this, element, $completion);
          if (tmp_3 === get_COROUTINE_SUSPENDED())
            tmp_3 = yield tmp_3;
          break $l$block_5;
        case 5:
          segment.o1k();
          continue $l$loop_0;
        case 3:
          var segm = segment;
          var tmp_4 = sendOnNoWaiterSuspend($this, segm, i, element, s, $completion);
          if (tmp_4 === get_COROUTINE_SUSPENDED())
            tmp_4 = yield tmp_4;
          break $l$block_5;
      }
    }
  }
  return Unit_instance;
}
function onClosedSend($this, element, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.s1b();
  $l$block: {
    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.onClosedSend.<anonymous>' call
    var tmp79_safe_receiver = $this.r1j_1;
    var tmp80_safe_receiver = tmp79_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp79_safe_receiver, element);
    if (tmp80_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      addSuppressed(tmp80_safe_receiver, $this.r1k());
      // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = recoverStackTrace(tmp80_safe_receiver, cancellable);
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
      cancellable.bd(tmp$ret$0);
      break $l$block;
    }
    // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
    var exception_0 = $this.r1k();
    // Inline function 'kotlin.Companion.failure' call
    var exception_1 = recoverStackTrace(exception_0, cancellable);
    var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(exception_1));
    cancellable.bd(tmp$ret$3);
  }
  return cancellable.e19();
}
function sendOnNoWaiterSuspend($this, segment, index, element, s, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutineReusable.<anonymous>' call
  var cancellable = getOrCreateCancellableContinuation(intercepted($completion));
  try {
    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendOnNoWaiterSuspend.<anonymous>' call
    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImplOnNoWaiter' call
    switch (updateCellSend($this, segment, index, element, s, cancellable, false)) {
      case 0:
        segment.o1k();
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendOnNoWaiterSuspend.<anonymous>.<anonymous>' call

        // Inline function 'kotlin.coroutines.resume' call

        // Inline function 'kotlin.Companion.success' call

        var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
        cancellable.bd(tmp$ret$0);
        break;
      case 1:
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendOnNoWaiterSuspend.<anonymous>.<anonymous>' call

        // Inline function 'kotlin.coroutines.resume' call

        // Inline function 'kotlin.Companion.success' call

        var tmp$ret$2 = _Result___init__impl__xyqfz8(Unit_instance);
        cancellable.bd(tmp$ret$2);
        break;
      case 2:
        prepareSenderForSuspension(cancellable, $this, segment, index);
        break;
      case 4:
        if (s.x1($this.q1k()) < 0) {
          segment.o1k();
        }

        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendOnNoWaiterSuspend.<anonymous>.<anonymous>' call

        onClosedSendOnNoWaiterSuspend($this, element, cancellable);
        break;
      case 5:
        segment.o1k();
        $l$block_4: {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
          var segment_0 = $this.w1j_1.kotlinx$atomicfu$value;
          $l$loop_0: while (true) {
            var sendersAndCloseStatusCur = $this.s1j_1.atomicfu$getAndIncrement$long();
            // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
            var s_0 = sendersAndCloseStatusCur.j4(new Long(-1, 268435455));
            var closed = _get_isClosedForSend0__kxgf9m(sendersAndCloseStatusCur, $this);
            // Inline function 'kotlin.Long.div' call
            var other = get_SEGMENT_SIZE();
            var id = s_0.a4(toLong(other));
            // Inline function 'kotlin.Long.rem' call
            var other_0 = get_SEGMENT_SIZE();
            var i = s_0.b4(toLong(other_0)).j2();
            if (!segment_0.a1b_1.equals(id)) {
              var tmp0_elvis_lhs = findSegmentSend($this, id, segment_0);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                var tmp_0;
                if (closed) {
                  onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                  break $l$block_4;
                } else {
                  continue $l$loop_0;
                }
              } else {
                tmp = tmp0_elvis_lhs;
              }
              segment_0 = tmp;
            }
            switch (updateCellSend($this, segment_0, i, element, s_0, cancellable, closed)) {
              case 0:
                segment_0.o1k();
                // Inline function 'kotlin.coroutines.resume' call

                // Inline function 'kotlin.Companion.success' call

                var tmp$ret$8 = _Result___init__impl__xyqfz8(Unit_instance);
                cancellable.bd(tmp$ret$8);
                break $l$block_4;
              case 1:
                // Inline function 'kotlin.coroutines.resume' call

                // Inline function 'kotlin.Companion.success' call

                var tmp$ret$10 = _Result___init__impl__xyqfz8(Unit_instance);
                cancellable.bd(tmp$ret$10);
                break $l$block_4;
              case 2:
                if (closed) {
                  segment_0.e1k();
                  onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                  break $l$block_4;
                }

                var tmp83_safe_receiver = (!(cancellable == null) ? isInterface(cancellable, Waiter) : false) ? cancellable : null;
                if (tmp83_safe_receiver == null)
                  null;
                else {
                  prepareSenderForSuspension(tmp83_safe_receiver, $this, segment_0, i);
                }

                // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImplOnNoWaiter.<anonymous>' call

                break $l$block_4;
              case 4:
                if (s_0.x1($this.q1k()) < 0) {
                  segment_0.o1k();
                }

                onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                break $l$block_4;
              case 5:
                segment_0.o1k();
                continue $l$loop_0;
              case 3:
                var message = 'unexpected';
                throw IllegalStateException.h5(toString(message));
            }
          }
        }

        break;
      default:
        // Inline function 'kotlin.error' call

        var message_0 = 'unexpected';
        throw IllegalStateException.h5(toString(message_0));
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      cancellable.a1c();
      throw e;
    } else {
      throw $p;
    }
  }
  return cancellable.e19();
}
function prepareSenderForSuspension(_this__u8e3s4, $this, segment, index) {
  _this__u8e3s4.g1c(segment, index + get_SEGMENT_SIZE() | 0);
}
function onClosedSendOnNoWaiterSuspend($this, element, cont) {
  var tmp81_safe_receiver = $this.r1j_1;
  if (tmp81_safe_receiver == null)
    null;
  else {
    callUndeliveredElement(tmp81_safe_receiver, element, cont.zc());
  }
  // Inline function 'kotlin.coroutines.resumeWithException' call
  // Inline function 'kotlin.Companion.failure' call
  var exception = recoverStackTrace($this.r1k(), cont);
  var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
  cont.bd(tmp$ret$0);
}
function updateCellSend($this, segment, index, element, s, waiter, closed) {
  segment.i1j(index, element);
  if (closed)
    return updateCellSendSlow($this, segment, index, element, s, waiter, closed);
  var state = segment.m1j(index);
  if (state === null) {
    if (bufferOrRendezvousSend($this, s)) {
      if (segment.o1j(index, null, get_BUFFERED())) {
        return 1;
      }
    } else {
      if (waiter == null) {
        return 3;
      } else {
        if (segment.o1j(index, null, waiter))
          return 2;
      }
    }
  } else {
    if (!(state == null) ? isInterface(state, Waiter) : false) {
      segment.l1j(index);
      var tmp;
      if (tryResumeReceiver(state, $this, element)) {
        segment.n1j(index, get_DONE_RCV());
        $this.s1k();
        tmp = 0;
      } else {
        if (!(segment.p1j(index, get_INTERRUPTED_RCV()) === get_INTERRUPTED_RCV())) {
          segment.c1k(index, true);
        }
        tmp = 5;
      }
      return tmp;
    }
  }
  return updateCellSendSlow($this, segment, index, element, s, waiter, closed);
}
function updateCellSendSlow($this, segment, index, element, s, waiter, closed) {
  while (true) {
    var state = segment.m1j(index);
    if (state === null) {
      if (bufferOrRendezvousSend($this, s) && !closed) {
        if (segment.o1j(index, null, get_BUFFERED())) {
          return 1;
        }
      } else {
        if (closed) {
          if (segment.o1j(index, null, get_INTERRUPTED_SEND())) {
            segment.c1k(index, false);
            return 4;
          }
        } else if (waiter == null)
          return 3;
        else if (segment.o1j(index, null, waiter))
          return 2;
      }
    } else if (state === get_IN_BUFFER()) {
      if (segment.o1j(index, state, get_BUFFERED())) {
        return 1;
      }
    } else if (state === get_INTERRUPTED_RCV()) {
      segment.l1j(index);
      return 5;
    } else if (state === get_POISONED()) {
      segment.l1j(index);
      return 5;
    } else if (state === get_CHANNEL_CLOSED()) {
      segment.l1j(index);
      completeCloseOrCancel($this);
      return 4;
    } else {
      // Inline function 'kotlinx.coroutines.assert' call
      segment.l1j(index);
      var tmp;
      if (state instanceof WaiterEB) {
        tmp = state.t1k_1;
      } else {
        tmp = state;
      }
      var receiver = tmp;
      var tmp_0;
      if (tryResumeReceiver(receiver, $this, element)) {
        segment.n1j(index, get_DONE_RCV());
        $this.s1k();
        tmp_0 = 0;
      } else {
        if (!(segment.p1j(index, get_INTERRUPTED_RCV()) === get_INTERRUPTED_RCV())) {
          segment.c1k(index, true);
        }
        tmp_0 = 5;
      }
      return tmp_0;
    }
  }
}
function shouldSendSuspend0($this, curSendersAndCloseStatus) {
  if (_get_isClosedForSend0__kxgf9m(curSendersAndCloseStatus, $this))
    return false;
  // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
  var tmp$ret$0 = curSendersAndCloseStatus.j4(new Long(-1, 268435455));
  return !bufferOrRendezvousSend($this, tmp$ret$0);
}
function bufferOrRendezvousSend($this, curSenders) {
  var tmp;
  if (curSenders.x1(_get_bufferEndCounter__2d4hee($this)) < 0) {
    tmp = true;
  } else {
    // Inline function 'kotlin.Long.plus' call
    var this_0 = $this.q1k();
    var other = $this.q1j_1;
    var tmp$ret$0 = this_0.y3(toLong(other));
    tmp = curSenders.x1(tmp$ret$0) < 0;
  }
  return tmp;
}
function tryResumeReceiver(_this__u8e3s4, $this, element) {
  var tmp;
  if (isInterface(_this__u8e3s4, SelectInstance)) {
    tmp = _this__u8e3s4.b1l($this, element);
  } else {
    if (_this__u8e3s4 instanceof ReceiveCatching) {
      if (!(_this__u8e3s4 instanceof ReceiveCatching))
        THROW_CCE();
      var tmp_0 = Companion_getInstance_0().z1k(element);
      var tmp86_safe_receiver = $this.r1j_1;
      tmp = tryResume0(_this__u8e3s4.a1l_1, new ChannelResult(tmp_0), tmp86_safe_receiver == null ? null : bindCancellationFunResult(tmp86_safe_receiver, $this));
    } else {
      if (_this__u8e3s4 instanceof BufferedChannelIterator) {
        if (!(_this__u8e3s4 instanceof BufferedChannelIterator))
          THROW_CCE();
        tmp = _this__u8e3s4.x1k(element);
      } else {
        if (isInterface(_this__u8e3s4, CancellableContinuation)) {
          if (!isInterface(_this__u8e3s4, CancellableContinuation))
            THROW_CCE();
          var tmp87_safe_receiver = $this.r1j_1;
          tmp = tryResume0(_this__u8e3s4, element, tmp87_safe_receiver == null ? null : bindCancellationFun_0(tmp87_safe_receiver, $this));
        } else {
          var message = 'Unexpected receiver type: ' + toString(_this__u8e3s4);
          throw IllegalStateException.h5(toString(message));
        }
      }
    }
  }
  return tmp;
}
function *_generator_receive__aoggq9($this, $completion) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
    var segment = $this.x1j_1.kotlinx$atomicfu$value;
    $l$loop_0: while (true) {
      if ($this.c1l()) {
        throw recoverStackTrace_0(_get_receiveException__foorc1($this));
      }
      var r = $this.t1j_1.atomicfu$getAndIncrement$long();
      // Inline function 'kotlin.Long.div' call
      var other = get_SEGMENT_SIZE();
      var id = r.a4(toLong(other));
      // Inline function 'kotlin.Long.rem' call
      var other_0 = get_SEGMENT_SIZE();
      var i = r.b4(toLong(other_0)).j2();
      if (!segment.a1b_1.equals(id)) {
        var tmp0_elvis_lhs = findSegmentReceive($this, id, segment);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        segment = tmp;
      }
      var updCellResult = updateCellReceive($this, segment, i, r, null);
      var tmp_0;
      if (updCellResult === _get_SUSPEND_$accessor$yt74tm_ccb8g1()) {
        var tmp92_safe_receiver = (!(null == null) ? isInterface(null, Waiter) : false) ? null : null;
        if (tmp92_safe_receiver == null)
          null;
        else {
          prepareReceiverForSuspension(tmp92_safe_receiver, $this, segment, i);
        }
        var message = 'unexpected';
        throw IllegalStateException.h5(toString(message));
      } else if (updCellResult === _get_FAILED_$accessor$yt74tm_h47uk8()) {
        if (r.x1($this.d1l()) < 0) {
          segment.o1k();
        }
        continue $l$loop_0;
      } else if (updCellResult === _get_SUSPEND_NO_WAITER_$accessor$yt74tm_n6n1ky()) {
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receive.<anonymous>' call
        var segm = segment;
        var tmp_1 = receiveOnNoWaiterSuspend($this, segm, i, r, $completion);
        if (tmp_1 === get_COROUTINE_SUSPENDED())
          tmp_1 = yield tmp_1;
        tmp_0 = tmp_1;
      } else {
        segment.o1k();
        return (updCellResult == null ? true : !(updCellResult == null)) ? updCellResult : THROW_CCE();
      }
      tmp$ret$0 = tmp_0;
      break $l$block;
    }
  }
  return tmp$ret$0;
}
function receiveOnNoWaiterSuspend($this, segment, index, r, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutineReusable.<anonymous>' call
  var cancellable = getOrCreateCancellableContinuation(intercepted($completion));
  try {
    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveOnNoWaiterSuspend.<anonymous>' call
    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImplOnNoWaiter' call
    var updCellResult = updateCellReceive($this, segment, index, r, cancellable);
    if (updCellResult === _get_SUSPEND_$accessor$yt74tm_ccb8g1()) {
      prepareReceiverForSuspension(cancellable, $this, segment, index);
    } else if (updCellResult === _get_FAILED_$accessor$yt74tm_h47uk8()) {
      if (r.x1($this.d1l()) < 0) {
        segment.o1k();
      }
      $l$block_0: {
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
        var segment_0 = $this.x1j_1.kotlinx$atomicfu$value;
        $l$loop_0: while (true) {
          if ($this.c1l()) {
            onClosedReceiveOnNoWaiterSuspend($this, cancellable);
            break $l$block_0;
          }
          var r_0 = $this.t1j_1.atomicfu$getAndIncrement$long();
          // Inline function 'kotlin.Long.div' call
          var other = get_SEGMENT_SIZE();
          var id = r_0.a4(toLong(other));
          // Inline function 'kotlin.Long.rem' call
          var other_0 = get_SEGMENT_SIZE();
          var i = r_0.b4(toLong(other_0)).j2();
          if (!segment_0.a1b_1.equals(id)) {
            var tmp0_elvis_lhs = findSegmentReceive($this, id, segment_0);
            var tmp;
            if (tmp0_elvis_lhs == null) {
              continue $l$loop_0;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            segment_0 = tmp;
          }
          var updCellResult_0 = updateCellReceive($this, segment_0, i, r_0, cancellable);
          var tmp_0;
          if (updCellResult_0 === _get_SUSPEND_$accessor$yt74tm_ccb8g1()) {
            var tmp92_safe_receiver = (!(cancellable == null) ? isInterface(cancellable, Waiter) : false) ? cancellable : null;
            if (tmp92_safe_receiver == null)
              null;
            else {
              prepareReceiverForSuspension(tmp92_safe_receiver, $this, segment_0, i);
            }
            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImplOnNoWaiter.<anonymous>' call
            tmp_0 = Unit_instance;
          } else if (updCellResult_0 === _get_FAILED_$accessor$yt74tm_h47uk8()) {
            if (r_0.x1($this.d1l()) < 0) {
              segment_0.o1k();
            }
            continue $l$loop_0;
          } else if (updCellResult_0 === _get_SUSPEND_NO_WAITER_$accessor$yt74tm_n6n1ky()) {
            var message = 'unexpected';
            throw IllegalStateException.h5(toString(message));
          } else {
            segment_0.o1k();
            var element = (updCellResult_0 == null ? true : !(updCellResult_0 == null)) ? updCellResult_0 : THROW_CCE();
            var tmp88_safe_receiver = $this.r1j_1;
            var onCancellation = tmp88_safe_receiver == null ? null : bindCancellationFun_0(tmp88_safe_receiver, $this);
            cancellable.c1a(element, onCancellation);
            tmp_0 = Unit_instance;
          }
          break $l$block_0;
        }
      }
    } else {
      segment.o1k();
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveOnNoWaiterSuspend.<anonymous>.<anonymous>' call
      var element_0 = (updCellResult == null ? true : !(updCellResult == null)) ? updCellResult : THROW_CCE();
      var tmp88_safe_receiver_0 = $this.r1j_1;
      var onCancellation_0 = tmp88_safe_receiver_0 == null ? null : bindCancellationFun_0(tmp88_safe_receiver_0, $this);
      cancellable.c1a(element_0, onCancellation_0);
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      cancellable.a1c();
      throw e;
    } else {
      throw $p;
    }
  }
  return cancellable.e19();
}
function prepareReceiverForSuspension(_this__u8e3s4, $this, segment, index) {
  $this.e1l();
  _this__u8e3s4.g1c(segment, index);
}
function onClosedReceiveOnNoWaiterSuspend($this, cont) {
  // Inline function 'kotlin.coroutines.resumeWithException' call
  // Inline function 'kotlin.Companion.failure' call
  var exception = _get_receiveException__foorc1($this);
  var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
  cont.bd(tmp$ret$0);
}
function updateCellReceive($this, segment, index, r, waiter) {
  var state = segment.m1j(index);
  if (state === null) {
    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
    var senders = $this.s1j_1.kotlinx$atomicfu$value.j4(new Long(-1, 268435455));
    if (r.x1(senders) >= 0) {
      if (waiter === null) {
        return _get_SUSPEND_NO_WAITER_$accessor$yt74tm_n6n1ky();
      }
      if (segment.o1j(index, state, waiter)) {
        expandBuffer($this);
        return _get_SUSPEND_$accessor$yt74tm_ccb8g1();
      }
    }
  } else if (state === get_BUFFERED())
    if (segment.o1j(index, state, get_DONE_RCV())) {
      expandBuffer($this);
      return segment.k1j(index);
    }
  return updateCellReceiveSlow($this, segment, index, r, waiter);
}
function updateCellReceiveSlow($this, segment, index, r, waiter) {
  $l$loop: while (true) {
    var state = segment.m1j(index);
    if (state === null || state === get_IN_BUFFER()) {
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
      var senders = $this.s1j_1.kotlinx$atomicfu$value.j4(new Long(-1, 268435455));
      if (r.x1(senders) < 0) {
        if (segment.o1j(index, state, get_POISONED())) {
          expandBuffer($this);
          return _get_FAILED_$accessor$yt74tm_h47uk8();
        }
      } else {
        if (waiter === null) {
          return _get_SUSPEND_NO_WAITER_$accessor$yt74tm_n6n1ky();
        }
        if (segment.o1j(index, state, waiter)) {
          expandBuffer($this);
          return _get_SUSPEND_$accessor$yt74tm_ccb8g1();
        }
      }
    } else if (state === get_BUFFERED()) {
      if (segment.o1j(index, state, get_DONE_RCV())) {
        expandBuffer($this);
        return segment.k1j(index);
      }
    } else if (state === get_INTERRUPTED_SEND())
      return _get_FAILED_$accessor$yt74tm_h47uk8();
    else if (state === get_POISONED())
      return _get_FAILED_$accessor$yt74tm_h47uk8();
    else if (state === get_CHANNEL_CLOSED()) {
      expandBuffer($this);
      return _get_FAILED_$accessor$yt74tm_h47uk8();
    } else if (state === get_RESUMING_BY_EB())
      continue $l$loop;
    else {
      if (segment.o1j(index, state, get_RESUMING_BY_RCV())) {
        var helpExpandBuffer = state instanceof WaiterEB;
        var tmp;
        if (state instanceof WaiterEB) {
          tmp = state.t1k_1;
        } else {
          tmp = state;
        }
        var sender = tmp;
        var tmp_0;
        if (tryResumeSender(sender, $this, segment, index)) {
          segment.n1j(index, get_DONE_RCV());
          expandBuffer($this);
          tmp_0 = segment.k1j(index);
        } else {
          segment.n1j(index, get_INTERRUPTED_SEND());
          segment.c1k(index, false);
          if (helpExpandBuffer) {
            expandBuffer($this);
          }
          tmp_0 = _get_FAILED_$accessor$yt74tm_h47uk8();
        }
        return tmp_0;
      }
    }
  }
}
function tryResumeSender(_this__u8e3s4, $this, segment, index) {
  var tmp;
  if (isInterface(_this__u8e3s4, CancellableContinuation)) {
    if (!isInterface(_this__u8e3s4, CancellableContinuation))
      THROW_CCE();
    tmp = tryResume0(_this__u8e3s4, Unit_instance);
  } else {
    if (isInterface(_this__u8e3s4, SelectInstance)) {
      if (!(_this__u8e3s4 instanceof SelectImplementation))
        THROW_CCE();
      var trySelectResult = _this__u8e3s4.j1l($this, Unit_instance);
      if (trySelectResult === TrySelectDetailedResult_REREGISTER_getInstance()) {
        segment.l1j(index);
      }
      tmp = trySelectResult === TrySelectDetailedResult_SUCCESSFUL_getInstance();
    } else {
      if (_this__u8e3s4 instanceof SendBroadcast) {
        tmp = tryResume0(_this__u8e3s4.f1l_1, true);
      } else {
        var message = 'Unexpected waiter: ' + toString(_this__u8e3s4);
        throw IllegalStateException.h5(toString(message));
      }
    }
  }
  return tmp;
}
function expandBuffer($this) {
  if (_get_isRendezvousOrUnlimited__3mdufi($this))
    return Unit_instance;
  var segment = $this.y1j_1.kotlinx$atomicfu$value;
  try_again: while (true) {
    var b = $this.u1j_1.atomicfu$getAndIncrement$long();
    // Inline function 'kotlin.Long.div' call
    var other = get_SEGMENT_SIZE();
    var id = b.a4(toLong(other));
    var s = $this.d1l();
    if (s.x1(b) <= 0) {
      if (segment.a1b_1.x1(id) < 0 && !(segment.k1k() == null)) {
        moveSegmentBufferEndToSpecifiedOrLast($this, id, segment);
      }
      incCompletedExpandBufferAttempts$default($this);
      return Unit_instance;
    }
    if (!segment.a1b_1.equals(id)) {
      var tmp0_elvis_lhs = findSegmentBufferEnd($this, id, segment, b);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue try_again;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      segment = tmp;
    }
    // Inline function 'kotlin.Long.rem' call
    var other_0 = get_SEGMENT_SIZE();
    var i = b.b4(toLong(other_0)).j2();
    if (updateCellExpandBuffer($this, segment, i, b)) {
      incCompletedExpandBufferAttempts$default($this);
      return Unit_instance;
    } else {
      incCompletedExpandBufferAttempts$default($this);
      continue try_again;
    }
  }
}
function updateCellExpandBuffer($this, segment, index, b) {
  var state = segment.m1j(index);
  if (!(state == null) ? isInterface(state, Waiter) : false) {
    if (b.x1($this.t1j_1.kotlinx$atomicfu$value) >= 0) {
      if (segment.o1j(index, state, get_RESUMING_BY_EB())) {
        var tmp;
        if (tryResumeSender(state, $this, segment, index)) {
          segment.n1j(index, get_BUFFERED());
          tmp = true;
        } else {
          segment.n1j(index, get_INTERRUPTED_SEND());
          segment.c1k(index, false);
          tmp = false;
        }
        return tmp;
      }
    }
  }
  return updateCellExpandBufferSlow($this, segment, index, b);
}
function updateCellExpandBufferSlow($this, segment, index, b) {
  $l$loop: while (true) {
    var state = segment.m1j(index);
    if (!(state == null) ? isInterface(state, Waiter) : false) {
      if (b.x1($this.t1j_1.kotlinx$atomicfu$value) < 0) {
        if (segment.o1j(index, state, new WaiterEB(state)))
          return true;
      } else {
        if (segment.o1j(index, state, get_RESUMING_BY_EB())) {
          var tmp;
          if (tryResumeSender(state, $this, segment, index)) {
            segment.n1j(index, get_BUFFERED());
            tmp = true;
          } else {
            segment.n1j(index, get_INTERRUPTED_SEND());
            segment.c1k(index, false);
            tmp = false;
          }
          return tmp;
        }
      }
    } else {
      if (state === get_INTERRUPTED_SEND())
        return false;
      else {
        if (state === null) {
          if (segment.o1j(index, state, get_IN_BUFFER()))
            return true;
        } else {
          if (state === get_BUFFERED())
            return true;
          else {
            if (state === get_POISONED() || state === get_DONE_RCV() || state === get_INTERRUPTED_RCV())
              return true;
            else {
              if (state === get_CHANNEL_CLOSED())
                return true;
              else {
                if (state === get_RESUMING_BY_RCV())
                  continue $l$loop;
                else {
                  var message = 'Unexpected cell state: ' + toString_0(state);
                  throw IllegalStateException.h5(toString(message));
                }
              }
            }
          }
        }
      }
    }
  }
}
function incCompletedExpandBufferAttempts($this, nAttempts) {
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlinx.coroutines.channels.BufferedChannel.incCompletedExpandBufferAttempts.<anonymous>' call
  // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
  if (!$this.v1j_1.atomicfu$addAndGet$long(nAttempts).j4(new Long(0, 1073741824)).equals(new Long(0, 0))) {
    $l$loop: while (true) {
      // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
      if (!!$this.v1j_1.kotlinx$atomicfu$value.j4(new Long(0, 1073741824)).equals(new Long(0, 0))) {
        break $l$loop;
      }
    }
  }
}
function incCompletedExpandBufferAttempts$default($this, nAttempts, $super) {
  nAttempts = nAttempts === VOID ? new Long(1, 0) : nAttempts;
  return incCompletedExpandBufferAttempts($this, nAttempts);
}
function _get_receiveException__foorc1($this) {
  var tmp0_elvis_lhs = $this.l1l();
  return tmp0_elvis_lhs == null ? ClosedReceiveChannelException.q1l('Channel was closed') : tmp0_elvis_lhs;
}
function completeCloseOrCancel($this) {
  $this.r1l();
}
function completeClose($this, sendersCur) {
  var lastSegment = closeLinkedList($this);
  if ($this.t1l()) {
    var lastBufferedCellGlobalIndex = markAllEmptyCellsAsClosed($this, lastSegment);
    if (!lastBufferedCellGlobalIndex.equals(new Long(-1, -1))) {
      $this.s1l(lastBufferedCellGlobalIndex);
    }
  }
  cancelSuspendedReceiveRequests($this, lastSegment, sendersCur);
  return lastSegment;
}
function completeCancel($this, sendersCur) {
  var lastSegment = completeClose($this, sendersCur);
  removeUnprocessedElements($this, lastSegment);
}
function closeLinkedList($this) {
  var lastSegment = $this.y1j_1.kotlinx$atomicfu$value;
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  var it = $this.w1j_1.kotlinx$atomicfu$value;
  if (it.a1b_1.x1(lastSegment.a1b_1) > 0)
    lastSegment = it;
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  var it_0 = $this.x1j_1.kotlinx$atomicfu$value;
  if (it_0.a1b_1.x1(lastSegment.a1b_1) > 0)
    lastSegment = it_0;
  return close(lastSegment);
}
function markAllEmptyCellsAsClosed($this, lastSegment) {
  var segment = lastSegment;
  while (true) {
    var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        // Inline function 'kotlin.Long.plus' call
        // Inline function 'kotlin.Long.times' call
        var this_0 = segment.a1b_1;
        var other = get_SEGMENT_SIZE();
        var globalIndex = this_0.z3(toLong(other)).y3(toLong(index));
        if (globalIndex.x1($this.q1k()) < 0)
          return new Long(-1, -1);
        cell_update: while (true) {
          var state = segment.m1j(index);
          if (state === null || state === get_IN_BUFFER()) {
            if (segment.o1j(index, state, get_CHANNEL_CLOSED())) {
              segment.e1k();
              break cell_update;
            }
          } else if (state === get_BUFFERED())
            return globalIndex;
          else
            break cell_update;
        }
      }
       while (0 <= inductionVariable);
    var tmp0_elvis_lhs = segment.n1k();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return new Long(-1, -1);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    segment = tmp;
  }
}
function removeUnprocessedElements($this, lastSegment) {
  var onUndeliveredElement = $this.r1j_1;
  var undeliveredElementException = null;
  var suspendedSenders = _InlineList___init__impl__z8n56();
  var segment = lastSegment;
  process_segments: while (true) {
    var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        // Inline function 'kotlin.Long.plus' call
        // Inline function 'kotlin.Long.times' call
        var this_0 = segment.a1b_1;
        var other = get_SEGMENT_SIZE();
        var globalIndex = this_0.z3(toLong(other)).y3(toLong(index));
        update_cell: while (true) {
          var state = segment.m1j(index);
          if (state === get_DONE_RCV())
            break process_segments;
          else {
            if (state === get_BUFFERED()) {
              if (globalIndex.x1($this.q1k()) < 0)
                break process_segments;
              if (segment.o1j(index, state, get_CHANNEL_CLOSED())) {
                if (!(onUndeliveredElement == null)) {
                  var element = segment.j1j(index);
                  undeliveredElementException = callUndeliveredElementCatchingException(onUndeliveredElement, element, undeliveredElementException);
                }
                segment.l1j(index);
                segment.e1k();
                break update_cell;
              }
            } else {
              if (state === get_IN_BUFFER() || state === null) {
                if (segment.o1j(index, state, get_CHANNEL_CLOSED())) {
                  segment.e1k();
                  break update_cell;
                }
              } else {
                var tmp;
                if (!(state == null) ? isInterface(state, Waiter) : false) {
                  tmp = true;
                } else {
                  tmp = state instanceof WaiterEB;
                }
                if (tmp) {
                  if (globalIndex.x1($this.q1k()) < 0)
                    break process_segments;
                  var tmp_0;
                  if (state instanceof WaiterEB) {
                    tmp_0 = state.t1k_1;
                  } else {
                    tmp_0 = (!(state == null) ? isInterface(state, Waiter) : false) ? state : THROW_CCE();
                  }
                  var sender = tmp_0;
                  if (segment.o1j(index, state, get_CHANNEL_CLOSED())) {
                    if (!(onUndeliveredElement == null)) {
                      var element_0 = segment.j1j(index);
                      undeliveredElementException = callUndeliveredElementCatchingException(onUndeliveredElement, element_0, undeliveredElementException);
                    }
                    suspendedSenders = InlineList__plus_impl_nuetvo(suspendedSenders, sender);
                    segment.l1j(index);
                    segment.e1k();
                    break update_cell;
                  }
                } else {
                  if (state === get_RESUMING_BY_EB() || state === get_RESUMING_BY_RCV())
                    break process_segments;
                  else {
                    if (state === get_RESUMING_BY_EB())
                      continue update_cell;
                    else {
                      break update_cell;
                    }
                  }
                }
              }
            }
          }
        }
      }
       while (0 <= inductionVariable);
    var tmp0_elvis_lhs = segment.n1k();
    var tmp_1;
    if (tmp0_elvis_lhs == null) {
      break process_segments;
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    segment = tmp_1;
  }
  $l$block: {
    // Inline function 'kotlinx.coroutines.internal.InlineList.forEachReversed' call
    var this_1 = suspendedSenders;
    var tmp154_subject = _get_holder__f6h5pd(this_1);
    if (tmp154_subject == null) {
      break $l$block;
    } else {
      if (!(tmp154_subject instanceof ArrayList)) {
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.removeUnprocessedElements.<anonymous>' call
        var tmp_2 = _get_holder__f6h5pd(this_1);
        var it = (tmp_2 == null ? true : !(tmp_2 == null)) ? tmp_2 : THROW_CCE();
        resumeSenderOnCancelledChannel(it, $this);
      } else {
        var tmp_3 = _get_holder__f6h5pd(this_1);
        var list = tmp_3 instanceof ArrayList ? tmp_3 : THROW_CCE();
        var inductionVariable_0 = list.f1() - 1 | 0;
        if (0 <= inductionVariable_0)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + -1 | 0;
            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.removeUnprocessedElements.<anonymous>' call
            var it_0 = list.e1(i);
            resumeSenderOnCancelledChannel(it_0, $this);
          }
           while (0 <= inductionVariable_0);
      }
    }
  }
  var tmp100_safe_receiver = undeliveredElementException;
  if (tmp100_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    throw tmp100_safe_receiver;
  }
}
function cancelSuspendedReceiveRequests($this, lastSegment, sendersCounter) {
  var suspendedReceivers = _InlineList___init__impl__z8n56();
  var segment = lastSegment;
  process_segments: while (!(segment == null)) {
    var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        // Inline function 'kotlin.Long.plus' call
        // Inline function 'kotlin.Long.times' call
        var this_0 = segment.a1b_1;
        var other = get_SEGMENT_SIZE();
        if (this_0.z3(toLong(other)).y3(toLong(index)).x1(sendersCounter) < 0)
          break process_segments;
        cell_update: while (true) {
          var state = segment.m1j(index);
          if (state === null || state === get_IN_BUFFER()) {
            if (segment.o1j(index, state, get_CHANNEL_CLOSED())) {
              segment.e1k();
              break cell_update;
            }
          } else {
            if (state instanceof WaiterEB) {
              if (segment.o1j(index, state, get_CHANNEL_CLOSED())) {
                suspendedReceivers = InlineList__plus_impl_nuetvo(suspendedReceivers, state.t1k_1);
                segment.c1k(index, true);
                break cell_update;
              }
            } else {
              if (!(state == null) ? isInterface(state, Waiter) : false) {
                if (segment.o1j(index, state, get_CHANNEL_CLOSED())) {
                  suspendedReceivers = InlineList__plus_impl_nuetvo(suspendedReceivers, state);
                  segment.c1k(index, true);
                  break cell_update;
                }
              } else {
                break cell_update;
              }
            }
          }
        }
      }
       while (0 <= inductionVariable);
    segment = segment.n1k();
  }
  $l$block: {
    // Inline function 'kotlinx.coroutines.internal.InlineList.forEachReversed' call
    var this_1 = suspendedReceivers;
    var tmp154_subject = _get_holder__f6h5pd(this_1);
    if (tmp154_subject == null) {
      break $l$block;
    } else {
      if (!(tmp154_subject instanceof ArrayList)) {
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.cancelSuspendedReceiveRequests.<anonymous>' call
        var tmp = _get_holder__f6h5pd(this_1);
        var it = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
        resumeReceiverOnClosedChannel(it, $this);
      } else {
        var tmp_0 = _get_holder__f6h5pd(this_1);
        var list = tmp_0 instanceof ArrayList ? tmp_0 : THROW_CCE();
        var inductionVariable_0 = list.f1() - 1 | 0;
        if (0 <= inductionVariable_0)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + -1 | 0;
            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.cancelSuspendedReceiveRequests.<anonymous>' call
            var it_0 = list.e1(i);
            resumeReceiverOnClosedChannel(it_0, $this);
          }
           while (0 <= inductionVariable_0);
      }
    }
  }
}
function resumeReceiverOnClosedChannel(_this__u8e3s4, $this) {
  return resumeWaiterOnClosedChannel(_this__u8e3s4, $this, true);
}
function resumeSenderOnCancelledChannel(_this__u8e3s4, $this) {
  return resumeWaiterOnClosedChannel(_this__u8e3s4, $this, false);
}
function resumeWaiterOnClosedChannel(_this__u8e3s4, $this, receiver) {
  if (_this__u8e3s4 instanceof SendBroadcast) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = _this__u8e3s4.f1l_1;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(false);
    this_0.bd(tmp$ret$0);
  } else {
    if (isInterface(_this__u8e3s4, CancellableContinuation)) {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = receiver ? _get_receiveException__foorc1($this) : $this.r1k();
      var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
      _this__u8e3s4.bd(tmp$ret$2);
    } else {
      if (_this__u8e3s4 instanceof ReceiveCatching) {
        // Inline function 'kotlin.coroutines.resume' call
        var this_1 = _this__u8e3s4.a1l_1;
        // Inline function 'kotlin.Companion.success' call
        var value = new ChannelResult(Companion_getInstance_0().u1l($this.l1l()));
        var tmp$ret$4 = _Result___init__impl__xyqfz8(value);
        this_1.bd(tmp$ret$4);
      } else {
        if (_this__u8e3s4 instanceof BufferedChannelIterator) {
          _this__u8e3s4.k1l();
        } else {
          if (isInterface(_this__u8e3s4, SelectInstance))
            _this__u8e3s4.b1l($this, get_CHANNEL_CLOSED());
          else {
            var message = 'Unexpected waiter: ' + toString(_this__u8e3s4);
            throw IllegalStateException.h5(toString(message));
          }
        }
      }
    }
  }
}
function _get_isClosedForSend0__kxgf9m(_this__u8e3s4, $this) {
  return isClosed($this, _this__u8e3s4, false);
}
function _get_isClosedForReceive0__f7qknl(_this__u8e3s4, $this) {
  return isClosed($this, _this__u8e3s4, true);
}
function isClosed($this, sendersAndCloseStatusCur, isClosedForReceive) {
  // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
  var tmp;
  switch (sendersAndCloseStatusCur.h4(60).j2()) {
    case 0:
      tmp = false;
      break;
    case 1:
      tmp = false;
      break;
    case 2:
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

      var tmp$ret$1 = sendersAndCloseStatusCur.j4(new Long(-1, 268435455));
      completeClose($this, tmp$ret$1);
      tmp = isClosedForReceive ? !$this.v1l() : true;
      break;
    case 3:
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

      var tmp$ret$2 = sendersAndCloseStatusCur.j4(new Long(-1, 268435455));
      completeCancel($this, tmp$ret$2);
      tmp = true;
      break;
    default:
      // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call

      var message = 'unexpected close status: ' + sendersAndCloseStatusCur.h4(60).j2();
      throw IllegalStateException.h5(toString(message));
  }
  return tmp;
}
function isCellNonEmpty($this, segment, index, globalIndex) {
  while (true) {
    var state = segment.m1j(index);
    if (state === null || state === get_IN_BUFFER()) {
      if (segment.o1j(index, state, get_POISONED())) {
        expandBuffer($this);
        return false;
      }
    } else if (state === get_BUFFERED())
      return true;
    else if (state === get_INTERRUPTED_SEND())
      return false;
    else if (state === get_CHANNEL_CLOSED())
      return false;
    else if (state === get_DONE_RCV())
      return false;
    else if (state === get_POISONED())
      return false;
    else if (state === get_RESUMING_BY_EB())
      return true;
    else if (state === get_RESUMING_BY_RCV())
      return false;
    else
      return globalIndex.equals($this.q1k());
  }
}
function findSegmentSend($this, id, startFrom) {
  // Inline function 'kotlin.let' call
  var tmp$ret$1;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    var this_0 = $this.w1j_1;
    var createNewSegment = createSegmentFunction();
    while (true) {
      var s = findSegmentInternal(startFrom, id, createNewSegment);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp$ret$0;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          var to = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
          while (true) {
            // Inline function 'kotlinx.coroutines.internal.moveForward.<anonymous>' call
            var cur = this_0.kotlinx$atomicfu$value;
            if (cur.a1b_1.x1(to.a1b_1) >= 0) {
              tmp$ret$0 = true;
              break $l$block_1;
            }
            if (!to.g1k()) {
              tmp$ret$0 = false;
              break $l$block_1;
            }
            if (this_0.atomicfu$compareAndSet(cur, to)) {
              if (cur.h1k()) {
                cur.r6();
              }
              tmp$ret$0 = true;
              break $l$block_1;
            }
            if (to.h1k()) {
              to.r6();
            }
          }
          tmp$ret$0 = Unit_instance;
        }
        tmp = tmp$ret$0;
      }
      if (tmp) {
        tmp$ret$1 = s;
        break $l$block_2;
      }
    }
  }
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlinx.coroutines.channels.BufferedChannel.findSegmentSend.<anonymous>' call
  var it = tmp$ret$1;
  var tmp_0;
  if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
    completeCloseOrCancel($this);
    // Inline function 'kotlin.Long.times' call
    var this_1 = startFrom.a1b_1;
    var other = get_SEGMENT_SIZE();
    if (this_1.z3(toLong(other)).x1($this.q1k()) < 0) {
      startFrom.o1k();
    }
    tmp_0 = null;
  } else {
    var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
    var tmp_1;
    if (segment.a1b_1.x1(id) > 0) {
      // Inline function 'kotlin.Long.times' call
      var this_2 = segment.a1b_1;
      var other_0 = get_SEGMENT_SIZE();
      var tmp$ret$3 = this_2.z3(toLong(other_0));
      updateSendersCounterIfLower($this, tmp$ret$3);
      // Inline function 'kotlin.Long.times' call
      var this_3 = segment.a1b_1;
      var other_1 = get_SEGMENT_SIZE();
      if (this_3.z3(toLong(other_1)).x1($this.q1k()) < 0) {
        segment.o1k();
      }
      tmp_1 = null;
    } else {
      // Inline function 'kotlinx.coroutines.assert' call
      tmp_1 = segment;
    }
    tmp_0 = tmp_1;
  }
  return tmp_0;
}
function findSegmentReceive($this, id, startFrom) {
  // Inline function 'kotlin.let' call
  var tmp$ret$1;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    var this_0 = $this.x1j_1;
    var createNewSegment = createSegmentFunction();
    while (true) {
      var s = findSegmentInternal(startFrom, id, createNewSegment);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp$ret$0;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          var to = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
          while (true) {
            // Inline function 'kotlinx.coroutines.internal.moveForward.<anonymous>' call
            var cur = this_0.kotlinx$atomicfu$value;
            if (cur.a1b_1.x1(to.a1b_1) >= 0) {
              tmp$ret$0 = true;
              break $l$block_1;
            }
            if (!to.g1k()) {
              tmp$ret$0 = false;
              break $l$block_1;
            }
            if (this_0.atomicfu$compareAndSet(cur, to)) {
              if (cur.h1k()) {
                cur.r6();
              }
              tmp$ret$0 = true;
              break $l$block_1;
            }
            if (to.h1k()) {
              to.r6();
            }
          }
          tmp$ret$0 = Unit_instance;
        }
        tmp = tmp$ret$0;
      }
      if (tmp) {
        tmp$ret$1 = s;
        break $l$block_2;
      }
    }
  }
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlinx.coroutines.channels.BufferedChannel.findSegmentReceive.<anonymous>' call
  var it = tmp$ret$1;
  var tmp_0;
  if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
    completeCloseOrCancel($this);
    // Inline function 'kotlin.Long.times' call
    var this_1 = startFrom.a1b_1;
    var other = get_SEGMENT_SIZE();
    if (this_1.z3(toLong(other)).x1($this.d1l()) < 0) {
      startFrom.o1k();
    }
    tmp_0 = null;
  } else {
    var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
    var tmp_1;
    if (!_get_isRendezvousOrUnlimited__3mdufi($this)) {
      // Inline function 'kotlin.Long.div' call
      var this_2 = _get_bufferEndCounter__2d4hee($this);
      var other_0 = get_SEGMENT_SIZE();
      var tmp$ret$3 = this_2.a4(toLong(other_0));
      tmp_1 = id.x1(tmp$ret$3) <= 0;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      $l$block_5: {
        // Inline function 'kotlinx.coroutines.internal.moveForward' call
        var this_3 = $this.y1j_1;
        while (true) {
          // Inline function 'kotlinx.coroutines.internal.moveForward.<anonymous>' call
          var cur_0 = this_3.kotlinx$atomicfu$value;
          if (cur_0.a1b_1.x1(segment.a1b_1) >= 0) {
            break $l$block_5;
          }
          if (!segment.g1k()) {
            break $l$block_5;
          }
          if (this_3.atomicfu$compareAndSet(cur_0, segment)) {
            if (cur_0.h1k()) {
              cur_0.r6();
            }
            break $l$block_5;
          }
          if (segment.h1k()) {
            segment.r6();
          }
        }
      }
    }
    var tmp_2;
    if (segment.a1b_1.x1(id) > 0) {
      // Inline function 'kotlin.Long.times' call
      var this_4 = segment.a1b_1;
      var other_1 = get_SEGMENT_SIZE();
      var tmp$ret$5 = this_4.z3(toLong(other_1));
      updateReceiversCounterIfLower($this, tmp$ret$5);
      // Inline function 'kotlin.Long.times' call
      var this_5 = segment.a1b_1;
      var other_2 = get_SEGMENT_SIZE();
      if (this_5.z3(toLong(other_2)).x1($this.d1l()) < 0) {
        segment.o1k();
      }
      tmp_2 = null;
    } else {
      // Inline function 'kotlinx.coroutines.assert' call
      tmp_2 = segment;
    }
    tmp_0 = tmp_2;
  }
  return tmp_0;
}
function findSegmentBufferEnd($this, id, startFrom, currentBufferEndCounter) {
  // Inline function 'kotlin.let' call
  var tmp$ret$1;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    var this_0 = $this.y1j_1;
    var createNewSegment = createSegmentFunction();
    while (true) {
      var s = findSegmentInternal(startFrom, id, createNewSegment);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp$ret$0;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          var to = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
          while (true) {
            // Inline function 'kotlinx.coroutines.internal.moveForward.<anonymous>' call
            var cur = this_0.kotlinx$atomicfu$value;
            if (cur.a1b_1.x1(to.a1b_1) >= 0) {
              tmp$ret$0 = true;
              break $l$block_1;
            }
            if (!to.g1k()) {
              tmp$ret$0 = false;
              break $l$block_1;
            }
            if (this_0.atomicfu$compareAndSet(cur, to)) {
              if (cur.h1k()) {
                cur.r6();
              }
              tmp$ret$0 = true;
              break $l$block_1;
            }
            if (to.h1k()) {
              to.r6();
            }
          }
          tmp$ret$0 = Unit_instance;
        }
        tmp = tmp$ret$0;
      }
      if (tmp) {
        tmp$ret$1 = s;
        break $l$block_2;
      }
    }
  }
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlinx.coroutines.channels.BufferedChannel.findSegmentBufferEnd.<anonymous>' call
  var it = tmp$ret$1;
  var tmp_0;
  if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
    completeCloseOrCancel($this);
    moveSegmentBufferEndToSpecifiedOrLast($this, id, startFrom);
    incCompletedExpandBufferAttempts$default($this);
    tmp_0 = null;
  } else {
    var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
    var tmp_1;
    if (segment.a1b_1.x1(id) > 0) {
      // Inline function 'kotlin.Long.plus' call
      var tmp_2 = currentBufferEndCounter.y3(toLong(1));
      // Inline function 'kotlin.Long.times' call
      var this_1 = segment.a1b_1;
      var other = get_SEGMENT_SIZE();
      var tmp$ret$3 = this_1.z3(toLong(other));
      if ($this.u1j_1.atomicfu$compareAndSet(tmp_2, tmp$ret$3)) {
        // Inline function 'kotlin.Long.times' call
        var this_2 = segment.a1b_1;
        var other_0 = get_SEGMENT_SIZE();
        var tmp$ret$4 = this_2.z3(toLong(other_0));
        incCompletedExpandBufferAttempts($this, tmp$ret$4.y1(currentBufferEndCounter));
      } else {
        incCompletedExpandBufferAttempts$default($this);
      }
      tmp_1 = null;
    } else {
      // Inline function 'kotlinx.coroutines.assert' call
      tmp_1 = segment;
    }
    tmp_0 = tmp_1;
  }
  return tmp_0;
}
function moveSegmentBufferEndToSpecifiedOrLast($this, id, startFrom) {
  var segment = startFrom;
  $l$loop: while (segment.a1b_1.x1(id) < 0) {
    var tmp0_elvis_lhs = segment.k1k();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      break $l$loop;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    segment = tmp;
  }
  while (true) {
    $l$loop_0: while (segment.f1k()) {
      var tmp1_elvis_lhs = segment.k1k();
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        break $l$loop_0;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      segment = tmp_0;
    }
    var tmp$ret$0;
    $l$block_1: {
      // Inline function 'kotlinx.coroutines.internal.moveForward' call
      var this_0 = $this.y1j_1;
      var to = segment;
      while (true) {
        // Inline function 'kotlinx.coroutines.internal.moveForward.<anonymous>' call
        var cur = this_0.kotlinx$atomicfu$value;
        if (cur.a1b_1.x1(to.a1b_1) >= 0) {
          tmp$ret$0 = true;
          break $l$block_1;
        }
        if (!to.g1k()) {
          tmp$ret$0 = false;
          break $l$block_1;
        }
        if (this_0.atomicfu$compareAndSet(cur, to)) {
          if (cur.h1k()) {
            cur.r6();
          }
          tmp$ret$0 = true;
          break $l$block_1;
        }
        if (to.h1k()) {
          to.r6();
        }
      }
      tmp$ret$0 = Unit_instance;
    }
    if (tmp$ret$0)
      return Unit_instance;
  }
}
function updateSendersCounterIfLower($this, value) {
  var this_0 = $this.s1j_1;
  while (true) {
    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.updateSendersCounterIfLower.<anonymous>' call
    var cur = this_0.kotlinx$atomicfu$value;
    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
    var curCounter = cur.j4(new Long(-1, 268435455));
    if (curCounter.x1(value) >= 0)
      return Unit_instance;
    // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
    var tmp$ret$1 = cur.h4(60).j2();
    var update = constructSendersAndCloseStatus(curCounter, tmp$ret$1);
    if ($this.s1j_1.atomicfu$compareAndSet(cur, update))
      return Unit_instance;
  }
  return Unit_instance;
}
function updateReceiversCounterIfLower($this, value) {
  var this_0 = $this.t1j_1;
  while (true) {
    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.updateReceiversCounterIfLower.<anonymous>' call
    var cur = this_0.kotlinx$atomicfu$value;
    if (cur.x1(value) >= 0)
      return Unit_instance;
    if ($this.t1j_1.atomicfu$compareAndSet(cur, value))
      return Unit_instance;
  }
  return Unit_instance;
}
function bindCancellationFunResult(_this__u8e3s4, $this) {
  return BufferedChannel$onCancellationChannelResultImplDoNotCall$ref($this);
}
function onCancellationChannelResultImplDoNotCall($this, cause, element, context) {
  callUndeliveredElement(ensureNotNull($this.r1j_1), ensureNotNull(ChannelResult__getOrNull_impl_f5e07h(element)), context);
}
function bindCancellationFun(_this__u8e3s4, $this, element) {
  return BufferedChannel$bindCancellationFun$lambda(_this__u8e3s4, element);
}
function bindCancellationFun_0(_this__u8e3s4, $this) {
  return BufferedChannel$onCancellationImplDoNotCall$ref($this);
}
function onCancellationImplDoNotCall($this, cause, element, context) {
  callUndeliveredElement(ensureNotNull($this.r1j_1), element, context);
}
function BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda$lambda($element, this$0, $select) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
    var tmp;
    if (!($element === get_CHANNEL_CLOSED())) {
      callUndeliveredElement(this$0.r1j_1, ($element == null ? true : !($element == null)) ? $element : THROW_CCE(), $select.zc());
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda(this$0) {
  return function (select, _unused_var__etf5q3, element) {
    return BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda$lambda(element, this$0, select);
  };
}
function BufferedChannel$onCancellationChannelResultImplDoNotCall$ref($boundThis) {
  var l = function (p0, p1, p2) {
    onCancellationChannelResultImplDoNotCall($boundThis, p0, p1.x1l_1, p2);
    return Unit_instance;
  };
  l.callableName = 'onCancellationChannelResultImplDoNotCall';
  return l;
}
function BufferedChannel$bindCancellationFun$lambda($this_bindCancellationFun, $element) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, context) {
    callUndeliveredElement($this_bindCancellationFun, $element, context);
    return Unit_instance;
  };
}
function BufferedChannel$onCancellationImplDoNotCall$ref($boundThis) {
  var l = function (p0, p1, p2) {
    onCancellationImplDoNotCall($boundThis, p0, p1, p2);
    return Unit_instance;
  };
  l.callableName = 'onCancellationImplDoNotCall';
  return l;
}
function initialBufferEnd(capacity) {
  _init_properties_BufferedChannel_kt__d6uc4y();
  switch (capacity) {
    case 0:
      return new Long(0, 0);
    case 2147483647:
      return new Long(-1, 2147483647);
    default:
      return toLong(capacity);
  }
}
function tryResume0(_this__u8e3s4, value, onCancellation) {
  onCancellation = onCancellation === VOID ? null : onCancellation;
  _init_properties_BufferedChannel_kt__d6uc4y();
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlinx.coroutines.channels.tryResume0.<anonymous>' call
  var token = _this__u8e3s4.y19(value, null, onCancellation);
  var tmp;
  if (!(token == null)) {
    _this__u8e3s4.z19(token);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function constructEBCompletedAndPauseFlag(counter, pauseEB) {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return (pauseEB ? new Long(0, 1073741824) : new Long(0, 0)).y3(counter);
}
function constructSendersAndCloseStatus(counter, closeStatus) {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return toLong(closeStatus).g4(60).y3(counter);
}
function createSegmentFunction() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return createSegment$ref();
}
function createSegment(id, prev) {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return new ChannelSegment(id, prev, prev.g1j(), 0);
}
function _get_SUSPEND_NO_WAITER_$accessor$yt74tm_n6n1ky() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return get_SUSPEND_NO_WAITER();
}
function _get_SUSPEND_$accessor$yt74tm_ccb8g1() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return get_SUSPEND();
}
function _get_FAILED_$accessor$yt74tm_h47uk8() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return get_FAILED();
}
function createSegment$ref() {
  var l = function (p0, p1) {
    return createSegment(p0, p1);
  };
  l.callableName = 'createSegment';
  return l;
}
var properties_initialized_BufferedChannel_kt_58tjvw;
function _init_properties_BufferedChannel_kt__d6uc4y() {
  if (!properties_initialized_BufferedChannel_kt_58tjvw) {
    properties_initialized_BufferedChannel_kt_58tjvw = true;
    NULL_SEGMENT = new ChannelSegment(new Long(-1, -1), null, null, 0);
    SEGMENT_SIZE = systemProp('kotlinx.coroutines.bufferedChannel.segmentSize', 32);
    EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS = systemProp('kotlinx.coroutines.bufferedChannel.expandBufferCompletionWaitIterations', 10000);
    BUFFERED = new Symbol('BUFFERED');
    IN_BUFFER = new Symbol('SHOULD_BUFFER');
    RESUMING_BY_RCV = new Symbol('S_RESUMING_BY_RCV');
    RESUMING_BY_EB = new Symbol('RESUMING_BY_EB');
    POISONED = new Symbol('POISONED');
    DONE_RCV = new Symbol('DONE_RCV');
    INTERRUPTED_SEND = new Symbol('INTERRUPTED_SEND');
    INTERRUPTED_RCV = new Symbol('INTERRUPTED_RCV');
    CHANNEL_CLOSED = new Symbol('CHANNEL_CLOSED');
    SUSPEND = new Symbol('SUSPEND');
    SUSPEND_NO_WAITER = new Symbol('SUSPEND_NO_WAITER');
    FAILED = new Symbol('FAILED');
    NO_RECEIVE_RESULT = new Symbol('NO_RECEIVE_RESULT');
    CLOSE_HANDLER_CLOSED = new Symbol('CLOSE_HANDLER_CLOSED');
    CLOSE_HANDLER_INVOKED = new Symbol('CLOSE_HANDLER_INVOKED');
    NO_CLOSE_CAUSE = new Symbol('NO_CLOSE_CAUSE');
  }
}
var Factory_instance;
function Factory_getInstance() {
  if (Factory_instance === VOID)
    new Factory();
  return Factory_instance;
}
function _ChannelResult___init__impl__siwsuf(holder) {
  return holder;
}
function _ChannelResult___get_holder__impl__pm9gzw($this) {
  return $this;
}
function _ChannelResult___get_isSuccess__impl__odq1z9($this) {
  var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
  return !(tmp instanceof Failed);
}
function _ChannelResult___get_isClosed__impl__mg7kuu($this) {
  var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
  return tmp instanceof Closed;
}
function ChannelResult__getOrNull_impl_f5e07h($this) {
  var tmp;
  var tmp_0 = _ChannelResult___get_holder__impl__pm9gzw($this);
  if (!(tmp_0 instanceof Failed)) {
    var tmp_1 = _ChannelResult___get_holder__impl__pm9gzw($this);
    tmp = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
  } else {
    tmp = null;
  }
  return tmp;
}
function ChannelResult__exceptionOrNull_impl_16ei30($this) {
  var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
  var tmp112_safe_receiver = tmp instanceof Closed ? tmp : null;
  return tmp112_safe_receiver == null ? null : tmp112_safe_receiver.p1m_1;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new Companion();
  return Companion_instance_0;
}
function ChannelResult__toString_impl_rrcqu7($this) {
  var tmp;
  if (_ChannelResult___get_holder__impl__pm9gzw($this) instanceof Closed) {
    tmp = _ChannelResult___get_holder__impl__pm9gzw($this).toString();
  } else {
    tmp = 'Value(' + toString_0(_ChannelResult___get_holder__impl__pm9gzw($this)) + ')';
  }
  return tmp;
}
function ChannelResult__hashCode_impl_lilec2($this) {
  return $this == null ? 0 : hashCode($this);
}
function ChannelResult__equals_impl_f471ri($this, other) {
  if (!(other instanceof ChannelResult))
    return false;
  var tmp0_other_with_cast = other instanceof ChannelResult ? other.x1l_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function Channel(capacity, onBufferOverflow, onUndeliveredElement) {
  capacity = capacity === VOID ? 0 : capacity;
  onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
  onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
  var tmp;
  switch (capacity) {
    case 0:
      tmp = onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) ? new BufferedChannel(0, onUndeliveredElement) : new ConflatedBufferedChannel(1, onBufferOverflow, onUndeliveredElement);
      break;
    case -1:
      // Inline function 'kotlin.require' call

      // Inline function 'kotlin.contracts.contract' call

      if (!onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance())) {
        // Inline function 'kotlinx.coroutines.channels.Channel.<anonymous>' call
        var message = 'CONFLATED capacity cannot be used with non-default onBufferOverflow';
        throw IllegalArgumentException.l(toString(message));
      }

      tmp = new ConflatedBufferedChannel(1, BufferOverflow_DROP_OLDEST_getInstance(), onUndeliveredElement);
      break;
    case 2147483647:
      tmp = new BufferedChannel(2147483647, onUndeliveredElement);
      break;
    case -2:
      tmp = onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) ? new BufferedChannel(Factory_getInstance().o1m_1, onUndeliveredElement) : new ConflatedBufferedChannel(1, onBufferOverflow, onUndeliveredElement);
      break;
    default:
      tmp = onBufferOverflow === BufferOverflow_SUSPEND_getInstance() ? new BufferedChannel(capacity, onUndeliveredElement) : new ConflatedBufferedChannel(capacity, onBufferOverflow, onUndeliveredElement);
      break;
  }
  return tmp;
}
function trySendImpl($this, element, isSendOp) {
  return $this.d1n_1 === BufferOverflow_DROP_LATEST_getInstance() ? trySendDropLatest($this, element, isSendOp) : $this.b1m(element);
}
function trySendDropLatest($this, element, isSendOp) {
  var result = protoOf(BufferedChannel).z1l.call($this, element);
  if (_ChannelResult___get_isSuccess__impl__odq1z9(result) || _ChannelResult___get_isClosed__impl__mg7kuu(result))
    return result;
  if (isSendOp) {
    var tmp118_safe_receiver = $this.r1j_1;
    var tmp119_safe_receiver = tmp118_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp118_safe_receiver, element);
    if (tmp119_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      throw tmp119_safe_receiver;
    }
  }
  return Companion_getInstance_0().z1k(Unit_instance);
}
function get_CLOSED() {
  _init_properties_ConcurrentLinkedList_kt__5gcgzy();
  return CLOSED;
}
var CLOSED;
function close(_this__u8e3s4) {
  _init_properties_ConcurrentLinkedList_kt__5gcgzy();
  var cur = _this__u8e3s4;
  while (true) {
    // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed' call
    var this_0 = cur;
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed.<anonymous>' call
    var it = _get_nextOrClosed__w0gmuv(this_0);
    var tmp;
    if (it === get_CLOSED()) {
      // Inline function 'kotlinx.coroutines.internal.close.<anonymous>' call
      return cur;
    } else {
      tmp = (it == null ? true : it instanceof ConcurrentLinkedListNode) ? it : THROW_CCE();
    }
    var next = tmp;
    if (next === null) {
      if (cur.p1k())
        return cur;
    } else {
      cur = next;
    }
  }
}
function _SegmentOrClosed___init__impl__jnexvb(value) {
  return value;
}
function _get_value__a43j40($this) {
  return $this;
}
function _SegmentOrClosed___get_isClosed__impl__qmxmlo($this) {
  return _get_value__a43j40($this) === get_CLOSED();
}
function _SegmentOrClosed___get_segment__impl__jvcr9l($this) {
  var tmp;
  if (_get_value__a43j40($this) === get_CLOSED()) {
    var message = 'Does not contain segment';
    throw IllegalStateException.h5(toString(message));
  } else {
    var tmp_0 = _get_value__a43j40($this);
    tmp = tmp_0 instanceof Segment ? tmp_0 : THROW_CCE();
  }
  return tmp;
}
function SegmentOrClosed__toString_impl_pzb2an($this) {
  return 'SegmentOrClosed(value=' + toString_0($this) + ')';
}
function SegmentOrClosed__hashCode_impl_4855hs($this) {
  return $this == null ? 0 : hashCode($this);
}
function SegmentOrClosed__equals_impl_6erq1g($this, other) {
  if (!(other instanceof SegmentOrClosed))
    return false;
  var tmp0_other_with_cast = other instanceof SegmentOrClosed ? other.w1l_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function _get_nextOrClosed__w0gmuv($this) {
  return $this.i1k_1.kotlinx$atomicfu$value;
}
function _get_aliveSegmentLeft__mr4ndu($this) {
  var cur = $this.n1k();
  while (!(cur === null) && cur.f1k())
    cur = cur.j1k_1.kotlinx$atomicfu$value;
  return cur;
}
function _get_aliveSegmentRight__7ulr0b($this) {
  // Inline function 'kotlinx.coroutines.assert' call
  var cur = ensureNotNull($this.k1k());
  while (cur.f1k()) {
    var tmp0_elvis_lhs = cur.k1k();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return cur;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    cur = tmp;
  }
  return cur;
}
function findSegmentInternal(_this__u8e3s4, id, createNewSegment) {
  _init_properties_ConcurrentLinkedList_kt__5gcgzy();
  var cur = _this__u8e3s4;
  $l$loop: while (cur.a1b_1.x1(id) < 0 || cur.f1k()) {
    // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed' call
    var this_0 = cur;
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed.<anonymous>' call
    var it = _get_nextOrClosed__w0gmuv(this_0);
    var tmp;
    if (it === get_CLOSED()) {
      // Inline function 'kotlinx.coroutines.internal.findSegmentInternal.<anonymous>' call
      return _SegmentOrClosed___init__impl__jnexvb(get_CLOSED());
    } else {
      tmp = (it == null ? true : it instanceof ConcurrentLinkedListNode) ? it : THROW_CCE();
    }
    var next = tmp;
    if (!(next == null)) {
      cur = next;
      continue $l$loop;
    }
    // Inline function 'kotlin.Long.plus' call
    var newTail = createNewSegment(cur.a1b_1.y3(toLong(1)), cur);
    if (cur.l1k(newTail)) {
      if (cur.f1k()) {
        cur.r6();
      }
      cur = newTail;
    }
  }
  return _SegmentOrClosed___init__impl__jnexvb(cur);
}
var properties_initialized_ConcurrentLinkedList_kt_kwt434;
function _init_properties_ConcurrentLinkedList_kt__5gcgzy() {
  if (!properties_initialized_ConcurrentLinkedList_kt_kwt434) {
    properties_initialized_ConcurrentLinkedList_kt_kwt434 = true;
    CLOSED = new Symbol('CLOSED');
  }
}
function handleUncaughtCoroutineException(context, exception) {
  var _iterator__ex2g4s = get_platformExceptionHandlers().b1();
  while (_iterator__ex2g4s.c1()) {
    var handler = _iterator__ex2g4s.d1();
    try {
      handler.u1d(context, exception);
    } catch ($p) {
      if ($p instanceof ExceptionSuccessfullyProcessed) {
        var _unused_var__etf5q3 = $p;
        return Unit_instance;
      } else {
        if ($p instanceof Error) {
          var t = $p;
          propagateExceptionFinalResort(handlerException(exception, t));
        } else {
          throw $p;
        }
      }
    }
  }
  try {
    addSuppressed(exception, DiagnosticCoroutineContextException.h1n(context));
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
    } else {
      throw $p;
    }
  }
  propagateExceptionFinalResort(exception);
}
function get_UNDEFINED() {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  return UNDEFINED;
}
var UNDEFINED;
function get_REUSABLE_CLAIMED() {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  return REUSABLE_CLAIMED;
}
var REUSABLE_CLAIMED;
function _get_reusableCancellableContinuation__9qex09($this) {
  var tmp = $this.s1a_1.kotlinx$atomicfu$value;
  return tmp instanceof CancellableContinuationImpl ? tmp : null;
}
function resumeCancellableWith(_this__u8e3s4, result) {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  var tmp;
  if (_this__u8e3s4 instanceof DispatchedContinuation) {
    var state = toState_0(result);
    if (_this__u8e3s4.o1a_1.q1d(_this__u8e3s4.zc())) {
      _this__u8e3s4.q1a_1 = state;
      _this__u8e3s4.w1a_1 = 1;
      _this__u8e3s4.o1a_1.r1d(_this__u8e3s4.zc(), _this__u8e3s4);
    } else {
      $l$block: {
        // Inline function 'kotlinx.coroutines.internal.executeUnconfined' call
        // Inline function 'kotlinx.coroutines.assert' call
        var eventLoop = ThreadLocalEventLoop_getInstance().t1e();
        if (false && eventLoop.o1e()) {
          break $l$block;
        }
        var tmp_0;
        if (eventLoop.n1e()) {
          _this__u8e3s4.q1a_1 = state;
          _this__u8e3s4.w1a_1 = 1;
          eventLoop.m1e(_this__u8e3s4);
          tmp_0 = true;
        } else {
          // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
          eventLoop.p1e(true);
          try {
            // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeCancellableWith.<anonymous>' call
            var tmp$ret$3;
            $l$block_0: {
              // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeCancelled' call
              var job = _this__u8e3s4.zc().md(Key_instance_3);
              if (!(job == null) && !job.c17()) {
                var cause = job.z17();
                _this__u8e3s4.u1b(state, cause);
                // Inline function 'kotlin.coroutines.resumeWithException' call
                // Inline function 'kotlin.Companion.failure' call
                var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(cause));
                _this__u8e3s4.bd(tmp$ret$1);
                tmp$ret$3 = true;
                break $l$block_0;
              }
              tmp$ret$3 = false;
            }
            if (!tmp$ret$3) {
              // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeUndispatchedWith' call
              // Inline function 'kotlinx.coroutines.withContinuationContext' call
              _this__u8e3s4.p1a_1;
              _this__u8e3s4.r1a_1;
              _this__u8e3s4.p1a_1.bd(result);
            }
            $l$loop: while (eventLoop.l1e()) {
            }
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              _this__u8e3s4.o1c(e);
            } else {
              throw $p;
            }
          }
          finally {
            eventLoop.q1e(true);
          }
          tmp_0 = false;
        }
      }
    }
    tmp = Unit_instance;
  } else {
    _this__u8e3s4.bd(result);
    tmp = Unit_instance;
  }
  return tmp;
}
function yieldUndispatched(_this__u8e3s4) {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlinx.coroutines.internal.executeUnconfined' call
    // Inline function 'kotlinx.coroutines.assert' call
    var eventLoop = ThreadLocalEventLoop_getInstance().t1e();
    if (true && eventLoop.o1e()) {
      tmp$ret$0 = false;
      break $l$block;
    }
    var tmp;
    if (eventLoop.n1e()) {
      _this__u8e3s4.q1a_1 = Unit_instance;
      _this__u8e3s4.w1a_1 = 1;
      eventLoop.m1e(_this__u8e3s4);
      tmp = true;
    } else {
      // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
      eventLoop.p1e(true);
      try {
        // Inline function 'kotlinx.coroutines.internal.yieldUndispatched.<anonymous>' call
        _this__u8e3s4.n1c();
        $l$loop: while (eventLoop.l1e()) {
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          _this__u8e3s4.o1c(e);
        } else {
          throw $p;
        }
      }
      finally {
        eventLoop.q1e(true);
      }
      tmp = false;
    }
    tmp$ret$0 = tmp;
  }
  return tmp$ret$0;
}
var properties_initialized_DispatchedContinuation_kt_2siadq;
function _init_properties_DispatchedContinuation_kt__tnmqc0() {
  if (!properties_initialized_DispatchedContinuation_kt_2siadq) {
    properties_initialized_DispatchedContinuation_kt_2siadq = true;
    UNDEFINED = new Symbol('UNDEFINED');
    REUSABLE_CLAIMED = new Symbol('REUSABLE_CLAIMED');
  }
}
function get_isReusableMode(_this__u8e3s4) {
  return _this__u8e3s4 === 2;
}
function get_isCancellableMode(_this__u8e3s4) {
  return _this__u8e3s4 === 1 || _this__u8e3s4 === 2;
}
function dispatch(_this__u8e3s4, mode) {
  // Inline function 'kotlinx.coroutines.assert' call
  var delegate = _this__u8e3s4.r1b();
  var undispatched = mode === 4;
  var tmp;
  var tmp_0;
  if (!undispatched) {
    tmp_0 = delegate instanceof DispatchedContinuation;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = get_isCancellableMode(mode) === get_isCancellableMode(_this__u8e3s4.w1a_1);
  } else {
    tmp = false;
  }
  if (tmp) {
    var dispatcher = delegate.o1a_1;
    var context = delegate.zc();
    if (dispatcher.q1d(context)) {
      dispatcher.r1d(context, _this__u8e3s4);
    } else {
      resumeUnconfined(_this__u8e3s4);
    }
  } else {
    resume(_this__u8e3s4, delegate, undispatched);
  }
}
function resumeUnconfined(_this__u8e3s4) {
  var eventLoop = ThreadLocalEventLoop_getInstance().t1e();
  if (eventLoop.n1e()) {
    eventLoop.m1e(_this__u8e3s4);
  } else {
    // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
    eventLoop.p1e(true);
    try {
      // Inline function 'kotlinx.coroutines.resumeUnconfined.<anonymous>' call
      resume(_this__u8e3s4, _this__u8e3s4.r1b(), true);
      $l$loop: while (eventLoop.l1e()) {
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        _this__u8e3s4.o1c(e);
      } else {
        throw $p;
      }
    }
    finally {
      eventLoop.q1e(true);
    }
  }
}
function resume(_this__u8e3s4, delegate, undispatched) {
  var state = _this__u8e3s4.t1b();
  var exception = _this__u8e3s4.l1c(state);
  var tmp;
  if (!(exception == null)) {
    // Inline function 'kotlin.Companion.failure' call
    tmp = _Result___init__impl__xyqfz8(createFailure(exception));
  } else {
    // Inline function 'kotlin.Companion.success' call
    var value = _this__u8e3s4.b1c(state);
    tmp = _Result___init__impl__xyqfz8(value);
  }
  var result = tmp;
  if (undispatched) {
    // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeUndispatchedWith' call
    var this_0 = delegate instanceof DispatchedContinuation ? delegate : THROW_CCE();
    // Inline function 'kotlinx.coroutines.withContinuationContext' call
    this_0.p1a_1;
    this_0.r1a_1;
    this_0.p1a_1.bd(result);
  } else {
    delegate.bd(result);
  }
}
function _InlineList___init__impl__z8n56(holder) {
  holder = holder === VOID ? null : holder;
  return holder;
}
function _get_holder__f6h5pd($this) {
  return $this;
}
function InlineList__plus_impl_nuetvo($this, element) {
  // Inline function 'kotlinx.coroutines.assert' call
  var tmp153_subject = _get_holder__f6h5pd($this);
  var tmp;
  if (tmp153_subject == null) {
    tmp = _InlineList___init__impl__z8n56(element);
  } else {
    if (tmp153_subject instanceof ArrayList) {
      var tmp_0 = _get_holder__f6h5pd($this);
      (tmp_0 instanceof ArrayList ? tmp_0 : THROW_CCE()).h(element);
      tmp = _InlineList___init__impl__z8n56(_get_holder__f6h5pd($this));
    } else {
      var list = ArrayList.w(4);
      var tmp_1 = _get_holder__f6h5pd($this);
      list.h((tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE());
      list.h(element);
      tmp = _InlineList___init__impl__z8n56(list);
    }
  }
  return tmp;
}
function callUndeliveredElement(_this__u8e3s4, element, context) {
  var tmp156_safe_receiver = callUndeliveredElementCatchingException(_this__u8e3s4, element, null);
  if (tmp156_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    handleCoroutineException(context, tmp156_safe_receiver);
  }
}
function callUndeliveredElementCatchingException(_this__u8e3s4, element, undeliveredElementException) {
  undeliveredElementException = undeliveredElementException === VOID ? null : undeliveredElementException;
  try {
    _this__u8e3s4(element);
  } catch ($p) {
    if ($p instanceof Error) {
      var ex = $p;
      if (!(undeliveredElementException == null) && !(undeliveredElementException.cause === ex)) {
        addSuppressed(undeliveredElementException, ex);
      } else {
        return UndeliveredElementException.m1n('Exception in undelivered element handler for ' + toString_0(element), ex);
      }
    } else {
      throw $p;
    }
  }
  return undeliveredElementException;
}
function systemProp(propertyName, defaultValue, minValue, maxValue) {
  minValue = minValue === VOID ? 1 : minValue;
  maxValue = maxValue === VOID ? 2147483647 : maxValue;
  return systemProp_0(propertyName, toLong(defaultValue), toLong(minValue), toLong(maxValue)).j2();
}
function systemProp_0(propertyName, defaultValue, minValue, maxValue) {
  minValue = minValue === VOID ? new Long(1, 0) : minValue;
  maxValue = maxValue === VOID ? new Long(-1, 2147483647) : maxValue;
  var tmp0_elvis_lhs = systemProp_1(propertyName);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return defaultValue;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var value = tmp;
  var tmp1_elvis_lhs = toLongOrNull(value);
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    var message = "System property '" + propertyName + "' has unrecognized value '" + value + "'";
    throw IllegalStateException.h5(toString(message));
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var parsed = tmp_0;
  if (!(minValue.x1(parsed) <= 0 ? parsed.x1(maxValue) <= 0 : false)) {
    // Inline function 'kotlin.error' call
    var message_0 = "System property '" + propertyName + "' should be in range " + minValue.toString() + '..' + maxValue.toString() + ", but is '" + parsed.toString() + "'";
    throw IllegalStateException.h5(toString(message_0));
  }
  return parsed;
}
function startCoroutineCancellable(_this__u8e3s4, receiver, completion) {
  var tmp;
  try {
    var tmp_0 = intercepted(createCoroutineUninterceptedGeneratorVersion(_this__u8e3s4, receiver, completion));
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
    resumeCancellableWith(tmp_0, tmp$ret$0);
    tmp = Unit_instance;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof Error) {
      var e = $p;
      dispatcherFailure$accessor$glj1hg(completion, e);
      tmp_1 = Unit_instance;
    } else {
      throw $p;
    }
    tmp = tmp_1;
  }
  return tmp;
}
function startCoroutineCancellable_0(_this__u8e3s4, fatalCompletion) {
  var tmp;
  try {
    var tmp_0 = intercepted(_this__u8e3s4);
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
    resumeCancellableWith(tmp_0, tmp$ret$0);
    tmp = Unit_instance;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof Error) {
      var e = $p;
      dispatcherFailure$accessor$glj1hg(fatalCompletion, e);
      tmp_1 = Unit_instance;
    } else {
      throw $p;
    }
    tmp = tmp_1;
  }
  return tmp;
}
function dispatcherFailure(completion, e) {
  // Inline function 'kotlin.Companion.failure' call
  var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(e));
  completion.bd(tmp$ret$0);
  throw e;
}
function dispatcherFailure$accessor$glj1hg(completion, e) {
  return dispatcherFailure(completion, e);
}
function startUndispatchedOrReturn(_this__u8e3s4, receiver, block) {
  var tmp$ret$2;
  $l$block_0: {
    // Inline function 'kotlinx.coroutines.intrinsics.undispatchedResult' call
    var tmp;
    try {
      // Inline function 'kotlinx.coroutines.intrinsics.startUndispatchedOrReturn.<anonymous>' call
      // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
      tmp = startCoroutineUninterceptedOrReturnGeneratorVersion(block, receiver, _this__u8e3s4);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        tmp_0 = new CompletedExceptionally(e);
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var result = tmp;
    if (result === get_COROUTINE_SUSPENDED()) {
      tmp$ret$2 = get_COROUTINE_SUSPENDED();
      break $l$block_0;
    }
    var state = _this__u8e3s4.k17(result);
    if (state === get_COMPLETING_WAITING_CHILDREN()) {
      tmp$ret$2 = get_COROUTINE_SUSPENDED();
      break $l$block_0;
    }
    var tmp_1;
    if (state instanceof CompletedExceptionally) {
      var tmp_2;
      // Inline function 'kotlinx.coroutines.intrinsics.startUndispatchedOrReturn.<anonymous>' call
      state.h17_1;
      if (true) {
        throw recoverStackTrace(state.h17_1, _this__u8e3s4.p19_1);
      } else {
        if (result instanceof CompletedExceptionally) {
          throw recoverStackTrace(result.h17_1, _this__u8e3s4.p19_1);
        } else {
          tmp_2 = result;
        }
      }
      tmp_1 = tmp_2;
    } else {
      tmp_1 = unboxState(state);
    }
    tmp$ret$2 = tmp_1;
  }
  return tmp$ret$2;
}
function startCoroutineUndispatched(_this__u8e3s4, receiver, completion) {
  // Inline function 'kotlinx.coroutines.internal.probeCoroutineCreated' call
  var actualCompletion = completion;
  var tmp;
  try {
    // Inline function 'kotlinx.coroutines.withCoroutineContext' call
    actualCompletion.zc();
    // Inline function 'kotlinx.coroutines.intrinsics.startCoroutineUndispatched.<anonymous>' call
    // Inline function 'kotlinx.coroutines.internal.probeCoroutineResumed' call
    // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
    tmp = startCoroutineUninterceptedOrReturnGeneratorVersion(_this__u8e3s4, receiver, actualCompletion);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var tmp$ret$4 = _Result___init__impl__xyqfz8(createFailure(e));
      actualCompletion.bd(tmp$ret$4);
      return Unit_instance;
    } else {
      throw $p;
    }
  }
  var value = tmp;
  if (!(value === get_COROUTINE_SUSPENDED())) {
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var value_0 = (value == null ? true : !(value == null)) ? value : THROW_CCE();
    var tmp$ret$6 = _Result___init__impl__xyqfz8(value_0);
    actualCompletion.bd(tmp$ret$6);
  }
}
function startUndispatchedOrReturnIgnoreTimeout(_this__u8e3s4, receiver, block) {
  var tmp$ret$2;
  $l$block_0: {
    // Inline function 'kotlinx.coroutines.intrinsics.undispatchedResult' call
    var tmp;
    try {
      // Inline function 'kotlinx.coroutines.intrinsics.startUndispatchedOrReturnIgnoreTimeout.<anonymous>' call
      // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
      tmp = startCoroutineUninterceptedOrReturnGeneratorVersion(block, receiver, _this__u8e3s4);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        tmp_0 = new CompletedExceptionally(e);
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var result = tmp;
    if (result === get_COROUTINE_SUSPENDED()) {
      tmp$ret$2 = get_COROUTINE_SUSPENDED();
      break $l$block_0;
    }
    var state = _this__u8e3s4.k17(result);
    if (state === get_COMPLETING_WAITING_CHILDREN()) {
      tmp$ret$2 = get_COROUTINE_SUSPENDED();
      break $l$block_0;
    }
    var tmp_1;
    if (state instanceof CompletedExceptionally) {
      var tmp_2;
      // Inline function 'kotlinx.coroutines.intrinsics.startUndispatchedOrReturnIgnoreTimeout.<anonymous>' call
      var e_0 = state.h17_1;
      var tmp_3;
      if (e_0 instanceof TimeoutCancellationException) {
        tmp_3 = e_0.l1i_1 === _this__u8e3s4;
      } else {
        tmp_3 = false;
      }
      if (!tmp_3) {
        throw recoverStackTrace(state.h17_1, _this__u8e3s4.p19_1);
      } else {
        if (result instanceof CompletedExceptionally) {
          throw recoverStackTrace(result.h17_1, _this__u8e3s4.p19_1);
        } else {
          tmp_2 = result;
        }
      }
      tmp_1 = tmp_2;
    } else {
      tmp_1 = unboxState(state);
    }
    tmp$ret$2 = tmp_1;
  }
  return tmp$ret$2;
}
var DUMMY_PROCESS_RESULT_FUNCTION;
function get_STATE_REG() {
  _init_properties_Select_kt__zhm2jg();
  return STATE_REG;
}
var STATE_REG;
function get_STATE_COMPLETED() {
  _init_properties_Select_kt__zhm2jg();
  return STATE_COMPLETED;
}
var STATE_COMPLETED;
function get_STATE_CANCELLED() {
  _init_properties_Select_kt__zhm2jg();
  return STATE_CANCELLED;
}
var STATE_CANCELLED;
function get_NO_RESULT() {
  _init_properties_Select_kt__zhm2jg();
  return NO_RESULT;
}
var NO_RESULT;
var PARAM_CLAUSE_0;
function trySelectInternal($this, clauseObject, internalResult) {
  $l$loop: while (true) {
    var curState = $this.g1l_1.kotlinx$atomicfu$value;
    if (isInterface(curState, CancellableContinuation)) {
      var tmp0_elvis_lhs = findClause($this, clauseObject);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var clause = tmp;
      var onCancellation = clause.t1n($this, internalResult);
      if ($this.g1l_1.atomicfu$compareAndSet(curState, clause)) {
        var cont = isInterface(curState, CancellableContinuation) ? curState : THROW_CCE();
        $this.i1l_1 = internalResult;
        if (tryResume_1(cont, onCancellation))
          return 0;
        $this.i1l_1 = get_NO_RESULT();
        return 2;
      }
    } else {
      var tmp_0;
      if (equals(curState, get_STATE_COMPLETED())) {
        tmp_0 = true;
      } else {
        tmp_0 = curState instanceof ClauseData;
      }
      if (tmp_0)
        return 3;
      else {
        if (equals(curState, get_STATE_CANCELLED()))
          return 2;
        else {
          if (equals(curState, get_STATE_REG())) {
            if ($this.g1l_1.atomicfu$compareAndSet(curState, listOf_0(clauseObject)))
              return 1;
          } else {
            if (isInterface(curState, KtList)) {
              if ($this.g1l_1.atomicfu$compareAndSet(curState, plus_0(curState, clauseObject)))
                return 1;
            } else {
              var message = 'Unexpected state: ' + toString(curState);
              throw IllegalStateException.h5(toString(message));
            }
          }
        }
      }
    }
  }
}
function findClause($this, clauseObject) {
  var tmp0_elvis_lhs = $this.h1l_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var clauses = tmp;
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var tmp0_iterator = clauses.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'kotlinx.coroutines.selects.SelectImplementation.findClause.<anonymous>' call
      if (element.q1n_1 === clauseObject) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp1_elvis_lhs = tmp$ret$1;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    var message = 'Clause with object ' + toString(clauseObject) + ' is not found';
    throw IllegalStateException.h5(toString(message));
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  return tmp_0;
}
var TrySelectDetailedResult_SUCCESSFUL_instance;
var TrySelectDetailedResult_REREGISTER_instance;
var TrySelectDetailedResult_CANCELLED_instance;
var TrySelectDetailedResult_ALREADY_SELECTED_instance;
var TrySelectDetailedResult_entriesInitialized;
function TrySelectDetailedResult_initEntries() {
  if (TrySelectDetailedResult_entriesInitialized)
    return Unit_instance;
  TrySelectDetailedResult_entriesInitialized = true;
  TrySelectDetailedResult_SUCCESSFUL_instance = new TrySelectDetailedResult('SUCCESSFUL', 0);
  TrySelectDetailedResult_REREGISTER_instance = new TrySelectDetailedResult('REREGISTER', 1);
  TrySelectDetailedResult_CANCELLED_instance = new TrySelectDetailedResult('CANCELLED', 2);
  TrySelectDetailedResult_ALREADY_SELECTED_instance = new TrySelectDetailedResult('ALREADY_SELECTED', 3);
}
function TrySelectDetailedResult_0(trySelectInternalResult) {
  _init_properties_Select_kt__zhm2jg();
  var tmp;
  switch (trySelectInternalResult) {
    case 0:
      tmp = TrySelectDetailedResult_SUCCESSFUL_getInstance();
      break;
    case 1:
      tmp = TrySelectDetailedResult_REREGISTER_getInstance();
      break;
    case 2:
      tmp = TrySelectDetailedResult_CANCELLED_getInstance();
      break;
    case 3:
      tmp = TrySelectDetailedResult_ALREADY_SELECTED_getInstance();
      break;
    default:
      var message = 'Unexpected internal result: ' + trySelectInternalResult;
      throw IllegalStateException.h5(toString(message));
  }
  return tmp;
}
function tryResume_1(_this__u8e3s4, onCancellation) {
  _init_properties_Select_kt__zhm2jg();
  var tmp0_elvis_lhs = _this__u8e3s4.y19(Unit_instance, null, onCancellation);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var token = tmp;
  _this__u8e3s4.z19(token);
  return true;
}
function DUMMY_PROCESS_RESULT_FUNCTION$lambda(_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
  _init_properties_Select_kt__zhm2jg();
  return null;
}
function TrySelectDetailedResult_SUCCESSFUL_getInstance() {
  TrySelectDetailedResult_initEntries();
  return TrySelectDetailedResult_SUCCESSFUL_instance;
}
function TrySelectDetailedResult_REREGISTER_getInstance() {
  TrySelectDetailedResult_initEntries();
  return TrySelectDetailedResult_REREGISTER_instance;
}
function TrySelectDetailedResult_CANCELLED_getInstance() {
  TrySelectDetailedResult_initEntries();
  return TrySelectDetailedResult_CANCELLED_instance;
}
function TrySelectDetailedResult_ALREADY_SELECTED_getInstance() {
  TrySelectDetailedResult_initEntries();
  return TrySelectDetailedResult_ALREADY_SELECTED_instance;
}
var properties_initialized_Select_kt_7rpl36;
function _init_properties_Select_kt__zhm2jg() {
  if (!properties_initialized_Select_kt_7rpl36) {
    properties_initialized_Select_kt_7rpl36 = true;
    DUMMY_PROCESS_RESULT_FUNCTION = DUMMY_PROCESS_RESULT_FUNCTION$lambda;
    STATE_REG = new Symbol('STATE_REG');
    STATE_COMPLETED = new Symbol('STATE_COMPLETED');
    STATE_CANCELLED = new Symbol('STATE_CANCELLED');
    NO_RESULT = new Symbol('NO_RESULT');
    PARAM_CLAUSE_0 = new Symbol('PARAM_CLAUSE_0');
  }
}
function get_NO_OWNER() {
  _init_properties_Mutex_kt__jod56b();
  return NO_OWNER;
}
var NO_OWNER;
var ON_LOCK_ALREADY_LOCKED_BY_OWNER;
function Mutex(locked) {
  locked = locked === VOID ? false : locked;
  _init_properties_Mutex_kt__jod56b();
  return new MutexImpl(locked);
}
function MutexImpl$CancellableContinuationWithOwner$tryResume$lambda(this$0, this$1) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
    this$0.b1o_1.kotlinx$atomicfu$value = this$1.e1o_1;
    this$0.g1o(this$1.e1o_1);
    return Unit_instance;
  };
}
function MutexImpl$CancellableContinuationWithOwner$resume$lambda(this$0, this$1) {
  return function (it) {
    this$0.g1o(this$1.e1o_1);
    return Unit_instance;
  };
}
function holdsLockImpl($this, owner) {
  $l$loop: while (true) {
    if (!$this.h1o())
      return 0;
    var curOwner = $this.b1o_1.kotlinx$atomicfu$value;
    if (curOwner === get_NO_OWNER())
      continue $l$loop;
    return curOwner === owner ? 1 : 2;
  }
}
function *_generator_lock__qllepv($this, owner, $completion) {
  if ($this.i1o(owner))
    return Unit_instance;
  var tmp = lockSuspend($this, owner, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function lockSuspend($this, owner, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutineReusable.<anonymous>' call
  var cancellable = getOrCreateCancellableContinuation(intercepted($completion));
  try {
    // Inline function 'kotlinx.coroutines.sync.MutexImpl.lockSuspend.<anonymous>' call
    var contWithOwner = new CancellableContinuationWithOwner($this, cancellable, owner);
    $this.acquireCont(contWithOwner);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      cancellable.a1c();
      throw e;
    } else {
      throw $p;
    }
  }
  return cancellable.e19();
}
function tryLockImpl($this, owner) {
  $l$loop: while (true) {
    if ($this.q1o()) {
      // Inline function 'kotlinx.coroutines.assert' call
      $this.b1o_1.kotlinx$atomicfu$value = owner;
      return 0;
    } else {
      if (owner == null)
        return 1;
      switch (holdsLockImpl($this, owner)) {
        case 1:
          return 2;
        case 2:
          return 1;
        case 0:
          continue $l$loop;
      }
    }
  }
}
function MutexImpl$onSelectCancellationUnlockConstructor$lambda$lambda(this$0, $owner) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
    this$0.g1o($owner);
    return Unit_instance;
  };
}
function MutexImpl$onSelectCancellationUnlockConstructor$lambda(this$0) {
  return function (_unused_var__etf5q3, owner, _unused_var__etf5q3_0) {
    return MutexImpl$onSelectCancellationUnlockConstructor$lambda$lambda(this$0, owner);
  };
}
var properties_initialized_Mutex_kt_yv4p3j;
function _init_properties_Mutex_kt__jod56b() {
  if (!properties_initialized_Mutex_kt_yv4p3j) {
    properties_initialized_Mutex_kt_yv4p3j = true;
    NO_OWNER = new Symbol('NO_OWNER');
    ON_LOCK_ALREADY_LOCKED_BY_OWNER = new Symbol('ALREADY_LOCKED_BY_OWNER');
  }
}
function get_MAX_SPIN_CYCLES() {
  _init_properties_Semaphore_kt__t514r6();
  return MAX_SPIN_CYCLES;
}
var MAX_SPIN_CYCLES;
function get_PERMIT() {
  _init_properties_Semaphore_kt__t514r6();
  return PERMIT;
}
var PERMIT;
function get_TAKEN() {
  _init_properties_Semaphore_kt__t514r6();
  return TAKEN;
}
var TAKEN;
function get_BROKEN() {
  _init_properties_Semaphore_kt__t514r6();
  return BROKEN;
}
var BROKEN;
function get_CANCELLED() {
  _init_properties_Semaphore_kt__t514r6();
  return CANCELLED;
}
var CANCELLED;
function get_SEGMENT_SIZE_0() {
  _init_properties_Semaphore_kt__t514r6();
  return SEGMENT_SIZE_0;
}
var SEGMENT_SIZE_0;
function decPermits($this) {
  $l$loop: while (true) {
    var p = $this.o1o_1.atomicfu$getAndDecrement();
    if (p > $this.j1o_1)
      continue $l$loop;
    return p;
  }
}
function coerceAvailablePermitsAtMaximum($this) {
  $l$loop_0: while (true) {
    var cur = $this.o1o_1.kotlinx$atomicfu$value;
    if (cur <= $this.j1o_1)
      break $l$loop_0;
    if ($this.o1o_1.atomicfu$compareAndSet(cur, $this.j1o_1))
      break $l$loop_0;
  }
}
function addAcquireToQueue($this, waiter) {
  var curTail = $this.m1o_1.kotlinx$atomicfu$value;
  var enqIdx = $this.n1o_1.atomicfu$getAndIncrement$long();
  var createNewSegment = createSegment$ref_0();
  var tmp$ret$2;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    var this_0 = $this.m1o_1;
    // Inline function 'kotlin.Long.div' call
    var other = get_SEGMENT_SIZE_0();
    var id = enqIdx.a4(toLong(other));
    while (true) {
      var s = findSegmentInternal(curTail, id, createNewSegment);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp$ret$1;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          var to = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
          while (true) {
            // Inline function 'kotlinx.coroutines.internal.moveForward.<anonymous>' call
            var cur = this_0.kotlinx$atomicfu$value;
            if (cur.a1b_1.x1(to.a1b_1) >= 0) {
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (!to.g1k()) {
              tmp$ret$1 = false;
              break $l$block_1;
            }
            if (this_0.atomicfu$compareAndSet(cur, to)) {
              if (cur.h1k()) {
                cur.r6();
              }
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (to.h1k()) {
              to.r6();
            }
          }
          tmp$ret$1 = Unit_instance;
        }
        tmp = tmp$ret$1;
      }
      if (tmp) {
        tmp$ret$2 = s;
        break $l$block_2;
      }
    }
  }
  var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(tmp$ret$2);
  // Inline function 'kotlin.Long.rem' call
  var other_0 = get_SEGMENT_SIZE_0();
  var i = enqIdx.b4(toLong(other_0)).j2();
  // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.cas' call
  if (segment.b1p_1.atomicfu$get(i).atomicfu$compareAndSet(null, waiter)) {
    waiter.g1c(segment, i);
    return true;
  }
  // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.cas' call
  var expected = get_PERMIT();
  var value = get_TAKEN();
  if (segment.b1p_1.atomicfu$get(i).atomicfu$compareAndSet(expected, value)) {
    if (isInterface(waiter, CancellableContinuation)) {
      if (!isInterface(waiter, CancellableContinuation))
        THROW_CCE();
      waiter.c1a(Unit_instance, $this.p1o_1);
    } else {
      if (isInterface(waiter, SelectInstance)) {
        waiter.p1n(Unit_instance);
      } else {
        var message = 'unexpected: ' + toString(waiter);
        throw IllegalStateException.h5(toString(message));
      }
    }
    return true;
  }
  // Inline function 'kotlinx.coroutines.assert' call
  return false;
}
function tryResumeNextFromQueue($this) {
  var curHead = $this.k1o_1.kotlinx$atomicfu$value;
  var deqIdx = $this.l1o_1.atomicfu$getAndIncrement$long();
  // Inline function 'kotlin.Long.div' call
  var other = get_SEGMENT_SIZE_0();
  var id = deqIdx.a4(toLong(other));
  var createNewSegment = createSegment$ref_1();
  var tmp$ret$2;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    var this_0 = $this.k1o_1;
    while (true) {
      var s = findSegmentInternal(curHead, id, createNewSegment);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp$ret$1;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          var to = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
          while (true) {
            // Inline function 'kotlinx.coroutines.internal.moveForward.<anonymous>' call
            var cur = this_0.kotlinx$atomicfu$value;
            if (cur.a1b_1.x1(to.a1b_1) >= 0) {
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (!to.g1k()) {
              tmp$ret$1 = false;
              break $l$block_1;
            }
            if (this_0.atomicfu$compareAndSet(cur, to)) {
              if (cur.h1k()) {
                cur.r6();
              }
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (to.h1k()) {
              to.r6();
            }
          }
          tmp$ret$1 = Unit_instance;
        }
        tmp = tmp$ret$1;
      }
      if (tmp) {
        tmp$ret$2 = s;
        break $l$block_2;
      }
    }
  }
  var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(tmp$ret$2);
  segment.o1k();
  if (segment.a1b_1.x1(id) > 0)
    return false;
  // Inline function 'kotlin.Long.rem' call
  var other_0 = get_SEGMENT_SIZE_0();
  var i = deqIdx.b4(toLong(other_0)).j2();
  // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.getAndSet' call
  var value = get_PERMIT();
  var cellState = segment.b1p_1.atomicfu$get(i).atomicfu$getAndSet(value);
  if (cellState === null) {
    // Inline function 'kotlin.repeat' call
    var times = get_MAX_SPIN_CYCLES();
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.coroutines.sync.SemaphoreAndMutexImpl.tryResumeNextFromQueue.<anonymous>' call
        // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.get' call
        if (segment.b1p_1.atomicfu$get(i).kotlinx$atomicfu$value === get_TAKEN())
          return true;
      }
       while (inductionVariable < times);
    // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.cas' call
    var expected = get_PERMIT();
    var value_0 = get_BROKEN();
    return !segment.b1p_1.atomicfu$get(i).atomicfu$compareAndSet(expected, value_0);
  } else if (cellState === get_CANCELLED())
    return false;
  else
    return tryResumeAcquire(cellState, $this);
}
function tryResumeAcquire(_this__u8e3s4, $this) {
  var tmp;
  if (isInterface(_this__u8e3s4, CancellableContinuation)) {
    if (!isInterface(_this__u8e3s4, CancellableContinuation))
      THROW_CCE();
    var token = _this__u8e3s4.y19(Unit_instance, null, $this.p1o_1);
    var tmp_0;
    if (!(token == null)) {
      _this__u8e3s4.z19(token);
      tmp_0 = true;
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    if (isInterface(_this__u8e3s4, SelectInstance)) {
      tmp = _this__u8e3s4.b1l($this, Unit_instance);
    } else {
      var message = 'unexpected: ' + toString(_this__u8e3s4);
      throw IllegalStateException.h5(toString(message));
    }
  }
  return tmp;
}
function SemaphoreAndMutexImpl$onCancellationRelease$lambda(this$0) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
    this$0.w1o();
    return Unit_instance;
  };
}
function createSegment$ref_0() {
  var l = function (p0, p1) {
    return createSegment_0(p0, p1);
  };
  l.callableName = 'createSegment';
  return l;
}
function createSegment$ref_1() {
  var l = function (p0, p1) {
    return createSegment_0(p0, p1);
  };
  l.callableName = 'createSegment';
  return l;
}
function createSegment_0(id, prev) {
  _init_properties_Semaphore_kt__t514r6();
  return new SemaphoreSegment(id, prev, 0);
}
var properties_initialized_Semaphore_kt_uqcwok;
function _init_properties_Semaphore_kt__t514r6() {
  if (!properties_initialized_Semaphore_kt_uqcwok) {
    properties_initialized_Semaphore_kt_uqcwok = true;
    MAX_SPIN_CYCLES = systemProp('kotlinx.coroutines.semaphore.maxSpinCycles', 100);
    PERMIT = new Symbol('PERMIT');
    TAKEN = new Symbol('TAKEN');
    BROKEN = new Symbol('BROKEN');
    CANCELLED = new Symbol('CANCELLED');
    SEGMENT_SIZE_0 = systemProp('kotlinx.coroutines.semaphore.segmentSize', 16);
  }
}
function createDefaultDispatcher() {
  var tmp;
  if (isJsdom()) {
    tmp = NodeDispatcher_getInstance();
  } else {
    var tmp_0;
    var tmp_1;
    if (!(typeof window === 'undefined')) {
      // Inline function 'kotlin.js.asDynamic' call
      tmp_1 = window != null;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      // Inline function 'kotlin.js.asDynamic' call
      tmp_0 = !(typeof window.addEventListener === 'undefined');
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = asCoroutineDispatcher(window);
    } else {
      if (typeof process === 'undefined' || typeof process.nextTick === 'undefined') {
        tmp = SetTimeoutDispatcher_getInstance();
      } else {
        tmp = NodeDispatcher_getInstance();
      }
    }
  }
  return tmp;
}
function isJsdom() {
  return !(typeof navigator === 'undefined') && navigator != null && navigator.userAgent != null && !(typeof navigator.userAgent === 'undefined') && !(typeof navigator.userAgent.match === 'undefined') && navigator.userAgent.match('\\bjsdom\\b');
}
var counter;
function get_DEBUG() {
  return DEBUG;
}
var DEBUG;
function get_classSimpleName(_this__u8e3s4) {
  var tmp0_elvis_lhs = getKClassFromExpression(_this__u8e3s4).gf();
  return tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs;
}
function get_hexAddress(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  var result = _this__u8e3s4.__debug_counter;
  if (!(typeof result === 'number')) {
    counter = counter + 1 | 0;
    result = counter;
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.__debug_counter = result;
  }
  return ((!(result == null) ? typeof result === 'number' : false) ? result : THROW_CCE()).toString();
}
var NodeDispatcher_instance;
function NodeDispatcher_getInstance() {
  if (NodeDispatcher_instance === VOID)
    NodeDispatcher.e1p();
  return NodeDispatcher_instance;
}
function ScheduledMessageQueue$processQueue$lambda(this$0) {
  return function () {
    this$0.r1p();
    return Unit_instance;
  };
}
function w3cSetTimeout(handler, timeout) {
  return setTimeout(handler, timeout);
}
function WindowMessageQueue$lambda(this$0) {
  return function (event) {
    var tmp;
    if (event.source == this$0.h1q_1 && event.data == this$0.i1q_1) {
      event.stopPropagation();
      this$0.r1p();
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function WindowMessageQueue$schedule$lambda(this$0) {
  return function (it) {
    this$0.r1p();
    return Unit_instance;
  };
}
function w3cSetTimeout_0(window_0, handler, timeout) {
  return setTimeout_0(window_0, handler, timeout);
}
function w3cClearTimeout(window_0, handle) {
  return window_0.clearTimeout(handle);
}
function w3cClearTimeout_0(handle) {
  return clearTimeout(handle);
}
function setTimeout_0(window_0, handler, timeout) {
  return window_0.setTimeout(handler, timeout);
}
function await_0(_this__u8e3s4, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.s1b();
  // Inline function 'kotlinx.coroutines.await.<anonymous>' call
  var tmp = await$lambda(cancellable);
  _this__u8e3s4.then(tmp, await$lambda_0(cancellable));
  return cancellable.e19();
}
function asDeferred(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  var deferred = _this__u8e3s4.deferred;
  var tmp;
  if (deferred == null) {
    var tmp_0 = GlobalScope_instance;
    var tmp_1 = CoroutineStart_UNDISPATCHED_getInstance();
    tmp = async(tmp_0, VOID, tmp_1, asDeferred$slambda_0(_this__u8e3s4));
  } else {
    tmp = deferred;
  }
  return tmp;
}
function await$lambda($cont) {
  return function (it) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $cont;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(it);
    this_0.bd(tmp$ret$0);
    return Unit_instance;
  };
}
function await$lambda_0($cont) {
  return function (it) {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    var this_0 = $cont;
    // Inline function 'kotlin.Companion.failure' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(it));
    this_0.bd(tmp$ret$0);
    return Unit_instance;
  };
}
function asDeferred$slambda_0($this_asDeferred) {
  var i = new asDeferred$slambda($this_asDeferred);
  var l = function ($this$async, $completion) {
    return i.k1q($this$async, $completion);
  };
  l.$arity = 1;
  return l;
}
function asCoroutineDispatcher(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  var tmp0_elvis_lhs = _this__u8e3s4.coroutineDispatcher;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    var this_0 = WindowDispatcher.o1q(_this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.asCoroutineDispatcher.<anonymous>' call
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.coroutineDispatcher = this_0;
    tmp = this_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function propagateExceptionFinalResort(exception) {
  console.error(exception.toString());
}
function createEventLoop() {
  return UnconfinedEventLoop.t1q();
}
function unsupported() {
  throw UnsupportedOperationException.la('runBlocking event loop is not supported');
}
var SetTimeoutDispatcher_instance;
function SetTimeoutDispatcher_getInstance() {
  if (SetTimeoutDispatcher_instance === VOID)
    SetTimeoutDispatcher.w1q();
  return SetTimeoutDispatcher_instance;
}
function SetTimeoutBasedDispatcher$invokeOnTimeout$lambda($block) {
  return function () {
    $block.n1c();
    return Unit_instance;
  };
}
function SetTimeoutBasedDispatcher$scheduleResumeAfterDelay$lambda($continuation, this$0) {
  return function () {
    // Inline function 'kotlin.with' call
    // Inline function 'kotlin.contracts.contract' call
    $continuation.b1a(this$0, Unit_instance);
    return Unit_instance;
  };
}
function WindowDispatcher$scheduleResumeAfterDelay$lambda($continuation, this$0) {
  return function () {
    // Inline function 'kotlin.with' call
    // Inline function 'kotlin.contracts.contract' call
    $continuation.b1a(this$0, Unit_instance);
    return Unit_instance;
  };
}
function Runnable$run$ref($boundThis) {
  var l = function () {
    $boundThis.n1c();
    return Unit_instance;
  };
  l.callableName = 'run';
  return l;
}
function delayToInt(timeMillis) {
  return coerceIn(timeMillis, new Long(0, 0), new Long(2147483647, 0)).j2();
}
function toDebugString(_this__u8e3s4) {
  return toString(_this__u8e3s4);
}
function get_DefaultDelay() {
  var tmp = Dispatchers_getInstance().y1d_1;
  return isInterface(tmp, Delay) ? tmp : THROW_CCE();
}
function newCoroutineContext(_this__u8e3s4, context) {
  var combined = _this__u8e3s4.b17().cn(context);
  return !(combined === Dispatchers_getInstance().y1d_1) && combined.md(Key_instance) == null ? combined.cn(Dispatchers_getInstance().y1d_1) : combined;
}
function newCoroutineContext_0(_this__u8e3s4, addedContext) {
  return _this__u8e3s4.cn(addedContext);
}
function get_coroutineName(_this__u8e3s4) {
  return null;
}
var Dispatchers_instance;
function Dispatchers_getInstance() {
  if (Dispatchers_instance === VOID)
    new Dispatchers();
  return Dispatchers_instance;
}
function identitySet(expectedSize) {
  return HashSet.ta(expectedSize);
}
function get_platformExceptionHandlers_() {
  _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf();
  return platformExceptionHandlers_;
}
var platformExceptionHandlers_;
function get_platformExceptionHandlers() {
  _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf();
  return get_platformExceptionHandlers_();
}
var properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx;
function _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf() {
  if (!properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx) {
    properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx = true;
    // Inline function 'kotlin.collections.mutableSetOf' call
    platformExceptionHandlers_ = LinkedHashSet.i1();
  }
}
function unwrap(exception) {
  return exception;
}
function recoverStackTrace(exception, continuation) {
  return exception;
}
function recoverStackTrace_0(exception) {
  return exception;
}
function systemProp_1(propertyName) {
  return null;
}
function threadContextElements(context) {
  return 0;
}
function commonThreadLocal(name) {
  return new CommonThreadLocal();
}
//region block: post-declaration
initMetadataForInterface(Job, 'Job', VOID, VOID, [Element], [0]);
initMetadataForInterface(ParentJob, 'ParentJob', VOID, VOID, [Job], [0]);
protoOf(JobSupport).j18 = cancel$default;
protoOf(JobSupport).cn = plus;
protoOf(JobSupport).md = get_0;
protoOf(JobSupport).bn = fold;
protoOf(JobSupport).an = minusKey_0;
initMetadataForClass(JobSupport, 'JobSupport', VOID, VOID, [Job, ParentJob], [0]);
initMetadataForInterface(CoroutineScope, 'CoroutineScope');
initMetadataForClass(AbstractCoroutine, 'AbstractCoroutine', VOID, VOID, [JobSupport, Job, CoroutineScope], [0]);
initMetadataForClass(StandaloneCoroutine, 'StandaloneCoroutine', VOID, VOID, VOID, [0]);
initMetadataForClass(LazyStandaloneCoroutine, 'LazyStandaloneCoroutine', VOID, VOID, VOID, [0]);
initMetadataForClass(ScopeCoroutine, 'ScopeCoroutine', VOID, VOID, VOID, [0]);
initMetadataForClass(DispatchedCoroutine, 'DispatchedCoroutine', VOID, VOID, VOID, [0]);
initMetadataForInterface(Deferred, 'Deferred', VOID, VOID, [Job], [0]);
initMetadataForClass(DeferredCoroutine, 'DeferredCoroutine', VOID, VOID, [AbstractCoroutine, Deferred], [0]);
initMetadataForClass(LazyDeferredCoroutine, 'LazyDeferredCoroutine', VOID, VOID, VOID, [0]);
initMetadataForInterface(CancellableContinuation, 'CancellableContinuation');
initMetadataForInterface(NotCompleted, 'NotCompleted');
initMetadataForInterface(CancelHandler, 'CancelHandler', VOID, VOID, [NotCompleted]);
initMetadataForClass(DisposeOnCancel, 'DisposeOnCancel', VOID, VOID, [CancelHandler]);
initMetadataForInterface(Runnable, 'Runnable');
initMetadataForClass(SchedulerTask, 'SchedulerTask', VOID, VOID, [Runnable]);
initMetadataForClass(DispatchedTask, 'DispatchedTask');
initMetadataForInterface(Waiter, 'Waiter');
initMetadataForClass(CancellableContinuationImpl, 'CancellableContinuationImpl', VOID, VOID, [DispatchedTask, CancellableContinuation, Waiter]);
initMetadataForClass(UserSupplied, 'UserSupplied', VOID, VOID, [CancelHandler]);
initMetadataForObject(Active, 'Active', VOID, VOID, [NotCompleted]);
initMetadataForClass(CompletedContinuation, 'CompletedContinuation');
initMetadataForClass(LockFreeLinkedListNode, 'LockFreeLinkedListNode', LockFreeLinkedListNode);
initMetadataForInterface(DisposableHandle, 'DisposableHandle');
initMetadataForInterface(Incomplete, 'Incomplete');
initMetadataForClass(JobNode, 'JobNode', VOID, VOID, [LockFreeLinkedListNode, DisposableHandle, Incomplete]);
initMetadataForClass(ChildContinuation, 'ChildContinuation');
initMetadataForClass(CompletableDeferredImpl, 'CompletableDeferredImpl', VOID, VOID, [JobSupport, Deferred], [0]);
initMetadataForClass(CompletedExceptionally, 'CompletedExceptionally');
initMetadataForClass(CancelledContinuation, 'CancelledContinuation');
initMetadataForObject(Key, 'Key');
protoOf(CoroutineDispatcher).md = get;
protoOf(CoroutineDispatcher).an = minusKey;
initMetadataForClass(CoroutineDispatcher, 'CoroutineDispatcher', VOID, VOID, [AbstractCoroutineContextElement, ContinuationInterceptor]);
initMetadataForObject(Key_0, 'Key');
initMetadataForObject(Key_1, 'Key');
initMetadataForClass(CoroutineName, 'CoroutineName');
initMetadataForObject(GlobalScope, 'GlobalScope', VOID, VOID, [CoroutineScope]);
initMetadataForClass(CoroutineStart, 'CoroutineStart');
initMetadataForInterface(Delay, 'Delay', VOID, VOID, VOID, [1]);
initMetadataForInterface(DelayWithTimeoutDiagnostics, 'DelayWithTimeoutDiagnostics', VOID, VOID, [Delay], [1]);
initMetadataForClass(EventLoop, 'EventLoop');
initMetadataForObject(ThreadLocalEventLoop, 'ThreadLocalEventLoop');
initMetadataForClass(CompletionHandlerException, 'CompletionHandlerException');
initMetadataForClass(CoroutinesInternalError, 'CoroutinesInternalError');
initMetadataForObject(Key_2, 'Key');
initMetadataForObject(NonDisposableHandle, 'NonDisposableHandle', VOID, VOID, [DisposableHandle]);
initMetadataForClass(DisposeOnCompletion, 'DisposeOnCompletion');
initMetadataForClass(Empty, 'Empty', VOID, VOID, [Incomplete]);
initMetadataForClass(LockFreeLinkedListHead, 'LockFreeLinkedListHead', LockFreeLinkedListHead);
initMetadataForClass(NodeList, 'NodeList', NodeList, VOID, [LockFreeLinkedListHead, Incomplete]);
initMetadataForClass(SynchronizedObject, 'SynchronizedObject', SynchronizedObject);
initMetadataForClass(Finishing, 'Finishing', VOID, VOID, [SynchronizedObject, Incomplete]);
initMetadataForClass(ChildCompletion, 'ChildCompletion');
initMetadataForClass(AwaitContinuation, 'AwaitContinuation');
initMetadataForLambda(JobSupport$_get_children_$slambda_k839f8, VOID, VOID, [1]);
initMetadataForClass(InactiveNodeList, 'InactiveNodeList', VOID, VOID, [Incomplete]);
initMetadataForClass(InvokeOnCompletion, 'InvokeOnCompletion');
initMetadataForClass(InvokeOnCancelling, 'InvokeOnCancelling');
initMetadataForClass(ResumeOnCompletion, 'ResumeOnCompletion');
initMetadataForClass(ChildHandleNode, 'ChildHandleNode', VOID, VOID, [JobNode, DisposableHandle]);
initMetadataForClass(ResumeAwaitOnCompletion, 'ResumeAwaitOnCompletion');
initMetadataForClass(IncompleteStateBox, 'IncompleteStateBox');
initMetadataForClass(JobImpl, 'JobImpl', VOID, VOID, [JobSupport, Job], [0]);
initMetadataForClass(MainCoroutineDispatcher, 'MainCoroutineDispatcher');
initMetadataForClass(SupervisorJobImpl, 'SupervisorJobImpl', VOID, VOID, VOID, [0]);
initMetadataForClass(TimeoutCancellationException, 'TimeoutCancellationException');
initMetadataForClass(TimeoutCoroutine, 'TimeoutCoroutine', VOID, VOID, [ScopeCoroutine, Runnable], [0]);
initMetadataForObject(Unconfined, 'Unconfined');
initMetadataForObject(Key_3, 'Key');
initMetadataForClass(YieldContext, 'YieldContext', YieldContext.y1i);
initMetadataForClass(BufferOverflow, 'BufferOverflow');
initMetadataForClass(ConcurrentLinkedListNode, 'ConcurrentLinkedListNode');
initMetadataForClass(Segment, 'Segment', VOID, VOID, [ConcurrentLinkedListNode, NotCompleted]);
initMetadataForClass(ChannelSegment, 'ChannelSegment');
initMetadataForClass(SendBroadcast, 'SendBroadcast', VOID, VOID, [Waiter]);
initMetadataForClass(BufferedChannelIterator, 'BufferedChannelIterator', VOID, VOID, [Waiter], [0, 3]);
initMetadataForClass(BufferedChannel, 'BufferedChannel', VOID, VOID, VOID, [1, 4, 0, 3]);
initMetadataForClass(WaiterEB, 'WaiterEB');
initMetadataForClass(ReceiveCatching, 'ReceiveCatching', VOID, VOID, [Waiter]);
initMetadataForObject(Factory, 'Factory');
initMetadataForClass(Failed, 'Failed', Failed);
initMetadataForClass(Closed, 'Closed');
initMetadataForCompanion(Companion);
initMetadataForClass(ChannelResult, 'ChannelResult');
initMetadataForClass(ClosedSendChannelException, 'ClosedSendChannelException');
initMetadataForClass(ClosedReceiveChannelException, 'ClosedReceiveChannelException');
initMetadataForClass(ConflatedBufferedChannel, 'ConflatedBufferedChannel', VOID, VOID, VOID, [1, 0]);
initMetadataForClass(SegmentOrClosed, 'SegmentOrClosed');
initMetadataForObject(ExceptionSuccessfullyProcessed, 'ExceptionSuccessfullyProcessed');
initMetadataForClass(DispatchedContinuation, 'DispatchedContinuation');
initMetadataForClass(UndeliveredElementException, 'UndeliveredElementException');
initMetadataForClass(ContextScope, 'ContextScope', VOID, VOID, [CoroutineScope]);
initMetadataForClass(Symbol, 'Symbol');
initMetadataForInterface(SelectInstance, 'SelectInstance');
initMetadataForClass(ClauseData, 'ClauseData', VOID, VOID, VOID, [1]);
initMetadataForClass(SelectImplementation, 'SelectImplementation', VOID, VOID, [CancelHandler, SelectInstance, Waiter], [0, 2]);
initMetadataForClass(TrySelectDetailedResult, 'TrySelectDetailedResult');
initMetadataForClass(CancellableContinuationWithOwner, 'CancellableContinuationWithOwner', VOID, VOID, [CancellableContinuation, Waiter]);
initMetadataForClass(SemaphoreAndMutexImpl, 'SemaphoreAndMutexImpl', VOID, VOID, VOID, [0]);
initMetadataForClass(MutexImpl, 'MutexImpl', VOID, VOID, VOID, [1, 0]);
initMetadataForClass(SemaphoreSegment, 'SemaphoreSegment');
initMetadataForClass(SetTimeoutBasedDispatcher, 'SetTimeoutBasedDispatcher', VOID, VOID, [CoroutineDispatcher, Delay], [1]);
initMetadataForObject(NodeDispatcher, 'NodeDispatcher', VOID, VOID, VOID, [1]);
initMetadataForClass(MessageQueue, 'MessageQueue', VOID, VOID, [KtMutableList]);
initMetadataForClass(ScheduledMessageQueue, 'ScheduledMessageQueue');
initMetadataForClass(WindowMessageQueue, 'WindowMessageQueue');
initMetadataForLambda(asDeferred$slambda, VOID, VOID, [1]);
initMetadataForClass(UnconfinedEventLoop, 'UnconfinedEventLoop', UnconfinedEventLoop.t1q);
initMetadataForObject(SetTimeoutDispatcher, 'SetTimeoutDispatcher', VOID, VOID, VOID, [1]);
initMetadataForClass(ClearTimeout, 'ClearTimeout', VOID, VOID, [CancelHandler, DisposableHandle]);
initMetadataForClass(WindowClearTimeout, 'WindowClearTimeout');
initMetadataForClass(WindowDispatcher, 'WindowDispatcher', VOID, VOID, [CoroutineDispatcher, Delay], [1]);
initMetadataForClass(UndispatchedCoroutine, 'UndispatchedCoroutine', VOID, VOID, VOID, [0]);
initMetadataForObject(Dispatchers, 'Dispatchers');
initMetadataForClass(JsMainDispatcher, 'JsMainDispatcher');
initMetadataForClass(JobCancellationException, 'JobCancellationException');
initMetadataForClass(DiagnosticCoroutineContextException, 'DiagnosticCoroutineContextException');
initMetadataForClass(ListClosed, 'ListClosed');
initMetadataForClass(CommonThreadLocal, 'CommonThreadLocal', CommonThreadLocal);
//endregion
//region block: init
Active_instance = new Active();
Key_instance_1 = new Key_0();
Key_instance_2 = new Key_1();
GlobalScope_instance = new GlobalScope();
Key_instance_3 = new Key_2();
NonDisposableHandle_instance = new NonDisposableHandle();
Key_instance_4 = new Key_3();
counter = 0;
DEBUG = false;
//endregion
//region block: exports
export {
  CoroutineStart_UNDISPATCHED_getInstance as CoroutineStart_UNDISPATCHED_getInstance36t7e2kqqnuqp,
  await_0 as await24mygle6x7vn5,
  cancelAndJoin as cancelAndJoin2j6ktsickm6hy,
  coroutineScope as coroutineScope1245ljoj2flcu,
  delay as delay1f60wyf8ua1gc,
  delay_0 as delay1blitpytzu6gr,
  withContext as withContext3ioifgw29h7cj,
  withTimeout as withTimeout2wixyx2dhn9kz,
  yield_0 as yield17af0dtgvr9x7,
  Dispatchers_getInstance as Dispatchers_getInstance2xomc0oxzllw9,
  Key_instance_3 as Key_instance2expa55gr45sc,
  Channel as Channel3r72atmcithql,
  Mutex as Mutex16li1l0asjv17,
  CancellableContinuationImpl as CancellableContinuationImpl1cx201opicavg,
  CompletableDeferred as CompletableDeferred2lnqvsbvx74d3,
  CoroutineDispatcher as CoroutineDispatcherizb7p9bijexj,
  CoroutineName as CoroutineName2g5zosw74tf0f,
  CoroutineScope_0 as CoroutineScopelux7s7zphw7e,
  CoroutineScope as CoroutineScopefcb5f5dwqcas,
  Deferred as Deferred6wjx2us769ee,
  invokeOnTimeout as invokeOnTimeout3llts2igdsa63,
  Delay as Delay9umexudtwyie,
  DisposableHandle as DisposableHandle1uzxt8frdchxn,
  MainScope as MainScope1gi1r4abhrtmm,
  SupervisorJob as SupervisorJobythnfxkr3jxc,
  TimeoutCancellationException as TimeoutCancellationException198b5zwr3v3uw,
  asDeferred as asDeferredzhtizu7g12ut,
  async as asyncz02dsa2nb2zt,
  cancelChildren as cancelChildrennwartoz0yn6c,
  cancel as cancel2en0dn4yvpufo,
  completeWith as completeWith2hvdlbg1q1mlx,
  launch as launch1c91vkjzdi9sd,
};
//endregion
